export const map_bejing = {
    "type": "FeatureCollection",
    "features": [{
        "type": "Feature",
        "properties": {
            "adcode": 110101,
            "name": "东城区",
            "center": [116.418757, 39.917544],
            "centroid": [116.416739, 39.912912],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 0,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.387658, 39.96093],
                        [116.389498, 39.96314],
                        [116.40788, 39.962182],
                        [116.407504, 39.973995],
                        [116.411101, 39.97146],
                        [116.411415, 39.964928],
                        [116.414196, 39.962182],
                        [116.424861, 39.962279],
                        [116.429002, 39.957274],
                        [116.429483, 39.950155],
                        [116.436698, 39.949245],
                        [116.435422, 39.952121],
                        [116.442239, 39.9497],
                        [116.440566, 39.945295],
                        [116.446338, 39.946205],
                        [116.443703, 39.936663],
                        [116.443682, 39.928664],
                        [116.434314, 39.92868],
                        [116.434983, 39.913964],
                        [116.436488, 39.902042],
                        [116.448722, 39.903246],
                        [116.446819, 39.900042],
                        [116.447154, 39.894186],
                        [116.450876, 39.894088],
                        [116.450939, 39.890249],
                        [116.444059, 39.890038],
                        [116.445648, 39.879283],
                        [116.44364, 39.87284],
                        [116.442574, 39.87188],
                        [116.423209, 39.872824],
                        [116.413652, 39.871148],
                        [116.41589, 39.863645],
                        [116.41246, 39.858942],
                        [116.406856, 39.859967],
                        [116.3955, 39.858682],
                        [116.394956, 39.862734],
                        [116.387888, 39.867372],
                        [116.380632, 39.866054],
                        [116.38059, 39.871148],
                        [116.399097, 39.872205],
                        [116.397612, 39.898675],
                        [116.396086, 39.89944],
                        [116.395563, 39.907995],
                        [116.392259, 39.907881],
                        [116.392175, 39.92242],
                        [116.399474, 39.923574],
                        [116.396692, 39.928306],
                        [116.396169, 39.94006],
                        [116.394266, 39.940629],
                        [116.393723, 39.957371],
                        [116.38678, 39.957014],
                        [116.387658, 39.96093]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110102,
            "name": "西城区",
            "center": [116.366794, 39.915309],
            "centroid": [116.365684, 39.912236],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 1,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.380903, 39.972712],
                        [116.394099, 39.972858],
                        [116.394162, 39.969397],
                        [116.390084, 39.968406],
                        [116.387658, 39.96093],
                        [116.38678, 39.957014],
                        [116.393723, 39.957371],
                        [116.394266, 39.940629],
                        [116.396169, 39.94006],
                        [116.396692, 39.928306],
                        [116.399474, 39.923574],
                        [116.392175, 39.92242],
                        [116.392259, 39.907881],
                        [116.395563, 39.907995],
                        [116.396086, 39.89944],
                        [116.397612, 39.898675],
                        [116.399097, 39.872205],
                        [116.38059, 39.871148],
                        [116.35058, 39.86869],
                        [116.349472, 39.873588],
                        [116.344286, 39.873653],
                        [116.341567, 39.876159],
                        [116.335273, 39.875183],
                        [116.326636, 39.876859],
                        [116.321345, 39.875004],
                        [116.325799, 39.896789],
                        [116.337301, 39.89739],
                        [116.335356, 39.898448],
                        [116.334645, 39.922664],
                        [116.333056, 39.938565],
                        [116.327953, 39.942369],
                        [116.332889, 39.944092],
                        [116.341442, 39.941979],
                        [116.35171, 39.94375],
                        [116.351814, 39.950854],
                        [116.355265, 39.951796],
                        [116.35698, 39.944466],
                        [116.371974, 39.948594],
                        [116.370384, 39.967902],
                        [116.380401, 39.968178],
                        [116.380903, 39.972712]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110105,
            "name": "朝阳区",
            "center": [116.486409, 39.921489],
            "centroid": [116.513687, 39.951064],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 2,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.595548, 40.01751],
                        [116.60132, 40.013873],
                        [116.61989, 40.011794],
                        [116.628129, 40.007653],
                        [116.625766, 40.003122],
                        [116.63273, 39.999825],
                        [116.637582, 40.002359],
                        [116.642684, 39.996755],
                        [116.643751, 39.989608],
                        [116.640321, 39.990177],
                        [116.639129, 39.986879],
                        [116.63365, 39.986197],
                        [116.634026, 39.981696],
                        [116.639819, 39.982606],
                        [116.641827, 39.969575],
                        [116.643081, 39.952983],
                        [116.645277, 39.945977],
                        [116.632228, 39.950545],
                        [116.630492, 39.946156],
                        [116.633441, 39.940906],
                        [116.629677, 39.938727],
                        [116.6293, 39.931314],
                        [116.624156, 39.929981],
                        [116.630576, 39.921672],
                        [116.620956, 39.923103],
                        [116.623006, 39.913818],
                        [116.620245, 39.90767],
                        [116.623361, 39.904271],
                        [116.621019, 39.898854],
                        [116.61531, 39.895503],
                        [116.615603, 39.889794],
                        [116.627585, 39.890477],
                        [116.628987, 39.881594],
                        [116.624323, 39.881155],
                        [116.62493, 39.87725],
                        [116.619994, 39.868951],
                        [116.626958, 39.860683],
                        [116.613449, 39.850185],
                        [116.604185, 39.850071],
                        [116.604666, 39.846132],
                        [116.608367, 39.846539],
                        [116.601905, 39.840727],
                        [116.60224, 39.831675],
                        [116.598977, 39.831659],
                        [116.599228, 39.825585],
                        [116.59147, 39.826367],
                        [116.591595, 39.823875],
                        [116.583732, 39.824917],
                        [116.587015, 39.828223],
                        [116.577479, 39.827539],
                        [116.577145, 39.830682],
                        [116.569386, 39.833498],
                        [116.558596, 39.834687],
                        [116.543664, 39.835078],
                        [116.542681, 39.830209],
                        [116.533187, 39.832733],
                        [116.538143, 39.828207],
                        [116.534944, 39.82482],
                        [116.525868, 39.826904],
                        [116.525366, 39.829754],
                        [116.516164, 39.829835],
                        [116.510602, 39.827637],
                        [116.510142, 39.821449],
                        [116.502801, 39.819006],
                        [116.505813, 39.817866],
                        [116.498201, 39.8157],
                        [116.495357, 39.818795],
                        [116.485632, 39.816889],
                        [116.485256, 39.81272],
                        [116.474256, 39.809772],
                        [116.468463, 39.814511],
                        [116.462775, 39.815945],
                        [116.452737, 39.823012],
                        [116.443912, 39.82096],
                        [116.44592, 39.826692],
                        [116.436677, 39.827425],
                        [116.43699, 39.830649],
                        [116.430068, 39.830112],
                        [116.425217, 39.831903],
                        [116.432055, 39.832929],
                        [116.436739, 39.841329],
                        [116.440587, 39.839653],
                        [116.442323, 39.843674],
                        [116.446694, 39.84426],
                        [116.445983, 39.848329],
                        [116.450479, 39.848704],
                        [116.451148, 39.852008],
                        [116.460308, 39.848622],
                        [116.467794, 39.856012],
                        [116.463319, 39.856224],
                        [116.456062, 39.86122],
                        [116.454222, 39.859381],
                        [116.448178, 39.863645],
                        [116.446359, 39.860862],
                        [116.442971, 39.866087],
                        [116.44364, 39.87284],
                        [116.445648, 39.879283],
                        [116.444059, 39.890038],
                        [116.450939, 39.890249],
                        [116.450876, 39.894088],
                        [116.447154, 39.894186],
                        [116.446819, 39.900042],
                        [116.448722, 39.903246],
                        [116.436488, 39.902042],
                        [116.434983, 39.913964],
                        [116.434314, 39.92868],
                        [116.443682, 39.928664],
                        [116.443703, 39.936663],
                        [116.446338, 39.946205],
                        [116.440566, 39.945295],
                        [116.442239, 39.9497],
                        [116.435422, 39.952121],
                        [116.436698, 39.949245],
                        [116.429483, 39.950155],
                        [116.429002, 39.957274],
                        [116.424861, 39.962279],
                        [116.414196, 39.962182],
                        [116.411415, 39.964928],
                        [116.411101, 39.97146],
                        [116.407504, 39.973995],
                        [116.40788, 39.962182],
                        [116.389498, 39.96314],
                        [116.387658, 39.96093],
                        [116.390084, 39.968406],
                        [116.394162, 39.969397],
                        [116.394099, 39.972858],
                        [116.380903, 39.972712],
                        [116.381196, 39.977976],
                        [116.376554, 39.992971],
                        [116.350873, 40.0267],
                        [116.378708, 40.031181],
                        [116.395103, 40.032854],
                        [116.390251, 40.036587],
                        [116.390649, 40.041279],
                        [116.39297, 40.041733],
                        [116.395333, 40.036766],
                        [116.405266, 40.038974],
                        [116.408884, 40.043291],
                        [116.406124, 40.049768],
                        [116.409595, 40.055626],
                        [116.415618, 40.056],
                        [116.433268, 40.06228],
                        [116.442867, 40.061323],
                        [116.451629, 40.058759],
                        [116.45142, 40.06129],
                        [116.459408, 40.059992],
                        [116.462127, 40.06731],
                        [116.458635, 40.070377],
                        [116.458823, 40.075796],
                        [116.462608, 40.076786],
                        [116.461855, 40.080825],
                        [116.466247, 40.08235],
                        [116.466832, 40.090185],
                        [116.471015, 40.08939],
                        [116.473545, 40.085562],
                        [116.482935, 40.083745],
                        [116.486657, 40.081036],
                        [116.49933, 40.080387],
                        [116.506775, 40.074352],
                        [116.513948, 40.070426],
                        [116.525993, 40.071334],
                        [116.534379, 40.066791],
                        [116.543183, 40.059408],
                        [116.547784, 40.062718],
                        [116.551757, 40.059765],
                        [116.552761, 40.05488],
                        [116.54655, 40.048956],
                        [116.550753, 40.045499],
                        [116.564242, 40.039655],
                        [116.570474, 40.032431],
                        [116.578797, 40.033097],
                        [116.577814, 40.027512],
                        [116.595548, 40.01751]
                    ]
                ],
                [
                    [
                        [116.603683, 40.052949],
                        [116.598517, 40.052543],
                        [116.601633, 40.047658],
                        [116.599417, 40.047171],
                        [116.599814, 40.041408],
                        [116.590006, 40.043616],
                        [116.591198, 40.051796],
                        [116.587957, 40.05053],
                        [116.590131, 40.056162],
                        [116.586597, 40.074336],
                        [116.58139, 40.073817],
                        [116.581411, 40.067846],
                        [116.578149, 40.076461],
                        [116.574322, 40.096138],
                        [116.574071, 40.107815],
                        [116.578316, 40.102739],
                        [116.580365, 40.088352],
                        [116.595903, 40.090218],
                        [116.598705, 40.09351],
                        [116.598392, 40.103874],
                        [116.602909, 40.093883],
                        [116.603473, 40.086811],
                        [116.608409, 40.054912],
                        [116.603683, 40.052949]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110106,
            "name": "丰台区",
            "center": [116.286968, 39.863642],
            "centroid": [116.250298, 39.83569],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 3,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.167033, 39.888752],
                        [116.179099, 39.882684],
                        [116.19035, 39.881529],
                        [116.199426, 39.883286],
                        [116.20457, 39.879885],
                        [116.208126, 39.874125],
                        [116.212099, 39.874679],
                        [116.210907, 39.878079],
                        [116.219105, 39.876713],
                        [116.219523, 39.881334],
                        [116.222952, 39.883986],
                        [116.22772, 39.883839],
                        [116.227783, 39.889078],
                        [116.234642, 39.88955],
                        [116.233534, 39.89212],
                        [116.252899, 39.896382],
                        [116.259089, 39.896658],
                        [116.266199, 39.896252],
                        [116.294975, 39.896496],
                        [116.294995, 39.886735],
                        [116.29922, 39.889566],
                        [116.30656, 39.890883],
                        [116.30449, 39.892478],
                        [116.313189, 39.896772],
                        [116.325799, 39.896789],
                        [116.321345, 39.875004],
                        [116.326636, 39.876859],
                        [116.335273, 39.875183],
                        [116.341567, 39.876159],
                        [116.344286, 39.873653],
                        [116.349472, 39.873588],
                        [116.35058, 39.86869],
                        [116.38059, 39.871148],
                        [116.380632, 39.866054],
                        [116.387888, 39.867372],
                        [116.394956, 39.862734],
                        [116.3955, 39.858682],
                        [116.406856, 39.859967],
                        [116.41246, 39.858942],
                        [116.41589, 39.863645],
                        [116.413652, 39.871148],
                        [116.423209, 39.872824],
                        [116.442574, 39.87188],
                        [116.44364, 39.87284],
                        [116.442971, 39.866087],
                        [116.446359, 39.860862],
                        [116.448178, 39.863645],
                        [116.454222, 39.859381],
                        [116.456062, 39.86122],
                        [116.463319, 39.856224],
                        [116.467794, 39.856012],
                        [116.460308, 39.848622],
                        [116.451148, 39.852008],
                        [116.450479, 39.848704],
                        [116.445983, 39.848329],
                        [116.446694, 39.84426],
                        [116.442323, 39.843674],
                        [116.440587, 39.839653],
                        [116.436739, 39.841329],
                        [116.432055, 39.832929],
                        [116.425217, 39.831903],
                        [116.420072, 39.826611],
                        [116.415785, 39.829428],
                        [116.414426, 39.824282],
                        [116.418441, 39.822915],
                        [116.419759, 39.815375],
                        [116.41016, 39.817052],
                        [116.410013, 39.811336],
                        [116.415262, 39.812525],
                        [116.417772, 39.81013],
                        [116.422456, 39.81044],
                        [116.425719, 39.805358],
                        [116.429399, 39.803583],
                        [116.429274, 39.794102],
                        [116.421034, 39.794134],
                        [116.42024, 39.787439],
                        [116.396023, 39.786738],
                        [116.397905, 39.781068],
                        [116.398888, 39.765864],
                        [116.391903, 39.765277],
                        [116.390649, 39.780465],
                        [116.385609, 39.778852],
                        [116.379209, 39.77939],
                        [116.378478, 39.785646],
                        [116.367582, 39.784962],
                        [116.365742, 39.794151],
                        [116.368189, 39.794819],
                        [116.367039, 39.79982],
                        [116.356833, 39.800471],
                        [116.355704, 39.805668],
                        [116.341755, 39.807589],
                        [116.340124, 39.802149],
                        [116.328225, 39.801416],
                        [116.326824, 39.798386],
                        [116.322872, 39.798386],
                        [116.321784, 39.783626],
                        [116.317978, 39.783447],
                        [116.31068, 39.772057],
                        [116.307062, 39.770085],
                        [116.301541, 39.774941],
                        [116.295205, 39.790958],
                        [116.291148, 39.793271],
                        [116.296083, 39.795568],
                        [116.289182, 39.795894],
                        [116.287237, 39.799103],
                        [116.27423, 39.796936],
                        [116.262184, 39.792782],
                        [116.259298, 39.797621],
                        [116.251519, 39.793059],
                        [116.250933, 39.801432],
                        [116.25361, 39.807231],
                        [116.251644, 39.81329],
                        [116.244304, 39.818567],
                        [116.243007, 39.825145],
                        [116.23962, 39.826872],
                        [116.228306, 39.827197],
                        [116.227219, 39.825048],
                        [116.214127, 39.824706],
                        [116.214462, 39.818974],
                        [116.216762, 39.816905],
                        [116.207415, 39.810814],
                        [116.208063, 39.806352],
                        [116.201852, 39.799657],
                        [116.201852, 39.788269],
                        [116.200388, 39.778151],
                        [116.194449, 39.778493],
                        [116.194407, 39.780579],
                        [116.188008, 39.781785],
                        [116.183365, 39.780204],
                        [116.182989, 39.783707],
                        [116.16971, 39.784278],
                        [116.166113, 39.775039],
                        [116.159923, 39.767494],
                        [116.150554, 39.766565],
                        [116.143444, 39.764381],
                        [116.133427, 39.766336],
                        [116.12847, 39.762409],
                        [116.121465, 39.761626],
                        [116.117491, 39.77336],
                        [116.121486, 39.779047],
                        [116.124351, 39.77675],
                        [116.127467, 39.779047],
                        [116.132569, 39.778624],
                        [116.131503, 39.783121],
                        [116.125062, 39.785353],
                        [116.120754, 39.784848],
                        [116.119792, 39.789654],
                        [116.106366, 39.788612],
                        [116.107014, 39.78532],
                        [116.101368, 39.78576],
                        [116.094613, 39.781557],
                        [116.091581, 39.784082],
                        [116.091916, 39.787927],
                        [116.0856, 39.795324],
                        [116.087127, 39.803289],
                        [116.084826, 39.811596],
                        [116.086186, 39.816401],
                        [116.089594, 39.816352],
                        [116.088214, 39.82692],
                        [116.089741, 39.829721],
                        [116.085747, 39.832163],
                        [116.084366, 39.828581],
                        [116.078615, 39.831593],
                        [116.07619, 39.837015],
                        [116.068975, 39.840792],
                        [116.061488, 39.841899],
                        [116.05465, 39.845953],
                        [116.056553, 39.85095],
                        [116.070982, 39.853717],
                        [116.070188, 39.860423],
                        [116.067344, 39.865761],
                        [116.07046, 39.868446],
                        [116.078323, 39.870318],
                        [116.087169, 39.866152],
                        [116.095826, 39.869032],
                        [116.104149, 39.868837],
                        [116.105425, 39.872547],
                        [116.112242, 39.873247],
                        [116.119729, 39.877477],
                        [116.125898, 39.877949],
                        [116.13167, 39.881268],
                        [116.147605, 39.885287],
                        [116.150972, 39.884051],
                        [116.156137, 39.889029],
                        [116.163352, 39.886881],
                        [116.167033, 39.888752]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110107,
            "name": "石景山区",
            "center": [116.195445, 39.914601],
            "centroid": [116.176243, 39.9332],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 4,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.259089, 39.896658],
                        [116.252899, 39.896382],
                        [116.233534, 39.89212],
                        [116.234642, 39.88955],
                        [116.227783, 39.889078],
                        [116.22772, 39.883839],
                        [116.222952, 39.883986],
                        [116.219523, 39.881334],
                        [116.219105, 39.876713],
                        [116.210907, 39.878079],
                        [116.212099, 39.874679],
                        [116.208126, 39.874125],
                        [116.20457, 39.879885],
                        [116.199426, 39.883286],
                        [116.19035, 39.881529],
                        [116.179099, 39.882684],
                        [116.167033, 39.888752],
                        [116.161094, 39.896805],
                        [116.153503, 39.900985],
                        [116.152792, 39.906629],
                        [116.146852, 39.910077],
                        [116.139282, 39.922095],
                        [116.13029, 39.924518],
                        [116.127341, 39.926615],
                        [116.127822, 39.930338],
                        [116.124769, 39.934907],
                        [116.119875, 39.932761],
                        [116.11195, 39.942921],
                        [116.114522, 39.949196],
                        [116.120545, 39.951],
                        [116.115254, 39.957745],
                        [116.120712, 39.96119],
                        [116.122971, 39.967561],
                        [116.116592, 39.971932],
                        [116.113455, 39.981518],
                        [116.118934, 39.986115],
                        [116.144678, 39.989186],
                        [116.151579, 39.993442],
                        [116.156117, 39.989137],
                        [116.158124, 39.984133],
                        [116.166845, 39.987561],
                        [116.169229, 39.979357],
                        [116.171487, 39.977001],
                        [116.178012, 39.982216],
                        [116.178911, 39.988292],
                        [116.186586, 39.983906],
                        [116.18531, 39.977976],
                        [116.185812, 39.970274],
                        [116.190685, 39.968259],
                        [116.190747, 39.965367],
                        [116.20112, 39.961109],
                        [116.212831, 39.948952],
                        [116.215466, 39.94375],
                        [116.216281, 39.936386],
                        [116.213186, 39.933232],
                        [116.216198, 39.931233],
                        [116.213061, 39.928891],
                        [116.215696, 39.927103],
                        [116.207707, 39.9259],
                        [116.206787, 39.916663],
                        [116.230899, 39.919525],
                        [116.232426, 39.91694],
                        [116.237696, 39.918452],
                        [116.250975, 39.919834],
                        [116.252983, 39.915558],
                        [116.252983, 39.896951],
                        [116.259089, 39.896658]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110108,
            "name": "海淀区",
            "center": [116.310316, 39.956074],
            "centroid": [116.233161, 40.026971],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 5,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.259089, 39.896658],
                        [116.252983, 39.896951],
                        [116.252983, 39.915558],
                        [116.250975, 39.919834],
                        [116.237696, 39.918452],
                        [116.232426, 39.91694],
                        [116.230899, 39.919525],
                        [116.206787, 39.916663],
                        [116.207707, 39.9259],
                        [116.215696, 39.927103],
                        [116.213061, 39.928891],
                        [116.216198, 39.931233],
                        [116.213186, 39.933232],
                        [116.216281, 39.936386],
                        [116.215466, 39.94375],
                        [116.212831, 39.948952],
                        [116.20112, 39.961109],
                        [116.190747, 39.965367],
                        [116.190685, 39.968259],
                        [116.185812, 39.970274],
                        [116.18531, 39.977976],
                        [116.186586, 39.983906],
                        [116.178911, 39.988292],
                        [116.178012, 39.982216],
                        [116.171487, 39.977001],
                        [116.169229, 39.979357],
                        [116.166845, 39.987561],
                        [116.158124, 39.984133],
                        [116.156117, 39.989137],
                        [116.151579, 39.993442],
                        [116.154527, 39.997275],
                        [116.161658, 39.999987],
                        [116.172115, 40.000637],
                        [116.175335, 40.006403],
                        [116.164774, 40.014328],
                        [116.163938, 40.016796],
                        [116.157309, 40.021034],
                        [116.149278, 40.022154],
                        [116.140098, 40.02873],
                        [116.129558, 40.0311],
                        [116.123598, 40.029655],
                        [116.114522, 40.033],
                        [116.105488, 40.032204],
                        [116.098398, 40.033811],
                        [116.095073, 40.031782],
                        [116.084241, 40.030905],
                        [116.078176, 40.032756],
                        [116.075123, 40.039915],
                        [116.068055, 40.051926],
                        [116.071129, 40.062037],
                        [116.064981, 40.067456],
                        [116.064019, 40.073022],
                        [116.054587, 40.07823],
                        [116.051325, 40.084345],
                        [116.048878, 40.085303],
                        [116.051848, 40.091661],
                        [116.055905, 40.09643],
                        [116.061969, 40.09956],
                        [116.062931, 40.10282],
                        [116.069456, 40.104912],
                        [116.072676, 40.109258],
                        [116.073847, 40.115436],
                        [116.077883, 40.115047],
                        [116.08445, 40.120252],
                        [116.089783, 40.119327],
                        [116.096056, 40.121257],
                        [116.102246, 40.115987],
                        [116.105864, 40.118014],
                        [116.113309, 40.115598],
                        [116.127676, 40.116393],
                        [116.132214, 40.115079],
                        [116.132925, 40.121354],
                        [116.152708, 40.121776],
                        [116.169563, 40.124564],
                        [116.167409, 40.128455],
                        [116.17178, 40.127936],
                        [116.168622, 40.135442],
                        [116.167681, 40.141844],
                        [116.174122, 40.143595],
                        [116.180417, 40.14729],
                        [116.183094, 40.153335],
                        [116.182696, 40.158099],
                        [116.192065, 40.155669],
                        [116.194282, 40.160076],
                        [116.202166, 40.160984],
                        [116.203211, 40.153773],
                        [116.205658, 40.150175],
                        [116.206285, 40.143092],
                        [116.212224, 40.140548],
                        [116.215445, 40.143174],
                        [116.233785, 40.136577],
                        [116.247043, 40.136204],
                        [116.245036, 40.118825],
                        [116.241836, 40.118403],
                        [116.243363, 40.113279],
                        [116.240498, 40.108009],
                        [116.245956, 40.10535],
                        [116.252732, 40.106517],
                        [116.255868, 40.104474],
                        [116.25957, 40.106907],
                        [116.258022, 40.11195],
                        [116.263334, 40.110588],
                        [116.263899, 40.10402],
                        [116.258273, 40.101522],
                        [116.265237, 40.094694],
                        [116.27333, 40.09557],
                        [116.2731, 40.092699],
                        [116.279897, 40.079754],
                        [116.290353, 40.083145],
                        [116.302942, 40.060803],
                        [116.305995, 40.063043],
                        [116.309446, 40.060609],
                        [116.318292, 40.061663],
                        [116.325946, 40.054799],
                        [116.338828, 40.058921],
                        [116.340271, 40.055091],
                        [116.343366, 40.055448],
                        [116.342676, 40.059635],
                        [116.346963, 40.06043],
                        [116.34667, 40.063659],
                        [116.357293, 40.066012],
                        [116.363023, 40.065931],
                        [116.363149, 40.068965],
                        [116.372538, 40.06843],
                        [116.373354, 40.065623],
                        [116.381928, 40.066402],
                        [116.382848, 40.061582],
                        [116.379272, 40.059002],
                        [116.372267, 40.05785],
                        [116.372999, 40.054344],
                        [116.367394, 40.053436],
                        [116.36959, 40.04696],
                        [116.376114, 40.045466],
                        [116.376888, 40.042756],
                        [116.38519, 40.042853],
                        [116.390649, 40.041279],
                        [116.390251, 40.036587],
                        [116.395103, 40.032854],
                        [116.378708, 40.031181],
                        [116.350873, 40.0267],
                        [116.376554, 39.992971],
                        [116.381196, 39.977976],
                        [116.380903, 39.972712],
                        [116.380401, 39.968178],
                        [116.370384, 39.967902],
                        [116.371974, 39.948594],
                        [116.35698, 39.944466],
                        [116.355265, 39.951796],
                        [116.351814, 39.950854],
                        [116.35171, 39.94375],
                        [116.341442, 39.941979],
                        [116.332889, 39.944092],
                        [116.327953, 39.942369],
                        [116.333056, 39.938565],
                        [116.334645, 39.922664],
                        [116.335356, 39.898448],
                        [116.337301, 39.89739],
                        [116.325799, 39.896789],
                        [116.313189, 39.896772],
                        [116.30449, 39.892478],
                        [116.30656, 39.890883],
                        [116.29922, 39.889566],
                        [116.294995, 39.886735],
                        [116.294975, 39.896496],
                        [116.266199, 39.896252],
                        [116.259089, 39.896658]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110109,
            "name": "门头沟区",
            "center": [116.105381, 39.937183],
            "centroid": [115.791703, 39.994114],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 6,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [115.853348, 40.149332],
                        [115.856547, 40.147468],
                        [115.865184, 40.148635],
                        [115.870768, 40.144276],
                        [115.874155, 40.14387],
                        [115.8816, 40.139073],
                        [115.900442, 40.138716],
                        [115.904457, 40.136123],
                        [115.906549, 40.138181],
                        [115.921438, 40.134485],
                        [115.933588, 40.124824],
                        [115.947913, 40.107409],
                        [115.943229, 40.103339],
                        [115.952681, 40.10102],
                        [115.956717, 40.096041],
                        [115.957449, 40.100679],
                        [115.962552, 40.10235],
                        [115.962092, 40.094419],
                        [115.960461, 40.092456],
                        [115.966588, 40.084556],
                        [115.968575, 40.075488],
                        [115.977232, 40.079041],
                        [115.979993, 40.081669],
                        [115.986434, 40.083469],
                        [115.99735, 40.082074],
                        [116.005129, 40.079803],
                        [116.007785, 40.080614],
                        [116.020856, 40.074579],
                        [116.030914, 40.082188],
                        [116.033926, 40.079657],
                        [116.037899, 40.084524],
                        [116.043775, 40.083502],
                        [116.048878, 40.085303],
                        [116.051325, 40.084345],
                        [116.054587, 40.07823],
                        [116.064019, 40.073022],
                        [116.064981, 40.067456],
                        [116.071129, 40.062037],
                        [116.068055, 40.051926],
                        [116.075123, 40.039915],
                        [116.078176, 40.032756],
                        [116.084241, 40.030905],
                        [116.095073, 40.031782],
                        [116.098398, 40.033811],
                        [116.105488, 40.032204],
                        [116.114522, 40.033],
                        [116.123598, 40.029655],
                        [116.129558, 40.0311],
                        [116.140098, 40.02873],
                        [116.149278, 40.022154],
                        [116.157309, 40.021034],
                        [116.163938, 40.016796],
                        [116.164774, 40.014328],
                        [116.175335, 40.006403],
                        [116.172115, 40.000637],
                        [116.161658, 39.999987],
                        [116.154527, 39.997275],
                        [116.151579, 39.993442],
                        [116.144678, 39.989186],
                        [116.118934, 39.986115],
                        [116.113455, 39.981518],
                        [116.116592, 39.971932],
                        [116.122971, 39.967561],
                        [116.120712, 39.96119],
                        [116.115254, 39.957745],
                        [116.120545, 39.951],
                        [116.114522, 39.949196],
                        [116.11195, 39.942921],
                        [116.119875, 39.932761],
                        [116.124769, 39.934907],
                        [116.127822, 39.930338],
                        [116.127341, 39.926615],
                        [116.13029, 39.924518],
                        [116.139282, 39.922095],
                        [116.146852, 39.910077],
                        [116.152792, 39.906629],
                        [116.153503, 39.900985],
                        [116.161094, 39.896805],
                        [116.167033, 39.888752],
                        [116.163352, 39.886881],
                        [116.156137, 39.889029],
                        [116.150972, 39.884051],
                        [116.147605, 39.885287],
                        [116.13167, 39.881268],
                        [116.125898, 39.877949],
                        [116.119729, 39.877477],
                        [116.112242, 39.873247],
                        [116.105425, 39.872547],
                        [116.104149, 39.868837],
                        [116.095826, 39.869032],
                        [116.087169, 39.866152],
                        [116.078323, 39.870318],
                        [116.07046, 39.868446],
                        [116.067344, 39.865761],
                        [116.070188, 39.860423],
                        [116.070982, 39.853717],
                        [116.056553, 39.85095],
                        [116.05465, 39.845953],
                        [116.045825, 39.84732],
                        [116.04181, 39.844878],
                        [116.033089, 39.845904],
                        [116.030308, 39.843462],
                        [116.021023, 39.840662],
                        [116.018367, 39.841525],
                        [116.016694, 39.849225],
                        [116.00789, 39.849469],
                        [115.991285, 39.840222],
                        [115.98428, 39.849111],
                        [115.98817, 39.859837],
                        [115.986789, 39.864703],
                        [115.992875, 39.867356],
                        [115.997245, 39.875167],
                        [115.990177, 39.876338],
                        [115.97627, 39.870497],
                        [115.976563, 39.868251],
                        [115.968742, 39.867714],
                        [115.967822, 39.872059],
                        [115.961318, 39.867877],
                        [115.954145, 39.866786],
                        [115.949837, 39.871278],
                        [115.92744, 39.876192],
                        [115.921856, 39.884164],
                        [115.935805, 39.898236],
                        [115.944965, 39.901847],
                        [115.945697, 39.910972],
                        [115.941159, 39.917509],
                        [115.935868, 39.917753],
                        [115.927858, 39.914257],
                        [115.903935, 39.914029],
                        [115.890112, 39.917281],
                        [115.87884, 39.915964],
                        [115.87311, 39.912484],
                        [115.868321, 39.905572],
                        [115.860897, 39.901359],
                        [115.845255, 39.897049],
                        [115.838772, 39.900644],
                        [115.835112, 39.899586],
                        [115.826914, 39.910581],
                        [115.8188, 39.913948],
                        [115.811084, 39.913785],
                        [115.806839, 39.919656],
                        [115.797344, 39.92216],
                        [115.792848, 39.920859],
                        [115.774257, 39.920599],
                        [115.769385, 39.925233],
                        [115.76148, 39.920989],
                        [115.749622, 39.917655],
                        [115.74889, 39.9152],
                        [115.731261, 39.907865],
                        [115.721621, 39.906824],
                        [115.719592, 39.904612],
                        [115.709178, 39.905117],
                        [115.691779, 39.8997],
                        [115.68929, 39.896187],
                        [115.682556, 39.893047],
                        [115.678144, 39.886556],
                        [115.671055, 39.88597],
                        [115.667541, 39.883888],
                        [115.654869, 39.882505],
                        [115.648867, 39.875411],
                        [115.644705, 39.875964],
                        [115.640021, 39.871554],
                        [115.630987, 39.871977],
                        [115.623103, 39.866949],
                        [115.621973, 39.863271],
                        [115.616369, 39.857542],
                        [115.613086, 39.843755],
                        [115.607586, 39.84089],
                        [115.604533, 39.834443],
                        [115.599325, 39.829151],
                        [115.596649, 39.821498],
                        [115.59117, 39.818534],
                        [115.587322, 39.813762],
                        [115.577367, 39.812541],
                        [115.569274, 39.813274],
                        [115.563461, 39.816417],
                        [115.548027, 39.822703],
                        [115.546396, 39.825992],
                        [115.534957, 39.830714],
                        [115.530482, 39.829916],
                        [115.526509, 39.835241],
                        [115.514505, 39.83835],
                        [115.510992, 39.84509],
                        [115.515948, 39.847678],
                        [115.522368, 39.858779],
                        [115.521929, 39.868186],
                        [115.527345, 39.869862],
                        [115.529185, 39.875948],
                        [115.526299, 39.875655],
                        [115.516659, 39.880406],
                        [115.51003, 39.88148],
                        [115.509026, 39.884164],
                        [115.523016, 39.898919],
                        [115.52013, 39.902547],
                        [115.50386, 39.915818],
                        [115.494994, 39.917948],
                        [115.487277, 39.923835],
                        [115.48069, 39.93585],
                        [115.472387, 39.93876],
                        [115.464462, 39.940142],
                        [115.456787, 39.944271],
                        [115.452312, 39.948188],
                        [115.447042, 39.948806],
                        [115.444595, 39.951358],
                        [115.438468, 39.95256],
                        [115.43577, 39.950919],
                        [115.42615, 39.95035],
                        [115.423745, 39.955697],
                        [115.426924, 39.965302],
                        [115.423411, 39.969819],
                        [115.427635, 39.979471],
                        [115.428513, 39.984328],
                        [115.436815, 39.991427],
                        [115.443905, 39.994644],
                        [115.450346, 39.993247],
                        [115.449196, 40.001985],
                        [115.442817, 40.007345],
                        [115.442169, 40.010885],
                        [115.452082, 40.02079],
                        [115.454528, 40.029704],
                        [115.460656, 40.032172],
                        [115.468414, 40.031896],
                        [115.478557, 40.036165],
                        [115.488992, 40.043746],
                        [115.488323, 40.046132],
                        [115.500954, 40.052478],
                        [115.510427, 40.062913],
                        [115.509695, 40.065477],
                        [115.514944, 40.066937],
                        [115.527324, 40.076072],
                        [115.537885, 40.077775],
                        [115.544263, 40.07591],
                        [115.552168, 40.079252],
                        [115.555472, 40.082626],
                        [115.553736, 40.091661],
                        [115.563419, 40.097922],
                        [115.567769, 40.096543],
                        [115.576196, 40.100825],
                        [115.578538, 40.096365],
                        [115.584038, 40.094889],
                        [115.590709, 40.096397],
                        [115.592403, 40.110182],
                        [115.594432, 40.108982],
                        [115.59485, 40.116279],
                        [115.599116, 40.120008],
                        [115.606979, 40.120057],
                        [115.616223, 40.117138],
                        [115.621388, 40.118711],
                        [115.625048, 40.116295],
                        [115.631468, 40.117852],
                        [115.635943, 40.115793],
                        [115.643722, 40.117511],
                        [115.641882, 40.120819],
                        [115.64458, 40.126639],
                        [115.654806, 40.131276],
                        [115.657734, 40.128098],
                        [115.678667, 40.130935],
                        [115.681197, 40.13267],
                        [115.68699, 40.13053],
                        [115.693096, 40.131924],
                        [115.697216, 40.12672],
                        [115.702172, 40.128196],
                        [115.712064, 40.126899],
                        [115.711039, 40.128941],
                        [115.704765, 40.129655],
                        [115.699746, 40.132394],
                        [115.708697, 40.134291],
                        [115.715891, 40.133383],
                        [115.724841, 40.128812],
                        [115.734126, 40.129379],
                        [115.741111, 40.132216],
                        [115.749246, 40.137711],
                        [115.75485, 40.145459],
                        [115.749539, 40.152995],
                        [115.754328, 40.163252],
                        [115.762212, 40.16262],
                        [115.768213, 40.165553],
                        [115.773023, 40.176197],
                        [115.787014, 40.178708],
                        [115.78693, 40.170414],
                        [115.789837, 40.168939],
                        [115.802091, 40.156754],
                        [115.806567, 40.153254],
                        [115.822272, 40.152606],
                        [115.829047, 40.149981],
                        [115.83576, 40.145426],
                        [115.834234, 40.15024],
                        [115.846384, 40.147096],
                        [115.853348, 40.149332]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110111,
            "name": "房山区",
            "center": [116.139157, 39.735535],
            "centroid": [115.853935, 39.719211],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 7,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.05465, 39.845953],
                        [116.061488, 39.841899],
                        [116.068975, 39.840792],
                        [116.07619, 39.837015],
                        [116.078615, 39.831593],
                        [116.084366, 39.828581],
                        [116.085747, 39.832163],
                        [116.089741, 39.829721],
                        [116.088214, 39.82692],
                        [116.089594, 39.816352],
                        [116.086186, 39.816401],
                        [116.084826, 39.811596],
                        [116.087127, 39.803289],
                        [116.0856, 39.795324],
                        [116.091916, 39.787927],
                        [116.091581, 39.784082],
                        [116.094613, 39.781557],
                        [116.101368, 39.78576],
                        [116.107014, 39.78532],
                        [116.106366, 39.788612],
                        [116.119792, 39.789654],
                        [116.120754, 39.784848],
                        [116.125062, 39.785353],
                        [116.131503, 39.783121],
                        [116.132569, 39.778624],
                        [116.127467, 39.779047],
                        [116.124351, 39.77675],
                        [116.121486, 39.779047],
                        [116.117491, 39.77336],
                        [116.121465, 39.761626],
                        [116.12847, 39.762409],
                        [116.133427, 39.766336],
                        [116.143444, 39.764381],
                        [116.150554, 39.766565],
                        [116.159923, 39.767494],
                        [116.166113, 39.775039],
                        [116.16971, 39.784278],
                        [116.182989, 39.783707],
                        [116.183365, 39.780204],
                        [116.188008, 39.781785],
                        [116.194407, 39.780579],
                        [116.194449, 39.778493],
                        [116.200388, 39.778151],
                        [116.201852, 39.788269],
                        [116.201852, 39.799657],
                        [116.208063, 39.806352],
                        [116.207415, 39.810814],
                        [116.216762, 39.816905],
                        [116.214462, 39.818974],
                        [116.214127, 39.824706],
                        [116.227219, 39.825048],
                        [116.228306, 39.827197],
                        [116.23962, 39.826872],
                        [116.243007, 39.825145],
                        [116.244304, 39.818567],
                        [116.251644, 39.81329],
                        [116.25361, 39.807231],
                        [116.250933, 39.801432],
                        [116.251519, 39.793059],
                        [116.251602, 39.782518],
                        [116.253777, 39.77952],
                        [116.252481, 39.771747],
                        [116.254426, 39.76324],
                        [116.252481, 39.758676],
                        [116.251895, 39.749092],
                        [116.243948, 39.741658],
                        [116.248026, 39.732641],
                        [116.248466, 39.728027],
                        [116.245768, 39.72408],
                        [116.245036, 39.718421],
                        [116.236629, 39.71286],
                        [116.231945, 39.706025],
                        [116.23435, 39.703823],
                        [116.230941, 39.692355],
                        [116.221238, 39.678453],
                        [116.22565, 39.67359],
                        [116.221342, 39.667486],
                        [116.223162, 39.664728],
                        [116.216992, 39.651572],
                        [116.215487, 39.64305],
                        [116.218875, 39.628011],
                        [116.219502, 39.618931],
                        [116.21808, 39.608102],
                        [116.223141, 39.597222],
                        [116.222597, 39.593938],
                        [116.226089, 39.591993],
                        [116.225085, 39.584085],
                        [116.221175, 39.578921],
                        [116.208105, 39.577728],
                        [116.206243, 39.583219],
                        [116.201726, 39.586373],
                        [116.196394, 39.586095],
                        [116.196854, 39.588987],
                        [116.19058, 39.587386],
                        [116.190768, 39.589396],
                        [116.184432, 39.590915],
                        [116.177071, 39.590016],
                        [116.176924, 39.585899],
                        [116.165527, 39.583562],
                        [116.151788, 39.583415],
                        [116.149613, 39.573087],
                        [116.13878, 39.571044],
                        [116.138425, 39.568887],
                        [116.130373, 39.567743],
                        [116.130311, 39.569459],
                        [116.121528, 39.570554],
                        [116.121465, 39.574917],
                        [116.116634, 39.574002],
                        [116.11379, 39.570668],
                        [116.106282, 39.570979],
                        [116.105801, 39.576568],
                        [116.101368, 39.580049],
                        [116.102016, 39.576143],
                        [116.098817, 39.575146],
                        [116.039237, 39.571943],
                        [116.032964, 39.572302],
                        [116.032859, 39.574607],
                        [116.024766, 39.575604],
                        [116.02623, 39.587402],
                        [116.020667, 39.585981],
                        [116.014038, 39.588072],
                        [116.013703, 39.583039],
                        [116.010588, 39.583023],
                        [116.007618, 39.577205],
                        [115.995196, 39.577075],
                        [115.996953, 39.583203],
                        [115.990721, 39.586471],
                        [115.990993, 39.593791],
                        [115.978445, 39.595686],
                        [115.977086, 39.590931],
                        [115.978153, 39.572842],
                        [115.974576, 39.570832],
                        [115.968909, 39.570995],
                        [115.967592, 39.564604],
                        [115.963409, 39.565503],
                        [115.957554, 39.560927],
                        [115.954982, 39.566092],
                        [115.950423, 39.56637],
                        [115.949147, 39.573299],
                        [115.943083, 39.574672],
                        [115.943187, 39.577385],
                        [115.937938, 39.577467],
                        [115.938105, 39.581699],
                        [115.934969, 39.581814],
                        [115.934174, 39.588072],
                        [115.929991, 39.589935],
                        [115.930221, 39.593382],
                        [115.924178, 39.59384],
                        [115.923759, 39.597287],
                        [115.912488, 39.599149],
                        [115.910187, 39.600832],
                        [115.9068, 39.590016],
                        [115.909665, 39.588284],
                        [115.908744, 39.58402],
                        [115.915604, 39.582958],
                        [115.911777, 39.574182],
                        [115.91276, 39.572842],
                        [115.907866, 39.566876],
                        [115.896009, 39.569916],
                        [115.890028, 39.567873],
                        [115.893416, 39.561875],
                        [115.89306, 39.556219],
                        [115.888752, 39.555614],
                        [115.887686, 39.55066],
                        [115.883587, 39.551102],
                        [115.88296, 39.54811],
                        [115.873298, 39.548829],
                        [115.872315, 39.546099],
                        [115.866355, 39.546361],
                        [115.866041, 39.549843],
                        [115.862026, 39.548551],
                        [115.855481, 39.554993],
                        [115.851361, 39.550448],
                        [115.847555, 39.550284],
                        [115.846028, 39.543287],
                        [115.84216, 39.54157],
                        [115.828692, 39.541309],
                        [115.828399, 39.535455],
                        [115.824321, 39.534212],
                        [115.822753, 39.530533],
                        [115.819219, 39.530762],
                        [115.819804, 39.524923],
                        [115.824112, 39.522405],
                        [115.824447, 39.518774],
                        [115.819762, 39.518528],
                        [115.822146, 39.514145],
                        [115.829487, 39.512885],
                        [115.828692, 39.507045],
                        [115.821456, 39.509499],
                        [115.792681, 39.510742],
                        [115.785006, 39.51035],
                        [115.777917, 39.513834],
                        [115.776537, 39.512722],
                        [115.767419, 39.515862],
                        [115.770828, 39.510971],
                        [115.768736, 39.508878],
                        [115.765328, 39.514848],
                        [115.759451, 39.513916],
                        [115.752508, 39.515453],
                        [115.743934, 39.526771],
                        [115.741487, 39.536289],
                        [115.73879, 39.539314],
                        [115.739124, 39.545363],
                        [115.726765, 39.548143],
                        [115.726953, 39.543908],
                        [115.7216, 39.543499],
                        [115.72022, 39.554747],
                        [115.717104, 39.560403],
                        [115.710161, 39.563019],
                        [115.698722, 39.563248],
                        [115.692072, 39.565781],
                        [115.694393, 39.56941],
                        [115.698596, 39.570586],
                        [115.697906, 39.579248],
                        [115.693431, 39.580327],
                        [115.694226, 39.587778],
                        [115.689269, 39.592941],
                        [115.68929, 39.599035],
                        [115.685317, 39.603675],
                        [115.673271, 39.608526],
                        [115.667479, 39.615256],
                        [115.667583, 39.609637],
                        [115.665304, 39.605325],
                        [115.657273, 39.600081],
                        [115.650268, 39.600996],
                        [115.643576, 39.598937],
                        [115.641589, 39.603332],
                        [115.634688, 39.603871],
                        [115.632555, 39.597695],
                        [115.625947, 39.599394],
                        [115.618439, 39.604067],
                        [115.6125, 39.601126],
                        [115.605285, 39.600032],
                        [115.599785, 39.600865],
                        [115.598719, 39.597761],
                        [115.592445, 39.59665],
                        [115.586109, 39.589412],
                        [115.571867, 39.591569],
                        [115.573875, 39.596552],
                        [115.567267, 39.599623],
                        [115.564569, 39.605619],
                        [115.55451, 39.609408],
                        [115.551875, 39.614064],
                        [115.545978, 39.618751],
                        [115.539119, 39.616285],
                        [115.533263, 39.611434],
                        [115.533891, 39.608608],
                        [115.530586, 39.602874],
                        [115.524229, 39.598937],
                        [115.518311, 39.597156],
                        [115.518834, 39.593072],
                        [115.515948, 39.591193],
                        [115.512121, 39.605129],
                        [115.514358, 39.613508],
                        [115.523414, 39.620384],
                        [115.521699, 39.622311],
                        [115.520423, 39.633416],
                        [115.522452, 39.639964],
                        [115.515864, 39.641237],
                        [115.511493, 39.644388],
                        [115.506705, 39.652127],
                        [115.496771, 39.652551],
                        [115.494659, 39.649237],
                        [115.478515, 39.650331],
                        [115.477971, 39.654216],
                        [115.482593, 39.66303],
                        [115.491334, 39.668694],
                        [115.486733, 39.673362],
                        [115.489724, 39.678012],
                        [115.488783, 39.681619],
                        [115.494408, 39.686481],
                        [115.496395, 39.685665],
                        [115.499783, 39.691278],
                        [115.49926, 39.696189],
                        [115.492631, 39.701719],
                        [115.490247, 39.701409],
                        [115.493404, 39.707494],
                        [115.491229, 39.714719],
                        [115.488866, 39.733163],
                        [115.492108, 39.73887],
                        [115.482321, 39.742473],
                        [115.470568, 39.742391],
                        [115.46672, 39.740451],
                        [115.457728, 39.744918],
                        [115.439158, 39.752678],
                        [115.434411, 39.763859],
                        [115.435414, 39.769938],
                        [115.430918, 39.772073],
                        [115.427029, 39.769775],
                        [115.425209, 39.77336],
                        [115.431169, 39.775756],
                        [115.434076, 39.782274],
                        [115.443382, 39.785646],
                        [115.452751, 39.781964],
                        [115.45777, 39.782143],
                        [115.475859, 39.791821],
                        [115.483241, 39.798679],
                        [115.49238, 39.796057],
                        [115.497336, 39.791088],
                        [115.508712, 39.784082],
                        [115.513815, 39.788693],
                        [115.536275, 39.792131],
                        [115.539432, 39.794754],
                        [115.554866, 39.795601],
                        [115.56229, 39.803713],
                        [115.566577, 39.804609],
                        [115.566367, 39.809788],
                        [115.569274, 39.813274],
                        [115.577367, 39.812541],
                        [115.587322, 39.813762],
                        [115.59117, 39.818534],
                        [115.596649, 39.821498],
                        [115.599325, 39.829151],
                        [115.604533, 39.834443],
                        [115.607586, 39.84089],
                        [115.613086, 39.843755],
                        [115.616369, 39.857542],
                        [115.621973, 39.863271],
                        [115.623103, 39.866949],
                        [115.630987, 39.871977],
                        [115.640021, 39.871554],
                        [115.644705, 39.875964],
                        [115.648867, 39.875411],
                        [115.654869, 39.882505],
                        [115.667541, 39.883888],
                        [115.671055, 39.88597],
                        [115.678144, 39.886556],
                        [115.682556, 39.893047],
                        [115.68929, 39.896187],
                        [115.691779, 39.8997],
                        [115.709178, 39.905117],
                        [115.719592, 39.904612],
                        [115.721621, 39.906824],
                        [115.731261, 39.907865],
                        [115.74889, 39.9152],
                        [115.749622, 39.917655],
                        [115.76148, 39.920989],
                        [115.769385, 39.925233],
                        [115.774257, 39.920599],
                        [115.792848, 39.920859],
                        [115.797344, 39.92216],
                        [115.806839, 39.919656],
                        [115.811084, 39.913785],
                        [115.8188, 39.913948],
                        [115.826914, 39.910581],
                        [115.835112, 39.899586],
                        [115.838772, 39.900644],
                        [115.845255, 39.897049],
                        [115.860897, 39.901359],
                        [115.868321, 39.905572],
                        [115.87311, 39.912484],
                        [115.87884, 39.915964],
                        [115.890112, 39.917281],
                        [115.903935, 39.914029],
                        [115.927858, 39.914257],
                        [115.935868, 39.917753],
                        [115.941159, 39.917509],
                        [115.945697, 39.910972],
                        [115.944965, 39.901847],
                        [115.935805, 39.898236],
                        [115.921856, 39.884164],
                        [115.92744, 39.876192],
                        [115.949837, 39.871278],
                        [115.954145, 39.866786],
                        [115.961318, 39.867877],
                        [115.967822, 39.872059],
                        [115.968742, 39.867714],
                        [115.976563, 39.868251],
                        [115.97627, 39.870497],
                        [115.990177, 39.876338],
                        [115.997245, 39.875167],
                        [115.992875, 39.867356],
                        [115.986789, 39.864703],
                        [115.98817, 39.859837],
                        [115.98428, 39.849111],
                        [115.991285, 39.840222],
                        [116.00789, 39.849469],
                        [116.016694, 39.849225],
                        [116.018367, 39.841525],
                        [116.021023, 39.840662],
                        [116.030308, 39.843462],
                        [116.033089, 39.845904],
                        [116.04181, 39.844878],
                        [116.045825, 39.84732],
                        [116.05465, 39.845953]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110112,
            "name": "通州区",
            "center": [116.658603, 39.902486],
            "centroid": [116.73624, 39.803923],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 8,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.534944, 39.82482],
                        [116.538143, 39.828207],
                        [116.533187, 39.832733],
                        [116.542681, 39.830209],
                        [116.543664, 39.835078],
                        [116.558596, 39.834687],
                        [116.569386, 39.833498],
                        [116.577145, 39.830682],
                        [116.577479, 39.827539],
                        [116.587015, 39.828223],
                        [116.583732, 39.824917],
                        [116.591595, 39.823875],
                        [116.59147, 39.826367],
                        [116.599228, 39.825585],
                        [116.598977, 39.831659],
                        [116.60224, 39.831675],
                        [116.601905, 39.840727],
                        [116.608367, 39.846539],
                        [116.604666, 39.846132],
                        [116.604185, 39.850071],
                        [116.613449, 39.850185],
                        [116.626958, 39.860683],
                        [116.619994, 39.868951],
                        [116.62493, 39.87725],
                        [116.624323, 39.881155],
                        [116.628987, 39.881594],
                        [116.627585, 39.890477],
                        [116.615603, 39.889794],
                        [116.61531, 39.895503],
                        [116.621019, 39.898854],
                        [116.623361, 39.904271],
                        [116.620245, 39.90767],
                        [116.623006, 39.913818],
                        [116.620956, 39.923103],
                        [116.630576, 39.921672],
                        [116.624156, 39.929981],
                        [116.6293, 39.931314],
                        [116.629677, 39.938727],
                        [116.633441, 39.940906],
                        [116.630492, 39.946156],
                        [116.632228, 39.950545],
                        [116.645277, 39.945977],
                        [116.643081, 39.952983],
                        [116.641827, 39.969575],
                        [116.639819, 39.982606],
                        [116.634026, 39.981696],
                        [116.63365, 39.986197],
                        [116.639129, 39.986879],
                        [116.640321, 39.990177],
                        [116.643751, 39.989608],
                        [116.642684, 39.996755],
                        [116.637582, 40.002359],
                        [116.63273, 39.999825],
                        [116.625766, 40.003122],
                        [116.628129, 40.007653],
                        [116.61989, 40.011794],
                        [116.60132, 40.013873],
                        [116.595548, 40.01751],
                        [116.600839, 40.018858],
                        [116.602762, 40.028503],
                        [116.610061, 40.031214],
                        [116.614055, 40.03175],
                        [116.614139, 40.028178],
                        [116.619388, 40.026733],
                        [116.620099, 40.022512],
                        [116.624239, 40.023664],
                        [116.627063, 40.021505],
                        [116.633504, 40.023664],
                        [116.636159, 40.019703],
                        [116.651195, 40.025759],
                        [116.651676, 40.021911],
                        [116.655629, 40.018566],
                        [116.660125, 40.021651],
                        [116.664705, 40.019037],
                        [116.668615, 40.013938],
                        [116.678465, 40.015058],
                        [116.683777, 40.014458],
                        [116.686286, 40.00827],
                        [116.688378, 40.00918],
                        [116.685575, 40.016569],
                        [116.697244, 40.016098],
                        [116.703936, 40.020141],
                        [116.708621, 40.026587],
                        [116.716337, 40.023762],
                        [116.717383, 40.019605],
                        [116.719725, 40.022512],
                        [116.724221, 40.021278],
                        [116.724828, 40.024265],
                        [116.732043, 40.022219],
                        [116.732335, 40.025109],
                        [116.737145, 40.02761],
                        [116.747058, 40.025385],
                        [116.747037, 40.021976],
                        [116.751763, 40.019962],
                        [116.75329, 40.015919],
                        [116.764791, 40.016049],
                        [116.771755, 40.014474],
                        [116.770459, 40.011632],
                        [116.775749, 40.002943],
                        [116.775373, 39.992759],
                        [116.766757, 39.982281],
                        [116.766443, 39.976351],
                        [116.759605, 39.969933],
                        [116.757326, 39.961483],
                        [116.762826, 39.956006],
                        [116.78058, 39.949716],
                        [116.782567, 39.947554],
                        [116.78332, 39.936045],
                        [116.782358, 39.928273],
                        [116.78217, 39.910419],
                        [116.78424, 39.902221],
                        [116.7847, 39.89142],
                        [116.787084, 39.886833],
                        [116.794738, 39.881252],
                        [116.804148, 39.877933],
                        [116.804253, 39.88488],
                        [116.808247, 39.884913],
                        [116.80831, 39.889631],
                        [116.812304, 39.889712],
                        [116.81312, 39.881301],
                        [116.817009, 39.878649],
                        [116.823681, 39.879137],
                        [116.827277, 39.877071],
                        [116.836897, 39.864736],
                        [116.839407, 39.865777],
                        [116.847249, 39.858616],
                        [116.85254, 39.859056],
                        [116.85829, 39.84846],
                        [116.865505, 39.846913],
                        [116.866049, 39.843902],
                        [116.871507, 39.842062],
                        [116.878638, 39.842257],
                        [116.878304, 39.84522],
                        [116.885665, 39.844585],
                        [116.897501, 39.832587],
                        [116.903357, 39.830682],
                        [116.907581, 39.834117],
                        [116.902896, 39.841346],
                        [116.902813, 39.848248],
                        [116.910383, 39.850608],
                        [116.917431, 39.846913],
                        [116.9259, 39.835403],
                        [116.92887, 39.820912],
                        [116.92818, 39.814153],
                        [116.92979, 39.811368],
                        [116.942881, 39.801677],
                        [116.934809, 39.801139],
                        [116.938301, 39.793124],
                        [116.950828, 39.791528],
                        [116.953797, 39.78607],
                        [116.948004, 39.785369],
                        [116.94974, 39.778542],
                        [116.945788, 39.777369],
                        [116.939284, 39.781361],
                        [116.933784, 39.781801],
                        [116.921718, 39.780628],
                        [116.91649, 39.775935],
                        [116.920902, 39.769107],
                        [116.910613, 39.762278],
                        [116.908292, 39.766711],
                        [116.901809, 39.763615],
                        [116.901558, 39.755204],
                        [116.907163, 39.75597],
                        [116.913185, 39.745962],
                        [116.914461, 39.741755],
                        [116.910718, 39.740989],
                        [116.912934, 39.73569],
                        [116.916364, 39.73587],
                        [116.916678, 39.731353],
                        [116.911533, 39.731516],
                        [116.90229, 39.729413],
                        [116.89976, 39.726168],
                        [116.887589, 39.725515],
                        [116.8828, 39.71847],
                        [116.887108, 39.714311],
                        [116.886376, 39.707004],
                        [116.893841, 39.695879],
                        [116.89336, 39.693187],
                        [116.887819, 39.690952],
                        [116.88991, 39.687656],
                        [116.902896, 39.690576],
                        [116.909024, 39.682859],
                        [116.905197, 39.681651],
                        [116.906661, 39.677425],
                        [116.891144, 39.67408],
                        [116.883239, 39.675352],
                        [116.87318, 39.671387],
                        [116.863979, 39.670391],
                        [116.860486, 39.667258],
                        [116.849946, 39.667552],
                        [116.85141, 39.652845],
                        [116.839135, 39.647523],
                        [116.840766, 39.644241],
                        [116.833572, 39.644127],
                        [116.834555, 39.641841],
                        [116.826901, 39.638217],
                        [116.82893, 39.635163],
                        [116.826357, 39.633122],
                        [116.838445, 39.62223],
                        [116.834116, 39.621495],
                        [116.835391, 39.617004],
                        [116.82504, 39.613884],
                        [116.823994, 39.617183],
                        [116.81954, 39.618996],
                        [116.809711, 39.614521],
                        [116.802078, 39.6123],
                        [116.790012, 39.610535],
                        [116.792835, 39.602155],
                        [116.789384, 39.602596],
                        [116.790702, 39.596045],
                        [116.785474, 39.596209],
                        [116.785055, 39.593497],
                        [116.778196, 39.593382],
                        [116.774892, 39.599166],
                        [116.774202, 39.605439],
                        [116.762616, 39.613819],
                        [116.748689, 39.619943],
                        [116.744004, 39.616824],
                        [116.737877, 39.61537],
                        [116.730516, 39.619143],
                        [116.730202, 39.622932],
                        [116.725518, 39.624075],
                        [116.721398, 39.629415],
                        [116.723489, 39.639033],
                        [116.716003, 39.640356],
                        [116.710419, 39.639686],
                        [116.70609, 39.642903],
                        [116.702891, 39.649923],
                        [116.702138, 39.657644],
                        [116.704857, 39.667192],
                        [116.703769, 39.674145],
                        [116.693543, 39.674944],
                        [116.692706, 39.676789],
                        [116.685554, 39.676886],
                        [116.680786, 39.674896],
                        [116.675203, 39.676234],
                        [116.668574, 39.674602],
                        [116.666022, 39.679693],
                        [116.669577, 39.683642],
                        [116.666566, 39.687101],
                        [116.65818, 39.68857],
                        [116.658097, 39.686155],
                        [116.651321, 39.687868],
                        [116.651509, 39.694459],
                        [116.647097, 39.694786],
                        [116.64626, 39.700447],
                        [116.647912, 39.703579],
                        [116.653098, 39.703823],
                        [116.652994, 39.708619],
                        [116.644587, 39.709647],
                        [116.638502, 39.717166],
                        [116.637623, 39.723934],
                        [116.631203, 39.722971],
                        [116.628129, 39.727749],
                        [116.621646, 39.728076],
                        [116.621876, 39.725825],
                        [116.616251, 39.725581],
                        [116.609141, 39.719367],
                        [116.604561, 39.718731],
                        [116.604017, 39.714752],
                        [116.598371, 39.711963],
                        [116.590194, 39.711522],
                        [116.590152, 39.713349],
                        [116.581202, 39.712517],
                        [116.579884, 39.710234],
                        [116.573464, 39.709125],
                        [116.573276, 39.714507],
                        [116.544961, 39.715045],
                        [116.535676, 39.711881],
                        [116.530552, 39.713268],
                        [116.53256, 39.71529],
                        [116.527332, 39.716578],
                        [116.52936, 39.719808],
                        [116.534609, 39.718079],
                        [116.536972, 39.72152],
                        [116.53783, 39.728043],
                        [116.531849, 39.730016],
                        [116.532413, 39.73962],
                        [116.537997, 39.738071],
                        [116.53624, 39.740663],
                        [116.527562, 39.743304],
                        [116.536408, 39.753917],
                        [116.540716, 39.760502],
                        [116.548119, 39.765554],
                        [116.561565, 39.771111],
                        [116.576957, 39.771943],
                        [116.594377, 39.776685],
                        [116.574677, 39.798386],
                        [116.565078, 39.793988],
                        [116.562423, 39.796936],
                        [116.555145, 39.793548],
                        [116.546634, 39.803501],
                        [116.538373, 39.81513],
                        [116.533375, 39.819658],
                        [116.539586, 39.821563],
                        [116.534944, 39.82482]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110113,
            "name": "顺义区",
            "center": [116.653525, 40.128936],
            "centroid": [116.726467, 40.152366],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 9,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.771755, 40.014474],
                        [116.764791, 40.016049],
                        [116.75329, 40.015919],
                        [116.751763, 40.019962],
                        [116.747037, 40.021976],
                        [116.747058, 40.025385],
                        [116.737145, 40.02761],
                        [116.732335, 40.025109],
                        [116.732043, 40.022219],
                        [116.724828, 40.024265],
                        [116.724221, 40.021278],
                        [116.719725, 40.022512],
                        [116.717383, 40.019605],
                        [116.716337, 40.023762],
                        [116.708621, 40.026587],
                        [116.703936, 40.020141],
                        [116.697244, 40.016098],
                        [116.685575, 40.016569],
                        [116.688378, 40.00918],
                        [116.686286, 40.00827],
                        [116.683777, 40.014458],
                        [116.678465, 40.015058],
                        [116.668615, 40.013938],
                        [116.664705, 40.019037],
                        [116.660125, 40.021651],
                        [116.655629, 40.018566],
                        [116.651676, 40.021911],
                        [116.651195, 40.025759],
                        [116.636159, 40.019703],
                        [116.633504, 40.023664],
                        [116.627063, 40.021505],
                        [116.624239, 40.023664],
                        [116.620099, 40.022512],
                        [116.619388, 40.026733],
                        [116.614139, 40.028178],
                        [116.614055, 40.03175],
                        [116.610061, 40.031214],
                        [116.603683, 40.052949],
                        [116.608409, 40.054912],
                        [116.603473, 40.086811],
                        [116.602909, 40.093883],
                        [116.598392, 40.103874],
                        [116.598705, 40.09351],
                        [116.595903, 40.090218],
                        [116.580365, 40.088352],
                        [116.578316, 40.102739],
                        [116.574071, 40.107815],
                        [116.574322, 40.096138],
                        [116.578149, 40.076461],
                        [116.551757, 40.059765],
                        [116.547784, 40.062718],
                        [116.543183, 40.059408],
                        [116.534379, 40.066791],
                        [116.525993, 40.071334],
                        [116.513948, 40.070426],
                        [116.506775, 40.074352],
                        [116.49933, 40.080387],
                        [116.486657, 40.081036],
                        [116.482935, 40.083745],
                        [116.473545, 40.085562],
                        [116.471015, 40.08939],
                        [116.466832, 40.090185],
                        [116.466498, 40.094954],
                        [116.473357, 40.097516],
                        [116.480885, 40.096965],
                        [116.489292, 40.101668],
                        [116.492199, 40.111561],
                        [116.487222, 40.124678],
                        [116.484754, 40.140078],
                        [116.482307, 40.140629],
                        [116.480781, 40.14742],
                        [116.490777, 40.148992],
                        [116.492303, 40.156981],
                        [116.484629, 40.160465],
                        [116.477916, 40.159979],
                        [116.476912, 40.163576],
                        [116.480802, 40.171937],
                        [116.483332, 40.171742],
                        [116.485151, 40.176764],
                        [116.490129, 40.181316],
                        [116.487975, 40.184686],
                        [116.488016, 40.191796],
                        [116.484503, 40.196493],
                        [116.472249, 40.205092],
                        [116.473712, 40.221203],
                        [116.477979, 40.225201],
                        [116.483771, 40.225185],
                        [116.481094, 40.238248],
                        [116.482098, 40.245385],
                        [116.493705, 40.251179],
                        [116.501024, 40.251599],
                        [116.503011, 40.25969],
                        [116.505959, 40.261356],
                        [116.509201, 40.258056],
                        [116.523965, 40.257522],
                        [116.526181, 40.261324],
                        [116.535717, 40.261373],
                        [116.540088, 40.267165],
                        [116.53693, 40.277178],
                        [116.540904, 40.274946],
                        [116.546236, 40.276224],
                        [116.552176, 40.27383],
                        [116.566187, 40.27802],
                        [116.565371, 40.273377],
                        [116.570516, 40.273102],
                        [116.570202, 40.268863],
                        [116.58254, 40.268362],
                        [116.585238, 40.266226],
                        [116.588396, 40.269462],
                        [116.590842, 40.264139],
                        [116.599647, 40.265385],
                        [116.600755, 40.258978],
                        [116.604624, 40.256146],
                        [116.603787, 40.251324],
                        [116.61324, 40.251761],
                        [116.622044, 40.250467],
                        [116.6238, 40.252667],
                        [116.623654, 40.26058],
                        [116.63526, 40.261454],
                        [116.637038, 40.25846],
                        [116.641492, 40.259463],
                        [116.643081, 40.25715],
                        [116.648519, 40.260143],
                        [116.666901, 40.262085],
                        [116.669494, 40.253153],
                        [116.673321, 40.246777],
                        [116.668783, 40.238539],
                        [116.670247, 40.234865],
                        [116.676311, 40.238604],
                        [116.678131, 40.234379],
                        [116.684007, 40.234282],
                        [116.69072, 40.240886],
                        [116.697265, 40.243216],
                        [116.696554, 40.248072],
                        [116.704585, 40.251551],
                        [116.704668, 40.257101],
                        [116.710837, 40.256227],
                        [116.738421, 40.284392],
                        [116.738965, 40.284101],
                        [116.741098, 40.283001],
                        [116.738337, 40.278764],
                        [116.74298, 40.279087],
                        [116.752788, 40.275512],
                        [116.762658, 40.269058],
                        [116.768597, 40.270109],
                        [116.771651, 40.266501],
                        [116.773512, 40.269527],
                        [116.782964, 40.273248],
                        [116.784073, 40.279443],
                        [116.787795, 40.281449],
                        [116.788025, 40.289439],
                        [116.794487, 40.287417],
                        [116.800572, 40.289196],
                        [116.809607, 40.28601],
                        [116.811823, 40.282387],
                        [116.825123, 40.285347],
                        [116.82458, 40.290991],
                        [116.827215, 40.298333],
                        [116.830101, 40.299206],
                        [116.828992, 40.304413],
                        [116.838382, 40.310185],
                        [116.848984, 40.311204],
                        [116.854547, 40.303152],
                        [116.857182, 40.2929],
                        [116.859462, 40.290878],
                        [116.871319, 40.290943],
                        [116.871737, 40.281481],
                        [116.876338, 40.274348],
                        [116.874247, 40.268281],
                        [116.879893, 40.264139],
                        [116.881273, 40.259221],
                        [116.886104, 40.255256],
                        [116.886585, 40.251907],
                        [116.892252, 40.245709],
                        [116.894343, 40.240028],
                        [116.901746, 40.23684],
                        [116.893946, 40.233457],
                        [116.900701, 40.228763],
                        [116.906598, 40.228682],
                        [116.908606, 40.222401],
                        [116.913917, 40.220118],
                        [116.915507, 40.222271],
                        [116.922031, 40.220134],
                        [116.92544, 40.225768],
                        [116.931065, 40.230624],
                        [116.935206, 40.229847],
                        [116.940978, 40.223922],
                        [116.938029, 40.210549],
                        [116.929685, 40.211585],
                        [116.930898, 40.207084],
                        [116.939556, 40.192347],
                        [116.945913, 40.193141],
                        [116.94997, 40.186354],
                        [116.945809, 40.186224],
                        [116.945349, 40.1813],
                        [116.951371, 40.174788],
                        [116.962037, 40.175549],
                        [116.961242, 40.171937],
                        [116.968749, 40.163495],
                        [116.972054, 40.156301],
                        [116.977763, 40.151374],
                        [116.970025, 40.140321],
                        [116.967829, 40.129849],
                        [116.96578, 40.127823],
                        [116.971594, 40.124224],
                        [116.969189, 40.118776],
                        [116.971301, 40.114009],
                        [116.976069, 40.111188],
                        [116.973329, 40.103712],
                        [116.967976, 40.101214],
                        [116.975462, 40.095051],
                        [116.979938, 40.093867],
                        [116.981862, 40.089828],
                        [116.981192, 40.08149],
                        [116.986274, 40.078359],
                        [116.982844, 40.070685],
                        [116.980816, 40.071188],
                        [116.978599, 40.064893],
                        [116.973476, 40.066304],
                        [116.970652, 40.063805],
                        [116.962288, 40.063529],
                        [116.961932, 40.051358],
                        [116.945265, 40.041425],
                        [116.945014, 40.048631],
                        [116.937632, 40.046911],
                        [116.938824, 40.050887],
                        [116.931693, 40.052024],
                        [116.928096, 40.054929],
                        [116.924164, 40.047463],
                        [116.917974, 40.044704],
                        [116.914252, 40.052592],
                        [116.906431, 40.051423],
                        [116.90137, 40.047723],
                        [116.890265, 40.04597],
                        [116.88075, 40.046164],
                        [116.873619, 40.041522],
                        [116.867826, 40.041863],
                        [116.857809, 40.051894],
                        [116.850197, 40.054977],
                        [116.849486, 40.051926],
                        [116.831502, 40.051196],
                        [116.831732, 40.048485],
                        [116.822739, 40.046473],
                        [116.823158, 40.039834],
                        [116.820816, 40.038779],
                        [116.82, 40.028357],
                        [116.815295, 40.030905],
                        [116.803375, 40.032155],
                        [116.800259, 40.028844],
                        [116.789531, 40.032318],
                        [116.790221, 40.034477],
                        [116.781542, 40.034818],
                        [116.77782, 40.032448],
                        [116.777485, 40.027204],
                        [116.771755, 40.014474]
                    ]
                ],
                [
                    [
                        [116.578149, 40.076461],
                        [116.581411, 40.067846],
                        [116.58139, 40.073817],
                        [116.586597, 40.074336],
                        [116.590131, 40.056162],
                        [116.587957, 40.05053],
                        [116.591198, 40.051796],
                        [116.590006, 40.043616],
                        [116.599814, 40.041408],
                        [116.599417, 40.047171],
                        [116.601633, 40.047658],
                        [116.598517, 40.052543],
                        [116.603683, 40.052949],
                        [116.610061, 40.031214],
                        [116.602762, 40.028503],
                        [116.600839, 40.018858],
                        [116.595548, 40.01751],
                        [116.577814, 40.027512],
                        [116.578797, 40.033097],
                        [116.570474, 40.032431],
                        [116.564242, 40.039655],
                        [116.550753, 40.045499],
                        [116.54655, 40.048956],
                        [116.552761, 40.05488],
                        [116.551757, 40.059765],
                        [116.578149, 40.076461]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110114,
            "name": "昌平区",
            "center": [116.235906, 40.218085],
            "centroid": [116.210635, 40.215461],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 10,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.466832, 40.090185],
                        [116.466247, 40.08235],
                        [116.461855, 40.080825],
                        [116.462608, 40.076786],
                        [116.458823, 40.075796],
                        [116.458635, 40.070377],
                        [116.462127, 40.06731],
                        [116.459408, 40.059992],
                        [116.45142, 40.06129],
                        [116.451629, 40.058759],
                        [116.442867, 40.061323],
                        [116.433268, 40.06228],
                        [116.415618, 40.056],
                        [116.409595, 40.055626],
                        [116.406124, 40.049768],
                        [116.408884, 40.043291],
                        [116.405266, 40.038974],
                        [116.395333, 40.036766],
                        [116.39297, 40.041733],
                        [116.390649, 40.041279],
                        [116.38519, 40.042853],
                        [116.376888, 40.042756],
                        [116.376114, 40.045466],
                        [116.36959, 40.04696],
                        [116.367394, 40.053436],
                        [116.372999, 40.054344],
                        [116.372267, 40.05785],
                        [116.379272, 40.059002],
                        [116.382848, 40.061582],
                        [116.381928, 40.066402],
                        [116.373354, 40.065623],
                        [116.372538, 40.06843],
                        [116.363149, 40.068965],
                        [116.363023, 40.065931],
                        [116.357293, 40.066012],
                        [116.34667, 40.063659],
                        [116.346963, 40.06043],
                        [116.342676, 40.059635],
                        [116.343366, 40.055448],
                        [116.340271, 40.055091],
                        [116.338828, 40.058921],
                        [116.325946, 40.054799],
                        [116.318292, 40.061663],
                        [116.309446, 40.060609],
                        [116.305995, 40.063043],
                        [116.302942, 40.060803],
                        [116.290353, 40.083145],
                        [116.279897, 40.079754],
                        [116.2731, 40.092699],
                        [116.27333, 40.09557],
                        [116.265237, 40.094694],
                        [116.258273, 40.101522],
                        [116.263899, 40.10402],
                        [116.263334, 40.110588],
                        [116.258022, 40.11195],
                        [116.25957, 40.106907],
                        [116.255868, 40.104474],
                        [116.252732, 40.106517],
                        [116.245956, 40.10535],
                        [116.240498, 40.108009],
                        [116.243363, 40.113279],
                        [116.241836, 40.118403],
                        [116.245036, 40.118825],
                        [116.247043, 40.136204],
                        [116.233785, 40.136577],
                        [116.215445, 40.143174],
                        [116.212224, 40.140548],
                        [116.206285, 40.143092],
                        [116.205658, 40.150175],
                        [116.203211, 40.153773],
                        [116.202166, 40.160984],
                        [116.194282, 40.160076],
                        [116.192065, 40.155669],
                        [116.182696, 40.158099],
                        [116.183094, 40.153335],
                        [116.180417, 40.14729],
                        [116.174122, 40.143595],
                        [116.167681, 40.141844],
                        [116.168622, 40.135442],
                        [116.17178, 40.127936],
                        [116.167409, 40.128455],
                        [116.169563, 40.124564],
                        [116.152708, 40.121776],
                        [116.132925, 40.121354],
                        [116.132214, 40.115079],
                        [116.127676, 40.116393],
                        [116.113309, 40.115598],
                        [116.105864, 40.118014],
                        [116.102246, 40.115987],
                        [116.096056, 40.121257],
                        [116.089783, 40.119327],
                        [116.08445, 40.120252],
                        [116.077883, 40.115047],
                        [116.073847, 40.115436],
                        [116.072676, 40.109258],
                        [116.069456, 40.104912],
                        [116.062931, 40.10282],
                        [116.061969, 40.09956],
                        [116.055905, 40.09643],
                        [116.051848, 40.091661],
                        [116.048878, 40.085303],
                        [116.043775, 40.083502],
                        [116.037899, 40.084524],
                        [116.033926, 40.079657],
                        [116.030914, 40.082188],
                        [116.020856, 40.074579],
                        [116.007785, 40.080614],
                        [116.005129, 40.079803],
                        [115.99735, 40.082074],
                        [115.986434, 40.083469],
                        [115.979993, 40.081669],
                        [115.977232, 40.079041],
                        [115.968575, 40.075488],
                        [115.966588, 40.084556],
                        [115.960461, 40.092456],
                        [115.962092, 40.094419],
                        [115.962552, 40.10235],
                        [115.957449, 40.100679],
                        [115.956717, 40.096041],
                        [115.952681, 40.10102],
                        [115.943229, 40.103339],
                        [115.947913, 40.107409],
                        [115.933588, 40.124824],
                        [115.921438, 40.134485],
                        [115.906549, 40.138181],
                        [115.904457, 40.136123],
                        [115.900442, 40.138716],
                        [115.8816, 40.139073],
                        [115.874155, 40.14387],
                        [115.870768, 40.144276],
                        [115.865184, 40.148635],
                        [115.856547, 40.147468],
                        [115.853348, 40.149332],
                        [115.853557, 40.154162],
                        [115.84676, 40.163171],
                        [115.844418, 40.168016],
                        [115.846865, 40.169458],
                        [115.854205, 40.179939],
                        [115.848099, 40.183843],
                        [115.855502, 40.188865],
                        [115.863072, 40.186095],
                        [115.870308, 40.186079],
                        [115.873695, 40.192687],
                        [115.87633, 40.193918],
                        [115.877313, 40.200849],
                        [115.886326, 40.206663],
                        [115.883169, 40.209594],
                        [115.885072, 40.212039],
                        [115.883106, 40.216119],
                        [115.891366, 40.225379],
                        [115.891994, 40.228147],
                        [115.898476, 40.234509],
                        [115.898079, 40.236419],
                        [115.906695, 40.23412],
                        [115.911965, 40.234477],
                        [115.916628, 40.242391],
                        [115.916984, 40.247068],
                        [115.935826, 40.25558],
                        [115.942706, 40.253557],
                        [115.950276, 40.256163],
                        [115.960001, 40.256648],
                        [115.965605, 40.259415],
                        [115.968888, 40.264269],
                        [115.967006, 40.265612],
                        [115.976396, 40.270983],
                        [115.981812, 40.276903],
                        [115.978822, 40.281627],
                        [115.981227, 40.28525],
                        [115.978675, 40.289633],
                        [115.982732, 40.297977],
                        [115.990323, 40.299498],
                        [115.987919, 40.303799],
                        [115.975538, 40.308698],
                        [115.976417, 40.311511],
                        [115.973259, 40.318997],
                        [115.979658, 40.320532],
                        [115.982711, 40.324202],
                        [115.993398, 40.328986],
                        [115.999065, 40.325463],
                        [116.007597, 40.33314],
                        [116.01684, 40.33466],
                        [116.026481, 40.324283],
                        [116.026167, 40.320484],
                        [116.031144, 40.312352],
                        [116.040095, 40.312724],
                        [116.042479, 40.316846],
                        [116.051116, 40.315812],
                        [116.056971, 40.322181],
                        [116.053353, 40.326853],
                        [116.061802, 40.336809],
                        [116.06841, 40.336971],
                        [116.073429, 40.339831],
                        [116.077716, 40.339346],
                        [116.083342, 40.33571],
                        [116.086353, 40.330813],
                        [116.098649, 40.330005],
                        [116.102978, 40.331524],
                        [116.110381, 40.330813],
                        [116.116634, 40.323668],
                        [116.116237, 40.321955],
                        [116.122385, 40.312805],
                        [116.132737, 40.31198],
                        [116.141959, 40.316879],
                        [116.138383, 40.324671],
                        [116.13809, 40.330974],
                        [116.143904, 40.336082],
                        [116.137651, 40.336534],
                        [116.137567, 40.340769],
                        [116.140809, 40.343047],
                        [116.138404, 40.345229],
                        [116.144782, 40.348541],
                        [116.147543, 40.340655],
                        [116.144719, 40.336631],
                        [116.152603, 40.337714],
                        [116.155677, 40.344906],
                        [116.1507, 40.349252],
                        [116.145514, 40.351046],
                        [116.148651, 40.35696],
                        [116.148233, 40.361807],
                        [116.159295, 40.366265],
                        [116.168789, 40.366718],
                        [116.170713, 40.369351],
                        [116.177154, 40.370934],
                        [116.180354, 40.367687],
                        [116.192985, 40.372775],
                        [116.209129, 40.376232],
                        [116.211451, 40.381756],
                        [116.222221, 40.382111],
                        [116.226989, 40.38111],
                        [116.23184, 40.374988],
                        [116.23665, 40.377427],
                        [116.241962, 40.377508],
                        [116.24353, 40.379818],
                        [116.247796, 40.374471],
                        [116.252104, 40.376297],
                        [116.25338, 40.381239],
                        [116.258336, 40.383193],
                        [116.261264, 40.380561],
                        [116.270863, 40.382693],
                        [116.282845, 40.375263],
                        [116.290729, 40.383177],
                        [116.289872, 40.391672],
                        [116.293762, 40.392415],
                        [116.295581, 40.384437],
                        [116.302691, 40.387473],
                        [116.313106, 40.389459],
                        [116.32078, 40.386859],
                        [116.32398, 40.387295],
                        [116.337364, 40.379769],
                        [116.34506, 40.373163],
                        [116.355369, 40.37137],
                        [116.360033, 40.366815],
                        [116.357356, 40.364084],
                        [116.352797, 40.364391],
                        [116.348866, 40.356427],
                        [116.355641, 40.356814],
                        [116.363923, 40.359028],
                        [116.369673, 40.356362],
                        [116.367101, 40.350351],
                        [116.364508, 40.349107],
                        [116.369903, 40.342401],
                        [116.368231, 40.334805],
                        [116.365909, 40.331702],
                        [116.376135, 40.334352],
                        [116.375069, 40.337375],
                        [116.384563, 40.339055],
                        [116.391422, 40.338393],
                        [116.396358, 40.334853],
                        [116.408633, 40.334886],
                        [116.408989, 40.333205],
                        [116.417061, 40.329843],
                        [116.424359, 40.331265],
                        [116.427914, 40.329213],
                        [116.43423, 40.329116],
                        [116.438245, 40.333221],
                        [116.443745, 40.322682],
                        [116.449182, 40.32113],
                        [116.455184, 40.316345],
                        [116.44822, 40.305982],
                        [116.443766, 40.302457],
                        [116.448011, 40.300484],
                        [116.45096, 40.293045],
                        [116.449412, 40.286722],
                        [116.45533, 40.284845],
                        [116.460308, 40.28711],
                        [116.469634, 40.283001],
                        [116.472081, 40.280122],
                        [116.478794, 40.280025],
                        [116.484001, 40.2759],
                        [116.484273, 40.267634],
                        [116.493245, 40.262489],
                        [116.501839, 40.262974],
                        [116.505959, 40.261356],
                        [116.503011, 40.25969],
                        [116.501024, 40.251599],
                        [116.493705, 40.251179],
                        [116.482098, 40.245385],
                        [116.481094, 40.238248],
                        [116.483771, 40.225185],
                        [116.477979, 40.225201],
                        [116.473712, 40.221203],
                        [116.472249, 40.205092],
                        [116.484503, 40.196493],
                        [116.488016, 40.191796],
                        [116.487975, 40.184686],
                        [116.490129, 40.181316],
                        [116.485151, 40.176764],
                        [116.483332, 40.171742],
                        [116.480802, 40.171937],
                        [116.476912, 40.163576],
                        [116.477916, 40.159979],
                        [116.484629, 40.160465],
                        [116.492303, 40.156981],
                        [116.490777, 40.148992],
                        [116.480781, 40.14742],
                        [116.482307, 40.140629],
                        [116.484754, 40.140078],
                        [116.487222, 40.124678],
                        [116.492199, 40.111561],
                        [116.489292, 40.101668],
                        [116.480885, 40.096965],
                        [116.473357, 40.097516],
                        [116.466498, 40.094954],
                        [116.466832, 40.090185]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110115,
            "name": "大兴区",
            "center": [116.338033, 39.728908],
            "centroid": [116.421058, 39.649884],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 11,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.534944, 39.82482],
                        [116.539586, 39.821563],
                        [116.533375, 39.819658],
                        [116.538373, 39.81513],
                        [116.546634, 39.803501],
                        [116.555145, 39.793548],
                        [116.562423, 39.796936],
                        [116.565078, 39.793988],
                        [116.574677, 39.798386],
                        [116.594377, 39.776685],
                        [116.576957, 39.771943],
                        [116.561565, 39.771111],
                        [116.548119, 39.765554],
                        [116.540716, 39.760502],
                        [116.536408, 39.753917],
                        [116.527562, 39.743304],
                        [116.53624, 39.740663],
                        [116.537997, 39.738071],
                        [116.532413, 39.73962],
                        [116.531849, 39.730016],
                        [116.53783, 39.728043],
                        [116.536972, 39.72152],
                        [116.534609, 39.718079],
                        [116.52936, 39.719808],
                        [116.527332, 39.716578],
                        [116.53256, 39.71529],
                        [116.530552, 39.713268],
                        [116.535676, 39.711881],
                        [116.544961, 39.715045],
                        [116.573276, 39.714507],
                        [116.573464, 39.709125],
                        [116.579884, 39.710234],
                        [116.581202, 39.712517],
                        [116.590152, 39.713349],
                        [116.590194, 39.711522],
                        [116.598371, 39.711963],
                        [116.604017, 39.714752],
                        [116.604561, 39.718731],
                        [116.609141, 39.719367],
                        [116.616251, 39.725581],
                        [116.621876, 39.725825],
                        [116.621646, 39.728076],
                        [116.628129, 39.727749],
                        [116.631203, 39.722971],
                        [116.637623, 39.723934],
                        [116.638502, 39.717166],
                        [116.644587, 39.709647],
                        [116.652994, 39.708619],
                        [116.653098, 39.703823],
                        [116.647912, 39.703579],
                        [116.64626, 39.700447],
                        [116.647097, 39.694786],
                        [116.651509, 39.694459],
                        [116.651321, 39.687868],
                        [116.658097, 39.686155],
                        [116.65818, 39.68857],
                        [116.666566, 39.687101],
                        [116.669577, 39.683642],
                        [116.666022, 39.679693],
                        [116.668574, 39.674602],
                        [116.675203, 39.676234],
                        [116.680786, 39.674896],
                        [116.685554, 39.676886],
                        [116.692706, 39.676789],
                        [116.693543, 39.674944],
                        [116.703769, 39.674145],
                        [116.704857, 39.667192],
                        [116.702138, 39.657644],
                        [116.702891, 39.649923],
                        [116.70609, 39.642903],
                        [116.710419, 39.639686],
                        [116.716003, 39.640356],
                        [116.723489, 39.639033],
                        [116.721398, 39.629415],
                        [116.725518, 39.624075],
                        [116.721858, 39.621756],
                        [116.716149, 39.62156],
                        [116.70929, 39.618114],
                        [116.705338, 39.621462],
                        [116.700737, 39.62107],
                        [116.702577, 39.610421],
                        [116.718282, 39.603021],
                        [116.718324, 39.601077],
                        [116.724953, 39.598006],
                        [116.727065, 39.593055],
                        [116.705108, 39.587974],
                        [116.700695, 39.590964],
                        [116.699127, 39.595457],
                        [116.696408, 39.595392],
                        [116.694087, 39.601355],
                        [116.6889, 39.598496],
                        [116.669975, 39.603381],
                        [116.670037, 39.604916],
                        [116.662384, 39.60521],
                        [116.6568, 39.602776],
                        [116.657678, 39.60075],
                        [116.646532, 39.599117],
                        [116.645549, 39.60209],
                        [116.635595, 39.604818],
                        [116.635407, 39.599934],
                        [116.628338, 39.599558],
                        [116.620517, 39.601665],
                        [116.620182, 39.606893],
                        [116.616857, 39.607301],
                        [116.616648, 39.614096],
                        [116.613177, 39.613802],
                        [116.611755, 39.618882],
                        [116.607781, 39.619698],
                        [116.607886, 39.624696],
                        [116.602177, 39.624533],
                        [116.600128, 39.619649],
                        [116.593561, 39.618588],
                        [116.591993, 39.621299],
                        [116.579194, 39.623487],
                        [116.579382, 39.619666],
                        [116.565936, 39.61978],
                        [116.565978, 39.616138],
                        [116.569637, 39.61176],
                        [116.566103, 39.61114],
                        [116.566605, 39.604361],
                        [116.562276, 39.601714],
                        [116.557132, 39.601502],
                        [116.549436, 39.596143],
                        [116.544187, 39.596519],
                        [116.544124, 39.603609],
                        [116.540883, 39.60142],
                        [116.541803, 39.59348],
                        [116.530866, 39.596715],
                        [116.530615, 39.598774],
                        [116.524446, 39.596535],
                        [116.525052, 39.593807],
                        [116.521267, 39.590229],
                        [116.52317, 39.586242],
                        [116.519699, 39.581863],
                        [116.520389, 39.577156],
                        [116.52614, 39.577271],
                        [116.527248, 39.57294],
                        [116.520389, 39.57191],
                        [116.519385, 39.566484],
                        [116.511564, 39.565503],
                        [116.510581, 39.560502],
                        [116.50805, 39.560256],
                        [116.508448, 39.551053],
                        [116.489773, 39.550268],
                        [116.48948, 39.553472],
                        [116.473378, 39.553096],
                        [116.470952, 39.5546],
                        [116.475134, 39.545756],
                        [116.47802, 39.543205],
                        [116.478188, 39.535487],
                        [116.468819, 39.534359],
                        [116.464595, 39.531628],
                        [116.464553, 39.527638],
                        [116.453846, 39.528652],
                        [116.45372, 39.526477],
                        [116.440985, 39.527311],
                        [116.436802, 39.526346],
                        [116.439876, 39.523353],
                        [116.440378, 39.516271],
                        [116.442741, 39.516189],
                        [116.443829, 39.509875],
                        [116.433017, 39.507438],
                        [116.431699, 39.51053],
                        [116.424631, 39.509728],
                        [116.423125, 39.516337],
                        [116.424046, 39.522732],
                        [116.421473, 39.525103],
                        [116.411247, 39.524678],
                        [116.402652, 39.526886],
                        [116.40282, 39.51439],
                        [116.407253, 39.512116],
                        [116.40857, 39.508011],
                        [116.418734, 39.506391],
                        [116.422895, 39.496608],
                        [116.418504, 39.496575],
                        [116.415827, 39.48823],
                        [116.411582, 39.485105],
                        [116.412376, 39.482077],
                        [116.423544, 39.485154],
                        [116.427329, 39.487788],
                        [116.429964, 39.481325],
                        [116.425342, 39.481259],
                        [116.428333, 39.476219],
                        [116.433644, 39.478183],
                        [116.436258, 39.482912],
                        [116.444142, 39.482192],
                        [116.444059, 39.47887],
                        [116.448764, 39.476284],
                        [116.448638, 39.465122],
                        [116.453992, 39.45751],
                        [116.454682, 39.453302],
                        [116.450667, 39.452648],
                        [116.450353, 39.448522],
                        [116.437241, 39.445951],
                        [116.434397, 39.442758],
                        [116.425635, 39.446885],
                        [116.408947, 39.450257],
                        [116.399787, 39.450044],
                        [116.391903, 39.452893],
                        [116.388557, 39.450732],
                        [116.373563, 39.452058],
                        [116.367791, 39.451633],
                        [116.362187, 39.454874],
                        [116.351124, 39.455529],
                        [116.350162, 39.45291],
                        [116.334499, 39.457019],
                        [116.325611, 39.462961],
                        [116.325088, 39.466153],
                        [116.320048, 39.468543],
                        [116.319944, 39.473436],
                        [116.314779, 39.476104],
                        [116.312708, 39.480556],
                        [116.306957, 39.485023],
                        [116.305284, 39.489179],
                        [116.283201, 39.493941],
                        [116.279269, 39.491306],
                        [116.275631, 39.495201],
                        [116.269315, 39.495495],
                        [116.257939, 39.500518],
                        [116.25706, 39.505491],
                        [116.253861, 39.510055],
                        [116.245831, 39.514897],
                        [116.246709, 39.520098],
                        [116.24353, 39.524236],
                        [116.246479, 39.525299],
                        [116.248256, 39.530271],
                        [116.245601, 39.53014],
                        [116.246521, 39.539788],
                        [116.242505, 39.552966],
                        [116.246186, 39.557167],
                        [116.243007, 39.55836],
                        [116.240644, 39.564098],
                        [116.234684, 39.563934],
                        [116.236462, 39.568396],
                        [116.229373, 39.565471],
                        [116.225817, 39.568151],
                        [116.221175, 39.578921],
                        [116.225085, 39.584085],
                        [116.226089, 39.591993],
                        [116.222597, 39.593938],
                        [116.223141, 39.597222],
                        [116.21808, 39.608102],
                        [116.219502, 39.618931],
                        [116.218875, 39.628011],
                        [116.215487, 39.64305],
                        [116.216992, 39.651572],
                        [116.223162, 39.664728],
                        [116.221342, 39.667486],
                        [116.22565, 39.67359],
                        [116.221238, 39.678453],
                        [116.230941, 39.692355],
                        [116.23435, 39.703823],
                        [116.231945, 39.706025],
                        [116.236629, 39.71286],
                        [116.245036, 39.718421],
                        [116.245768, 39.72408],
                        [116.248466, 39.728027],
                        [116.248026, 39.732641],
                        [116.243948, 39.741658],
                        [116.251895, 39.749092],
                        [116.252481, 39.758676],
                        [116.254426, 39.76324],
                        [116.252481, 39.771747],
                        [116.253777, 39.77952],
                        [116.251602, 39.782518],
                        [116.251519, 39.793059],
                        [116.259298, 39.797621],
                        [116.262184, 39.792782],
                        [116.27423, 39.796936],
                        [116.287237, 39.799103],
                        [116.289182, 39.795894],
                        [116.296083, 39.795568],
                        [116.291148, 39.793271],
                        [116.295205, 39.790958],
                        [116.301541, 39.774941],
                        [116.307062, 39.770085],
                        [116.31068, 39.772057],
                        [116.317978, 39.783447],
                        [116.321784, 39.783626],
                        [116.322872, 39.798386],
                        [116.326824, 39.798386],
                        [116.328225, 39.801416],
                        [116.340124, 39.802149],
                        [116.341755, 39.807589],
                        [116.355704, 39.805668],
                        [116.356833, 39.800471],
                        [116.367039, 39.79982],
                        [116.368189, 39.794819],
                        [116.365742, 39.794151],
                        [116.367582, 39.784962],
                        [116.378478, 39.785646],
                        [116.379209, 39.77939],
                        [116.385609, 39.778852],
                        [116.390649, 39.780465],
                        [116.391903, 39.765277],
                        [116.398888, 39.765864],
                        [116.397905, 39.781068],
                        [116.396023, 39.786738],
                        [116.42024, 39.787439],
                        [116.421034, 39.794134],
                        [116.429274, 39.794102],
                        [116.429399, 39.803583],
                        [116.425719, 39.805358],
                        [116.422456, 39.81044],
                        [116.417772, 39.81013],
                        [116.415262, 39.812525],
                        [116.410013, 39.811336],
                        [116.41016, 39.817052],
                        [116.419759, 39.815375],
                        [116.418441, 39.822915],
                        [116.414426, 39.824282],
                        [116.415785, 39.829428],
                        [116.420072, 39.826611],
                        [116.425217, 39.831903],
                        [116.430068, 39.830112],
                        [116.43699, 39.830649],
                        [116.436677, 39.827425],
                        [116.44592, 39.826692],
                        [116.443912, 39.82096],
                        [116.452737, 39.823012],
                        [116.462775, 39.815945],
                        [116.468463, 39.814511],
                        [116.474256, 39.809772],
                        [116.485256, 39.81272],
                        [116.485632, 39.816889],
                        [116.495357, 39.818795],
                        [116.498201, 39.8157],
                        [116.505813, 39.817866],
                        [116.502801, 39.819006],
                        [116.510142, 39.821449],
                        [116.510602, 39.827637],
                        [116.516164, 39.829835],
                        [116.525366, 39.829754],
                        [116.525868, 39.826904],
                        [116.534944, 39.82482]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110116,
            "name": "怀柔区",
            "center": [116.637122, 40.324272],
            "centroid": [116.586079, 40.63069],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 12,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.289872, 40.391672],
                        [116.286003, 40.396032],
                        [116.289746, 40.402539],
                        [116.287864, 40.404719],
                        [116.291608, 40.408448],
                        [116.288513, 40.413437],
                        [116.289433, 40.418021],
                        [116.291942, 40.416617],
                        [116.296648, 40.420701],
                        [116.294452, 40.429304],
                        [116.290667, 40.435856],
                        [116.289788, 40.440907],
                        [116.294368, 40.449975],
                        [116.293824, 40.452831],
                        [116.300955, 40.458429],
                        [116.306853, 40.466092],
                        [116.301646, 40.468108],
                        [116.294786, 40.47535],
                        [116.291691, 40.485317],
                        [116.29717, 40.486768],
                        [116.303779, 40.485817],
                        [116.31022, 40.491702],
                        [116.31321, 40.491799],
                        [116.323227, 40.500151],
                        [116.330567, 40.500748],
                        [116.336653, 40.498636],
                        [116.34232, 40.500457],
                        [116.348636, 40.499071],
                        [116.357042, 40.501941],
                        [116.365909, 40.499635],
                        [116.369632, 40.500312],
                        [116.377537, 40.49683],
                        [116.378603, 40.491525],
                        [116.376825, 40.485736],
                        [116.387344, 40.482043],
                        [116.38609, 40.475802],
                        [116.393702, 40.47256],
                        [116.4065, 40.481995],
                        [116.413673, 40.481527],
                        [116.416664, 40.483011],
                        [116.420971, 40.480301],
                        [116.433142, 40.478189],
                        [116.443201, 40.481801],
                        [116.455937, 40.480914],
                        [116.457903, 40.488445],
                        [116.465577, 40.48701],
                        [116.468212, 40.48493],
                        [116.483541, 40.484994],
                        [116.487347, 40.481737],
                        [116.492157, 40.481027],
                        [116.508322, 40.483172],
                        [116.511543, 40.486929],
                        [116.519092, 40.491799],
                        [116.519155, 40.496604],
                        [116.51194, 40.501135],
                        [116.506398, 40.508212],
                        [116.500459, 40.510904],
                        [116.497762, 40.518093],
                        [116.492073, 40.518093],
                        [116.488581, 40.515853],
                        [116.476306, 40.514192],
                        [116.470345, 40.518963],
                        [116.46587, 40.518802],
                        [116.460956, 40.524363],
                        [116.467125, 40.530068],
                        [116.470617, 40.535418],
                        [116.479651, 40.541396],
                        [116.484587, 40.552867],
                        [116.496277, 40.555106],
                        [116.499999, 40.560921],
                        [116.505144, 40.562581],
                        [116.509577, 40.57276],
                        [116.513153, 40.572792],
                        [116.517796, 40.579749],
                        [116.525136, 40.583002],
                        [116.531577, 40.59131],
                        [116.530929, 40.595883],
                        [116.535948, 40.59944],
                        [116.532915, 40.606459],
                        [116.535634, 40.615698],
                        [116.538938, 40.619673],
                        [116.539294, 40.625612],
                        [116.545003, 40.627076],
                        [116.551674, 40.625209],
                        [116.561231, 40.628557],
                        [116.568989, 40.625483],
                        [116.574092, 40.631678],
                        [116.573903, 40.63628],
                        [116.563886, 40.636908],
                        [116.55389, 40.642877],
                        [116.551151, 40.642828],
                        [116.550335, 40.647606],
                        [116.545023, 40.650116],
                        [116.544103, 40.653767],
                        [116.540046, 40.656679],
                        [116.529507, 40.654588],
                        [116.527039, 40.6584],
                        [116.518381, 40.660925],
                        [116.520096, 40.66411],
                        [116.517273, 40.665734],
                        [116.513488, 40.672344],
                        [116.505938, 40.673067],
                        [116.501568, 40.671186],
                        [116.492826, 40.673984],
                        [116.487138, 40.674338],
                        [116.483374, 40.679403],
                        [116.488811, 40.69196],
                        [116.496653, 40.696879],
                        [116.502676, 40.697361],
                        [116.501066, 40.70228],
                        [116.501923, 40.706796],
                        [116.506064, 40.710879],
                        [116.503115, 40.715893],
                        [116.504119, 40.720135],
                        [116.506858, 40.720039],
                        [116.510748, 40.72645],
                        [116.509493, 40.73548],
                        [116.513697, 40.741456],
                        [116.506461, 40.743432],
                        [116.501819, 40.746581],
                        [116.502906, 40.756635],
                        [116.50025, 40.760811],
                        [116.495482, 40.759735],
                        [116.491404, 40.7633],
                        [116.485193, 40.765179],
                        [116.4803, 40.771586],
                        [116.471517, 40.771233],
                        [116.465452, 40.772742],
                        [116.465849, 40.774525],
                        [116.460663, 40.78244],
                        [116.461416, 40.78854],
                        [116.457233, 40.7983],
                        [116.452152, 40.798059],
                        [116.450981, 40.801927],
                        [116.440002, 40.809133],
                        [116.439897, 40.815038],
                        [116.436823, 40.820735],
                        [116.422477, 40.822772],
                        [116.414991, 40.829318],
                        [116.406458, 40.833361],
                        [116.406145, 40.837933],
                        [116.399306, 40.850492],
                        [116.391778, 40.854838],
                        [116.389707, 40.861814],
                        [116.38174, 40.863465],
                        [116.374881, 40.871531],
                        [116.366599, 40.876645],
                        [116.365972, 40.880188],
                        [116.360514, 40.884885],
                        [116.353864, 40.887786],
                        [116.344683, 40.894694],
                        [116.342236, 40.899887],
                        [116.334436, 40.90463],
                        [116.33544, 40.910495],
                        [116.334122, 40.920829],
                        [116.338828, 40.925732],
                        [116.339894, 40.929416],
                        [116.35012, 40.936048],
                        [116.358925, 40.93608],
                        [116.364801, 40.942999],
                        [116.370343, 40.943655],
                        [116.379941, 40.935775],
                        [116.379732, 40.933228],
                        [116.384019, 40.928535],
                        [116.384877, 40.922848],
                        [116.39274, 40.913123],
                        [116.396316, 40.911264],
                        [116.398533, 40.906024],
                        [116.404764, 40.905736],
                        [116.413715, 40.899758],
                        [116.418922, 40.902339],
                        [116.430905, 40.903364],
                        [116.436614, 40.89939],
                        [116.448492, 40.899919],
                        [116.45073, 40.901345],
                        [116.458676, 40.900592],
                        [116.464344, 40.896329],
                        [116.474047, 40.896008],
                        [116.477581, 40.901746],
                        [116.473608, 40.91974],
                        [116.468422, 40.925091],
                        [116.467209, 40.931322],
                        [116.461541, 40.932684],
                        [116.462315, 40.935231],
                        [116.455372, 40.945433],
                        [116.454829, 40.949533],
                        [116.447446, 40.95384],
                        [116.453302, 40.964584],
                        [116.451713, 40.968667],
                        [116.455519, 40.980481],
                        [116.464135, 40.984498],
                        [116.474193, 40.978608],
                        [116.47894, 40.979104],
                        [116.485612, 40.982465],
                        [116.493726, 40.977919],
                        [116.496737, 40.978432],
                        [116.504516, 40.975919],
                        [116.51629, 40.975198],
                        [116.519573, 40.981569],
                        [116.524718, 40.981073],
                        [116.533417, 40.985698],
                        [116.535634, 40.988675],
                        [116.541991, 40.99026],
                        [116.547826, 40.988003],
                        [116.558617, 40.988627],
                        [116.561231, 40.993461],
                        [116.569177, 40.991636],
                        [116.574928, 40.986307],
                        [116.589692, 40.976703],
                        [116.597764, 40.97475],
                        [116.614515, 40.983314],
                        [116.617067, 40.998725],
                        [116.614892, 41.003574],
                        [116.619179, 41.01423],
                        [116.621897, 41.015749],
                        [116.62288, 41.020693],
                        [116.621228, 41.028978],
                        [116.617589, 41.034704],
                        [116.614118, 41.036096],
                        [116.613491, 41.040782],
                        [116.617736, 41.048649],
                        [116.61646, 41.053382],
                        [116.624093, 41.054437],
                        [116.630848, 41.0608],
                        [116.637937, 41.060497],
                        [116.641158, 41.058322],
                        [116.647431, 41.059393],
                        [116.653914, 41.05626],
                        [116.657009, 41.051303],
                        [116.665207, 41.046682],
                        [116.673279, 41.046378],
                        [116.67698, 41.042732],
                        [116.682878, 41.041789],
                        [116.688629, 41.044651],
                        [116.692246, 41.040813],
                        [116.691347, 41.037503],
                        [116.69509, 41.033265],
                        [116.695739, 41.025396],
                        [116.698855, 41.021253],
                        [116.693836, 41.013686],
                        [116.690866, 41.012982],
                        [116.69095, 41.007254],
                        [116.683066, 41.000486],
                        [116.682543, 40.986259],
                        [116.685304, 40.982641],
                        [116.681267, 40.980737],
                        [116.677921, 40.975983],
                        [116.677921, 40.970972],
                        [116.687248, 40.962551],
                        [116.689298, 40.951118],
                        [116.696178, 40.94452],
                        [116.702368, 40.940628],
                        [116.702786, 40.936512],
                        [116.70722, 40.934029],
                        [116.712197, 40.934846],
                        [116.713891, 40.929416],
                        [116.722318, 40.92743],
                        [116.717111, 40.921695],
                        [116.713347, 40.910431],
                        [116.716881, 40.910175],
                        [116.723678, 40.906313],
                        [116.726145, 40.901185],
                        [116.730432, 40.897771],
                        [116.739759, 40.896665],
                        [116.750257, 40.891665],
                        [116.759501, 40.889854],
                        [116.758539, 40.881983],
                        [116.762135, 40.880765],
                        [116.769392, 40.882961],
                        [116.772362, 40.87852],
                        [116.776795, 40.878376],
                        [116.797226, 40.860034],
                        [116.796996, 40.854886],
                        [116.802413, 40.851198],
                        [116.802496, 40.842392],
                        [116.805947, 40.840836],
                        [116.813622, 40.848423],
                        [116.820732, 40.848263],
                        [116.823471, 40.842681],
                        [116.828009, 40.841109],
                        [116.831815, 40.842585],
                        [116.837775, 40.841542],
                        [116.839741, 40.839024],
                        [116.84819, 40.839313],
                        [116.848587, 40.837147],
                        [116.855425, 40.835447],
                        [116.860633, 40.830457],
                        [116.861448, 40.825356],
                        [116.870378, 40.821601],
                        [116.876171, 40.8212],
                        [116.876735, 40.818456],
                        [116.882172, 40.814172],
                        [116.880207, 40.804367],
                        [116.886961, 40.801076],
                        [116.878575, 40.797545],
                        [116.873326, 40.798781],
                        [116.871277, 40.794785],
                        [116.862577, 40.792858],
                        [116.867471, 40.784559],
                        [116.858039, 40.78305],
                        [116.856806, 40.77955],
                        [116.851264, 40.778924],
                        [116.850448, 40.775006],
                        [116.834785, 40.770221],
                        [116.840076, 40.760682],
                        [116.831795, 40.751303],
                        [116.826211, 40.749343],
                        [116.818662, 40.75042],
                        [116.810527, 40.749118],
                        [116.802977, 40.745986],
                        [116.793629, 40.748267],
                        [116.783759, 40.757631],
                        [116.780727, 40.751512],
                        [116.782818, 40.747817],
                        [116.786352, 40.736026],
                        [116.790472, 40.728973],
                        [116.789091, 40.712454],
                        [116.786687, 40.7103],
                        [116.787105, 40.704482],
                        [116.783989, 40.700496],
                        [116.769246, 40.70281],
                        [116.762867, 40.706427],
                        [116.756155, 40.705687],
                        [116.754963, 40.702891],
                        [116.748668, 40.700544],
                        [116.747518, 40.697072],
                        [116.74252, 40.69593],
                        [116.735807, 40.69167],
                        [116.725581, 40.689114],
                        [116.725413, 40.68466],
                        [116.714915, 40.680014],
                        [116.713221, 40.669867],
                        [116.714309, 40.666104],
                        [116.709855, 40.662598],
                        [116.712636, 40.653896],
                        [116.711151, 40.648218],
                        [116.712197, 40.641268],
                        [116.70149, 40.632917],
                        [116.70195, 40.628444],
                        [116.705128, 40.626947],
                        [116.704689, 40.620076],
                        [116.701322, 40.621379],
                        [116.697955, 40.618402],
                        [116.702598, 40.612785],
                        [116.70655, 40.610998],
                        [116.707993, 40.606507],
                        [116.705609, 40.60303],
                        [116.711235, 40.600213],
                        [116.708495, 40.595206],
                        [116.711611, 40.59189],
                        [116.708955, 40.590054],
                        [116.714351, 40.58028],
                        [116.71456, 40.570682],
                        [116.710503, 40.568685],
                        [116.709855, 40.565512],
                        [116.699336, 40.563563],
                        [116.686349, 40.564497],
                        [116.679636, 40.562001],
                        [116.682397, 40.556766],
                        [116.66872, 40.557507],
                        [116.665771, 40.552432],
                        [116.67698, 40.554462],
                        [116.68225, 40.548904],
                        [116.690699, 40.549468],
                        [116.702138, 40.545456],
                        [116.701469, 40.539913],
                        [116.706948, 40.532582],
                        [116.712573, 40.529955],
                        [116.717216, 40.524798],
                        [116.712239, 40.522058],
                        [116.711402, 40.516465],
                        [116.701071, 40.510549],
                        [116.699106, 40.50444],
                        [116.698353, 40.493266],
                        [116.693376, 40.490783],
                        [116.694149, 40.485462],
                        [116.704334, 40.479043],
                        [116.69348, 40.481704],
                        [116.693397, 40.476108],
                        [116.695571, 40.466721],
                        [116.698667, 40.468043],
                        [116.706174, 40.459929],
                        [116.716902, 40.457074],
                        [116.719223, 40.460397],
                        [116.723594, 40.458542],
                        [116.7196, 40.455735],
                        [116.719265, 40.448636],
                        [116.725811, 40.443085],
                        [116.72098, 40.440988],
                        [116.716421, 40.441714],
                        [116.723552, 40.435065],
                        [116.722339, 40.423832],
                        [116.72556, 40.418053],
                        [116.73244, 40.420604],
                        [116.733235, 40.418312],
                        [116.741139, 40.414631],
                        [116.728801, 40.40982],
                        [116.724389, 40.409191],
                        [116.723427, 40.405316],
                        [116.718512, 40.402055],
                        [116.713242, 40.40157],
                        [116.713849, 40.395806],
                        [116.711716, 40.386908],
                        [116.716254, 40.384114],
                        [116.707115, 40.377007],
                        [116.706509, 40.373809],
                        [116.714079, 40.368608],
                        [116.719872, 40.369044],
                        [116.718094, 40.361338],
                        [116.726773, 40.361193],
                        [116.725769, 40.355619],
                        [116.729031, 40.355619],
                        [116.727484, 40.346522],
                        [116.723887, 40.344033],
                        [116.722967, 40.339152],
                        [116.731185, 40.339023],
                        [116.73129, 40.335031],
                        [116.744046, 40.339136],
                        [116.744653, 40.333706],
                        [116.751491, 40.335742],
                        [116.758559, 40.333884],
                        [116.759689, 40.326853],
                        [116.762846, 40.326707],
                        [116.768639, 40.317816],
                        [116.773324, 40.315973],
                        [116.762888, 40.310428],
                        [116.756845, 40.302586],
                        [116.754461, 40.303686],
                        [116.738965, 40.284101],
                        [116.738421, 40.284392],
                        [116.710837, 40.256227],
                        [116.704668, 40.257101],
                        [116.704585, 40.251551],
                        [116.696554, 40.248072],
                        [116.697265, 40.243216],
                        [116.69072, 40.240886],
                        [116.684007, 40.234282],
                        [116.678131, 40.234379],
                        [116.676311, 40.238604],
                        [116.670247, 40.234865],
                        [116.668783, 40.238539],
                        [116.673321, 40.246777],
                        [116.669494, 40.253153],
                        [116.666901, 40.262085],
                        [116.648519, 40.260143],
                        [116.643081, 40.25715],
                        [116.641492, 40.259463],
                        [116.637038, 40.25846],
                        [116.63526, 40.261454],
                        [116.623654, 40.26058],
                        [116.6238, 40.252667],
                        [116.622044, 40.250467],
                        [116.61324, 40.251761],
                        [116.603787, 40.251324],
                        [116.604624, 40.256146],
                        [116.600755, 40.258978],
                        [116.599647, 40.265385],
                        [116.590842, 40.264139],
                        [116.588396, 40.269462],
                        [116.585238, 40.266226],
                        [116.58254, 40.268362],
                        [116.570202, 40.268863],
                        [116.570516, 40.273102],
                        [116.565371, 40.273377],
                        [116.566187, 40.27802],
                        [116.552176, 40.27383],
                        [116.546236, 40.276224],
                        [116.540904, 40.274946],
                        [116.53693, 40.277178],
                        [116.540088, 40.267165],
                        [116.535717, 40.261373],
                        [116.526181, 40.261324],
                        [116.523965, 40.257522],
                        [116.509201, 40.258056],
                        [116.505959, 40.261356],
                        [116.501839, 40.262974],
                        [116.493245, 40.262489],
                        [116.484273, 40.267634],
                        [116.484001, 40.2759],
                        [116.478794, 40.280025],
                        [116.472081, 40.280122],
                        [116.469634, 40.283001],
                        [116.460308, 40.28711],
                        [116.45533, 40.284845],
                        [116.449412, 40.286722],
                        [116.45096, 40.293045],
                        [116.448011, 40.300484],
                        [116.443766, 40.302457],
                        [116.44822, 40.305982],
                        [116.455184, 40.316345],
                        [116.449182, 40.32113],
                        [116.443745, 40.322682],
                        [116.438245, 40.333221],
                        [116.43423, 40.329116],
                        [116.427914, 40.329213],
                        [116.424359, 40.331265],
                        [116.417061, 40.329843],
                        [116.408989, 40.333205],
                        [116.408633, 40.334886],
                        [116.396358, 40.334853],
                        [116.391422, 40.338393],
                        [116.384563, 40.339055],
                        [116.375069, 40.337375],
                        [116.376135, 40.334352],
                        [116.365909, 40.331702],
                        [116.368231, 40.334805],
                        [116.369903, 40.342401],
                        [116.364508, 40.349107],
                        [116.367101, 40.350351],
                        [116.369673, 40.356362],
                        [116.363923, 40.359028],
                        [116.355641, 40.356814],
                        [116.348866, 40.356427],
                        [116.352797, 40.364391],
                        [116.357356, 40.364084],
                        [116.360033, 40.366815],
                        [116.355369, 40.37137],
                        [116.34506, 40.373163],
                        [116.337364, 40.379769],
                        [116.32398, 40.387295],
                        [116.32078, 40.386859],
                        [116.313106, 40.389459],
                        [116.302691, 40.387473],
                        [116.295581, 40.384437],
                        [116.293762, 40.392415],
                        [116.289872, 40.391672]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110117,
            "name": "平谷区",
            "center": [117.112335, 40.144783],
            "centroid": [117.145392, 40.208997],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 13,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.961932, 40.051358],
                        [116.962288, 40.063529],
                        [116.970652, 40.063805],
                        [116.973476, 40.066304],
                        [116.978599, 40.064893],
                        [116.980816, 40.071188],
                        [116.982844, 40.070685],
                        [116.986274, 40.078359],
                        [116.981192, 40.08149],
                        [116.981862, 40.089828],
                        [116.979938, 40.093867],
                        [116.975462, 40.095051],
                        [116.967976, 40.101214],
                        [116.973329, 40.103712],
                        [116.976069, 40.111188],
                        [116.971301, 40.114009],
                        [116.969189, 40.118776],
                        [116.971594, 40.124224],
                        [116.96578, 40.127823],
                        [116.967829, 40.129849],
                        [116.970025, 40.140321],
                        [116.977763, 40.151374],
                        [116.972054, 40.156301],
                        [116.968749, 40.163495],
                        [116.961242, 40.171937],
                        [116.962037, 40.175549],
                        [116.951371, 40.174788],
                        [116.945349, 40.1813],
                        [116.945809, 40.186224],
                        [116.94997, 40.186354],
                        [116.945913, 40.193141],
                        [116.939556, 40.192347],
                        [116.930898, 40.207084],
                        [116.929685, 40.211585],
                        [116.938029, 40.210549],
                        [116.940978, 40.223922],
                        [116.935206, 40.229847],
                        [116.936837, 40.232259],
                        [116.945641, 40.233441],
                        [116.946896, 40.236095],
                        [116.953567, 40.236079],
                        [116.956286, 40.232615],
                        [116.959924, 40.23268],
                        [116.974082, 40.24456],
                        [116.975881, 40.249463],
                        [116.969293, 40.253962],
                        [116.961786, 40.252635],
                        [116.954341, 40.25715],
                        [116.950953, 40.261081],
                        [116.960468, 40.2704],
                        [116.961995, 40.273442],
                        [116.970527, 40.276531],
                        [116.971343, 40.281724],
                        [116.983765, 40.287886],
                        [116.991042, 40.287724],
                        [116.990833, 40.290603],
                        [116.99834, 40.29083],
                        [117.004091, 40.293918],
                        [117.002, 40.299675],
                        [117.011306, 40.307113],
                        [117.007563, 40.314599],
                        [117.006998, 40.319255],
                        [117.01024, 40.320726],
                        [117.012686, 40.32674],
                        [117.020842, 40.336179],
                        [117.026133, 40.338458],
                        [117.032762, 40.33752],
                        [117.039266, 40.340057],
                        [117.048279, 40.341528],
                        [117.052817, 40.337649],
                        [117.060931, 40.337795],
                        [117.066933, 40.342983],
                        [117.072286, 40.342999],
                        [117.072705, 40.345584],
                        [117.085231, 40.350432],
                        [117.0946, 40.358285],
                        [117.100915, 40.360546],
                        [117.117457, 40.353744],
                        [117.125362, 40.35641],
                        [117.128122, 40.358866],
                        [117.142385, 40.362824],
                        [117.147466, 40.369965],
                        [117.155329, 40.371402],
                        [117.157609, 40.374859],
                        [117.16796, 40.371467],
                        [117.170491, 40.374342],
                        [117.179943, 40.375021],
                        [117.185799, 40.377767],
                        [117.199747, 40.375861],
                        [117.204536, 40.373082],
                        [117.211124, 40.373825],
                        [117.218527, 40.377718],
                        [117.223901, 40.375538],
                        [117.22618, 40.369044],
                        [117.237055, 40.370627],
                        [117.242283, 40.369981],
                        [117.247762, 40.364101],
                        [117.250188, 40.358381],
                        [117.254182, 40.357105],
                        [117.25437, 40.351191],
                        [117.257089, 40.341463],
                        [117.261125, 40.338781],
                        [117.259828, 40.336195],
                        [117.267127, 40.335694],
                        [117.274969, 40.331944],
                        [117.271288, 40.325285],
                        [117.271853, 40.319853],
                        [117.274697, 40.314405],
                        [117.274342, 40.308552],
                        [117.285739, 40.302214],
                        [117.293309, 40.296748],
                        [117.294647, 40.290894],
                        [117.292368, 40.286236],
                        [117.29632, 40.2781],
                        [117.304309, 40.278181],
                        [117.316835, 40.281999],
                        [117.316794, 40.285104],
                        [117.32336, 40.284441],
                        [117.331244, 40.289665],
                        [117.334005, 40.285654],
                        [117.337999, 40.265903],
                        [117.337622, 40.263266],
                        [117.342202, 40.256502],
                        [117.339881, 40.246194],
                        [117.343457, 40.242909],
                        [117.345464, 40.234946],
                        [117.348246, 40.234574],
                        [117.351613, 40.229459],
                        [117.355691, 40.229556],
                        [117.36027, 40.23255],
                        [117.373989, 40.232777],
                        [117.386829, 40.227111],
                        [117.390029, 40.227969],
                        [117.39373, 40.221656],
                        [117.377586, 40.218612],
                        [117.378443, 40.21029],
                        [117.385679, 40.207894],
                        [117.393145, 40.203376],
                        [117.379552, 40.201319],
                        [117.381455, 40.194906],
                        [117.384382, 40.195278],
                        [117.38409, 40.187828],
                        [117.388356, 40.188249],
                        [117.397704, 40.192914],
                        [117.4077, 40.187504],
                        [117.404751, 40.183244],
                        [117.401217, 40.183617],
                        [117.391618, 40.177607],
                        [117.393186, 40.174901],
                        [117.380597, 40.17691],
                        [117.381225, 40.172455],
                        [117.377021, 40.176327],
                        [117.372023, 40.176538],
                        [117.368844, 40.17299],
                        [117.364014, 40.176683],
                        [117.359413, 40.173346],
                        [117.353746, 40.17367],
                        [117.351111, 40.171661],
                        [117.357343, 40.164273],
                        [117.360626, 40.156965],
                        [117.351717, 40.150564],
                        [117.355272, 40.148587],
                        [117.350525, 40.144827],
                        [117.356883, 40.145037],
                        [117.35636, 40.140904],
                        [117.351404, 40.139932],
                        [117.349082, 40.136528],
                        [117.330617, 40.133691],
                        [117.33093, 40.13575],
                        [117.323276, 40.14071],
                        [117.318571, 40.138522],
                        [117.313761, 40.139964],
                        [117.307613, 40.136982],
                        [117.302991, 40.125926],
                        [117.297073, 40.121273],
                        [117.297094, 40.118857],
                        [117.285425, 40.121322],
                        [117.275659, 40.113636],
                        [117.276663, 40.109307],
                        [117.274362, 40.105804],
                        [117.269908, 40.107198],
                        [117.266834, 40.112177],
                        [117.260393, 40.114155],
                        [117.255541, 40.113279],
                        [117.249268, 40.116474],
                        [117.245357, 40.113215],
                        [117.238226, 40.111755],
                        [117.236009, 40.108382],
                        [117.229025, 40.103533],
                        [117.228606, 40.100257],
                        [117.224403, 40.098619],
                        [117.224487, 40.094662],
                        [117.211249, 40.096608],
                        [117.21104, 40.090785],
                        [117.213989, 40.086243],
                        [117.204285, 40.079657],
                        [117.203616, 40.076704],
                        [117.208175, 40.076834],
                        [117.205247, 40.07028],
                        [117.197572, 40.067748],
                        [117.198576, 40.070101],
                        [117.191842, 40.072973],
                        [117.189207, 40.082853],
                        [117.18538, 40.083875],
                        [117.181533, 40.080095],
                        [117.186426, 40.076202],
                        [117.183603, 40.072081],
                        [117.175593, 40.071642],
                        [117.172227, 40.074157],
                        [117.158466, 40.077435],
                        [117.160139, 40.075553],
                        [117.15625, 40.069338],
                        [117.139227, 40.064049],
                        [117.128896, 40.06546],
                        [117.119507, 40.072421],
                        [117.107775, 40.071805],
                        [117.103927, 40.075585],
                        [117.085608, 40.075131],
                        [117.085064, 40.068592],
                        [117.080986, 40.065087],
                        [117.081049, 40.068819],
                        [117.069652, 40.06757],
                        [117.070634, 40.064179],
                        [117.064382, 40.062783],
                        [117.061182, 40.060105],
                        [117.052022, 40.059375],
                        [117.053382, 40.052884],
                        [117.051437, 40.051163],
                        [117.038639, 40.049378],
                        [117.033159, 40.04235],
                        [117.027032, 40.038828],
                        [117.028517, 40.033957],
                        [117.023916, 40.033746],
                        [117.024836, 40.03011],
                        [117.020884, 40.032448],
                        [117.018061, 40.030467],
                        [117.011369, 40.031246],
                        [117.000683, 40.029915],
                        [117.00016, 40.032253],
                        [116.991837, 40.036896],
                        [116.985626, 40.038828],
                        [116.972095, 40.036977],
                        [116.969293, 40.048583],
                        [116.964902, 40.047836],
                        [116.961932, 40.051358]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110118,
            "name": "密云区",
            "center": [116.843352, 40.377362],
            "centroid": [116.994846, 40.526834],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 14,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [116.886961, 40.801076],
                        [116.889073, 40.798348],
                        [116.896686, 40.796438],
                        [116.89495, 40.790675],
                        [116.895013, 40.781733],
                        [116.898589, 40.77674],
                        [116.904569, 40.777286],
                        [116.923391, 40.773722],
                        [116.923181, 40.766897],
                        [116.927908, 40.757824],
                        [116.923516, 40.750596],
                        [116.926548, 40.744894],
                        [116.940706, 40.739786],
                        [116.942714, 40.729857],
                        [116.946645, 40.726916],
                        [116.960134, 40.721083],
                        [116.96647, 40.71525],
                        [116.965111, 40.709593],
                        [116.969628, 40.706362],
                        [116.977533, 40.705559],
                        [116.979938, 40.702826],
                        [116.988177, 40.703164],
                        [116.990456, 40.701203],
                        [117.002481, 40.697345],
                        [117.005513, 40.694853],
                        [117.013418, 40.694082],
                        [117.018291, 40.696011],
                        [117.027848, 40.694355],
                        [117.031047, 40.692136],
                        [117.035585, 40.694467],
                        [117.036108, 40.697265],
                        [117.044494, 40.700367],
                        [117.054887, 40.699804],
                        [117.058338, 40.70154],
                        [117.076804, 40.700029],
                        [117.081153, 40.702617],
                        [117.086047, 40.702055],
                        [117.095144, 40.705559],
                        [117.110661, 40.708243],
                        [117.117792, 40.700078],
                        [117.128792, 40.700913],
                        [117.132493, 40.698663],
                        [117.142531, 40.6972],
                        [117.147571, 40.698968],
                        [117.159491, 40.696332],
                        [117.16474, 40.699628],
                        [117.169236, 40.699097],
                        [117.176639, 40.693567],
                        [117.180947, 40.694082],
                        [117.182453, 40.697072],
                        [117.193996, 40.696268],
                        [117.197802, 40.694291],
                        [117.202361, 40.695577],
                        [117.208405, 40.694435],
                        [117.210622, 40.691976],
                        [117.217335, 40.69196],
                        [117.218715, 40.689484],
                        [117.233207, 40.683583],
                        [117.234336, 40.680577],
                        [117.241635, 40.676669],
                        [117.256775, 40.679467],
                        [117.261397, 40.681155],
                        [117.267754, 40.676669],
                        [117.273401, 40.670076],
                        [117.278629, 40.667551],
                        [117.278608, 40.664463],
                        [117.290423, 40.660185],
                        [117.321164, 40.658287],
                        [117.331851, 40.661504],
                        [117.337622, 40.664447],
                        [117.336681, 40.666956],
                        [117.342411, 40.673437],
                        [117.359748, 40.673919],
                        [117.37058, 40.679708],
                        [117.378192, 40.678808],
                        [117.386996, 40.684178],
                        [117.397223, 40.683776],
                        [117.409226, 40.687281],
                        [117.414852, 40.685947],
                        [117.419348, 40.68696],
                        [117.426437, 40.685304],
                        [117.432711, 40.681622],
                        [117.437332, 40.683599],
                        [117.442226, 40.676605],
                        [117.453958, 40.677618],
                        [117.465188, 40.673534],
                        [117.471503, 40.674338],
                        [117.482399, 40.679033],
                        [117.484741, 40.677087],
                        [117.493357, 40.67527],
                        [117.502934, 40.669674],
                        [117.514583, 40.660523],
                        [117.513913, 40.656196],
                        [117.50283, 40.653076],
                        [117.505026, 40.646142],
                        [117.501972, 40.644518],
                        [117.500425, 40.6362],
                        [117.489948, 40.636023],
                        [117.486163, 40.633496],
                        [117.477986, 40.635331],
                        [117.475539, 40.644421],
                        [117.473093, 40.644453],
                        [117.467885, 40.649521],
                        [117.464309, 40.648652],
                        [117.462009, 40.653076],
                        [117.449106, 40.651596],
                        [117.456467, 40.649167],
                        [117.451448, 40.646577],
                        [117.45402, 40.642844],
                        [117.448876, 40.62838],
                        [117.442289, 40.627977],
                        [117.438002, 40.625692],
                        [117.431561, 40.625596],
                        [117.42857, 40.631887],
                        [117.428884, 40.637632],
                        [117.421188, 40.635427],
                        [117.42054, 40.629232],
                        [117.424701, 40.621862],
                        [117.422987, 40.618305],
                        [117.41918, 40.617114],
                        [117.412739, 40.605123],
                        [117.414747, 40.600728],
                        [117.421753, 40.593178],
                        [117.420623, 40.590875],
                        [117.423217, 40.58144],
                        [117.429804, 40.579298],
                        [117.429992, 40.576126],
                        [117.42123, 40.569104],
                        [117.413471, 40.569893],
                        [117.40358, 40.574257],
                        [117.400589, 40.569345],
                        [117.39465, 40.567912],
                        [117.389297, 40.561244],
                        [117.378422, 40.56337],
                        [117.375453, 40.567799],
                        [117.369221, 40.57036],
                        [117.365917, 40.575965],
                        [117.353014, 40.578831],
                        [117.350023, 40.582197],
                        [117.342767, 40.581585],
                        [117.334611, 40.576464],
                        [117.328442, 40.575948],
                        [117.325451, 40.578155],
                        [117.311837, 40.578026],
                        [117.299562, 40.566801],
                        [117.285592, 40.565061],
                        [117.279256, 40.560342],
                        [117.273191, 40.561501],
                        [117.268507, 40.559842],
                        [117.25964, 40.552867],
                        [117.24954, 40.548179],
                        [117.250606, 40.542024],
                        [117.247427, 40.540236],
                        [117.252007, 40.53632],
                        [117.255123, 40.527973],
                        [117.26146, 40.51906],
                        [117.264115, 40.517271],
                        [117.263133, 40.513145],
                        [117.255562, 40.514934],
                        [117.246821, 40.511968],
                        [117.239543, 40.516723],
                        [117.230405, 40.511162],
                        [117.219969, 40.514321],
                        [117.215013, 40.513273],
                        [117.212504, 40.507906],
                        [117.214449, 40.506922],
                        [117.208572, 40.501102],
                        [117.208426, 40.498071],
                        [117.212065, 40.494685],
                        [117.21792, 40.494589],
                        [117.22846, 40.481301],
                        [117.225783, 40.47585],
                        [117.230907, 40.470463],
                        [117.237243, 40.468785],
                        [117.233207, 40.463204],
                        [117.236532, 40.456558],
                        [117.243308, 40.455428],
                        [117.252154, 40.450459],
                        [117.252635, 40.446038],
                        [117.263342, 40.442375],
                        [117.257654, 40.435372],
                        [117.246737, 40.426883],
                        [117.243872, 40.422848],
                        [117.234085, 40.417149],
                        [117.237515, 40.407786],
                        [117.236616, 40.400844],
                        [117.240484, 40.39763],
                        [117.240694, 40.394417],
                        [117.23695, 40.394078],
                        [117.235382, 40.389556],
                        [117.229045, 40.386843],
                        [117.226661, 40.378558],
                        [117.223901, 40.375538],
                        [117.218527, 40.377718],
                        [117.211124, 40.373825],
                        [117.204536, 40.373082],
                        [117.199747, 40.375861],
                        [117.185799, 40.377767],
                        [117.179943, 40.375021],
                        [117.170491, 40.374342],
                        [117.16796, 40.371467],
                        [117.157609, 40.374859],
                        [117.155329, 40.371402],
                        [117.147466, 40.369965],
                        [117.142385, 40.362824],
                        [117.128122, 40.358866],
                        [117.125362, 40.35641],
                        [117.117457, 40.353744],
                        [117.100915, 40.360546],
                        [117.0946, 40.358285],
                        [117.085231, 40.350432],
                        [117.072705, 40.345584],
                        [117.072286, 40.342999],
                        [117.066933, 40.342983],
                        [117.060931, 40.337795],
                        [117.052817, 40.337649],
                        [117.048279, 40.341528],
                        [117.039266, 40.340057],
                        [117.032762, 40.33752],
                        [117.026133, 40.338458],
                        [117.020842, 40.336179],
                        [117.012686, 40.32674],
                        [117.01024, 40.320726],
                        [117.006998, 40.319255],
                        [117.007563, 40.314599],
                        [117.011306, 40.307113],
                        [117.002, 40.299675],
                        [117.004091, 40.293918],
                        [116.99834, 40.29083],
                        [116.990833, 40.290603],
                        [116.991042, 40.287724],
                        [116.983765, 40.287886],
                        [116.971343, 40.281724],
                        [116.970527, 40.276531],
                        [116.961995, 40.273442],
                        [116.960468, 40.2704],
                        [116.950953, 40.261081],
                        [116.954341, 40.25715],
                        [116.961786, 40.252635],
                        [116.969293, 40.253962],
                        [116.975881, 40.249463],
                        [116.974082, 40.24456],
                        [116.959924, 40.23268],
                        [116.956286, 40.232615],
                        [116.953567, 40.236079],
                        [116.946896, 40.236095],
                        [116.945641, 40.233441],
                        [116.936837, 40.232259],
                        [116.935206, 40.229847],
                        [116.931065, 40.230624],
                        [116.92544, 40.225768],
                        [116.922031, 40.220134],
                        [116.915507, 40.222271],
                        [116.913917, 40.220118],
                        [116.908606, 40.222401],
                        [116.906598, 40.228682],
                        [116.900701, 40.228763],
                        [116.893946, 40.233457],
                        [116.901746, 40.23684],
                        [116.894343, 40.240028],
                        [116.892252, 40.245709],
                        [116.886585, 40.251907],
                        [116.886104, 40.255256],
                        [116.881273, 40.259221],
                        [116.879893, 40.264139],
                        [116.874247, 40.268281],
                        [116.876338, 40.274348],
                        [116.871737, 40.281481],
                        [116.871319, 40.290943],
                        [116.859462, 40.290878],
                        [116.857182, 40.2929],
                        [116.854547, 40.303152],
                        [116.848984, 40.311204],
                        [116.838382, 40.310185],
                        [116.828992, 40.304413],
                        [116.830101, 40.299206],
                        [116.827215, 40.298333],
                        [116.82458, 40.290991],
                        [116.825123, 40.285347],
                        [116.811823, 40.282387],
                        [116.809607, 40.28601],
                        [116.800572, 40.289196],
                        [116.794487, 40.287417],
                        [116.788025, 40.289439],
                        [116.787795, 40.281449],
                        [116.784073, 40.279443],
                        [116.782964, 40.273248],
                        [116.773512, 40.269527],
                        [116.771651, 40.266501],
                        [116.768597, 40.270109],
                        [116.762658, 40.269058],
                        [116.752788, 40.275512],
                        [116.74298, 40.279087],
                        [116.738337, 40.278764],
                        [116.741098, 40.283001],
                        [116.738965, 40.284101],
                        [116.754461, 40.303686],
                        [116.756845, 40.302586],
                        [116.762888, 40.310428],
                        [116.773324, 40.315973],
                        [116.768639, 40.317816],
                        [116.762846, 40.326707],
                        [116.759689, 40.326853],
                        [116.758559, 40.333884],
                        [116.751491, 40.335742],
                        [116.744653, 40.333706],
                        [116.744046, 40.339136],
                        [116.73129, 40.335031],
                        [116.731185, 40.339023],
                        [116.722967, 40.339152],
                        [116.723887, 40.344033],
                        [116.727484, 40.346522],
                        [116.729031, 40.355619],
                        [116.725769, 40.355619],
                        [116.726773, 40.361193],
                        [116.718094, 40.361338],
                        [116.719872, 40.369044],
                        [116.714079, 40.368608],
                        [116.706509, 40.373809],
                        [116.707115, 40.377007],
                        [116.716254, 40.384114],
                        [116.711716, 40.386908],
                        [116.713849, 40.395806],
                        [116.713242, 40.40157],
                        [116.718512, 40.402055],
                        [116.723427, 40.405316],
                        [116.724389, 40.409191],
                        [116.728801, 40.40982],
                        [116.741139, 40.414631],
                        [116.733235, 40.418312],
                        [116.73244, 40.420604],
                        [116.72556, 40.418053],
                        [116.722339, 40.423832],
                        [116.723552, 40.435065],
                        [116.716421, 40.441714],
                        [116.72098, 40.440988],
                        [116.725811, 40.443085],
                        [116.719265, 40.448636],
                        [116.7196, 40.455735],
                        [116.723594, 40.458542],
                        [116.719223, 40.460397],
                        [116.716902, 40.457074],
                        [116.706174, 40.459929],
                        [116.698667, 40.468043],
                        [116.695571, 40.466721],
                        [116.693397, 40.476108],
                        [116.69348, 40.481704],
                        [116.704334, 40.479043],
                        [116.694149, 40.485462],
                        [116.693376, 40.490783],
                        [116.698353, 40.493266],
                        [116.699106, 40.50444],
                        [116.701071, 40.510549],
                        [116.711402, 40.516465],
                        [116.712239, 40.522058],
                        [116.717216, 40.524798],
                        [116.712573, 40.529955],
                        [116.706948, 40.532582],
                        [116.701469, 40.539913],
                        [116.702138, 40.545456],
                        [116.690699, 40.549468],
                        [116.68225, 40.548904],
                        [116.67698, 40.554462],
                        [116.665771, 40.552432],
                        [116.66872, 40.557507],
                        [116.682397, 40.556766],
                        [116.679636, 40.562001],
                        [116.686349, 40.564497],
                        [116.699336, 40.563563],
                        [116.709855, 40.565512],
                        [116.710503, 40.568685],
                        [116.71456, 40.570682],
                        [116.714351, 40.58028],
                        [116.708955, 40.590054],
                        [116.711611, 40.59189],
                        [116.708495, 40.595206],
                        [116.711235, 40.600213],
                        [116.705609, 40.60303],
                        [116.707993, 40.606507],
                        [116.70655, 40.610998],
                        [116.702598, 40.612785],
                        [116.697955, 40.618402],
                        [116.701322, 40.621379],
                        [116.704689, 40.620076],
                        [116.705128, 40.626947],
                        [116.70195, 40.628444],
                        [116.70149, 40.632917],
                        [116.712197, 40.641268],
                        [116.711151, 40.648218],
                        [116.712636, 40.653896],
                        [116.709855, 40.662598],
                        [116.714309, 40.666104],
                        [116.713221, 40.669867],
                        [116.714915, 40.680014],
                        [116.725413, 40.68466],
                        [116.725581, 40.689114],
                        [116.735807, 40.69167],
                        [116.74252, 40.69593],
                        [116.747518, 40.697072],
                        [116.748668, 40.700544],
                        [116.754963, 40.702891],
                        [116.756155, 40.705687],
                        [116.762867, 40.706427],
                        [116.769246, 40.70281],
                        [116.783989, 40.700496],
                        [116.787105, 40.704482],
                        [116.786687, 40.7103],
                        [116.789091, 40.712454],
                        [116.790472, 40.728973],
                        [116.786352, 40.736026],
                        [116.782818, 40.747817],
                        [116.780727, 40.751512],
                        [116.783759, 40.757631],
                        [116.793629, 40.748267],
                        [116.802977, 40.745986],
                        [116.810527, 40.749118],
                        [116.818662, 40.75042],
                        [116.826211, 40.749343],
                        [116.831795, 40.751303],
                        [116.840076, 40.760682],
                        [116.834785, 40.770221],
                        [116.850448, 40.775006],
                        [116.851264, 40.778924],
                        [116.856806, 40.77955],
                        [116.858039, 40.78305],
                        [116.867471, 40.784559],
                        [116.862577, 40.792858],
                        [116.871277, 40.794785],
                        [116.873326, 40.798781],
                        [116.878575, 40.797545],
                        [116.886961, 40.801076]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 110119,
            "name": "延庆区",
            "center": [115.985006, 40.465325],
            "centroid": [116.16401, 40.540016],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 110000
            },
            "subFeatureIndex": 15,
            "acroutes": [100000, 110000]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [115.967006, 40.265612],
                        [115.961611, 40.269219],
                        [115.960231, 40.274914],
                        [115.955212, 40.276984],
                        [115.951698, 40.282015],
                        [115.950088, 40.289228],
                        [115.946115, 40.289034],
                        [115.945885, 40.296199],
                        [115.939757, 40.304397],
                        [115.943814, 40.310945],
                        [115.937185, 40.313047],
                        [115.935721, 40.316717],
                        [115.929239, 40.32105],
                        [115.926792, 40.319611],
                        [115.922672, 40.325899],
                        [115.92721, 40.329601],
                        [115.922881, 40.332898],
                        [115.921417, 40.338668],
                        [115.924094, 40.341059],
                        [115.920581, 40.346473],
                        [115.918301, 40.35389],
                        [115.909539, 40.357622],
                        [115.892997, 40.355554],
                        [115.890927, 40.357897],
                        [115.88526, 40.357024],
                        [115.883169, 40.359545],
                        [115.878066, 40.359367],
                        [115.876226, 40.362146],
                        [115.872754, 40.359593],
                        [115.864452, 40.359335],
                        [115.861901, 40.363422],
                        [115.861859, 40.373422],
                        [115.855962, 40.37712],
                        [115.846865, 40.375085],
                        [115.840633, 40.381094],
                        [115.837454, 40.381255],
                        [115.836555, 40.38568],
                        [115.796445, 40.426834],
                        [115.796884, 40.432531],
                        [115.78992, 40.432483],
                        [115.786679, 40.437066],
                        [115.77043, 40.444166],
                        [115.773546, 40.44812],
                        [115.77248, 40.452831],
                        [115.77547, 40.45204],
                        [115.7734, 40.457397],
                        [115.779527, 40.464075],
                        [115.772856, 40.462301],
                        [115.770367, 40.46493],
                        [115.771559, 40.47285],
                        [115.776683, 40.477511],
                        [115.776202, 40.482704],
                        [115.782204, 40.492073],
                        [115.774529, 40.493911],
                        [115.768088, 40.498345],
                        [115.744039, 40.498249],
                        [115.743077, 40.494959],
                        [115.73605, 40.503988],
                        [115.743098, 40.513854],
                        [115.743788, 40.518464],
                        [115.748702, 40.526087],
                        [115.755624, 40.531019],
                        [115.752968, 40.536288],
                        [115.75506, 40.540042],
                        [115.759577, 40.538914],
                        [115.763885, 40.540574],
                        [115.770179, 40.548002],
                        [115.773902, 40.548582],
                        [115.776327, 40.552158],
                        [115.784713, 40.558376],
                        [115.7922, 40.561292],
                        [115.79908, 40.5577],
                        [115.804915, 40.55865],
                        [115.815036, 40.55741],
                        [115.819804, 40.559343],
                        [115.82154, 40.563305],
                        [115.820662, 40.568234],
                        [115.827374, 40.587027],
                        [115.846175, 40.593049],
                        [115.854895, 40.590151],
                        [115.86623, 40.593371],
                        [115.867777, 40.595786],
                        [115.885406, 40.595223],
                        [115.888146, 40.597026],
                        [115.894733, 40.606878],
                        [115.897849, 40.608101],
                        [115.907803, 40.617291],
                        [115.920372, 40.616632],
                        [115.928297, 40.612753],
                        [115.935031, 40.613316],
                        [115.944672, 40.611095],
                        [115.948331, 40.608809],
                        [115.955107, 40.609534],
                        [115.967404, 40.605896],
                        [115.965877, 40.601002],
                        [115.971983, 40.60237],
                        [115.97512, 40.590779],
                        [115.982147, 40.579008],
                        [115.995238, 40.579862],
                        [115.996116, 40.58392],
                        [116.005109, 40.584097],
                        [116.025268, 40.60654],
                        [116.028509, 40.607328],
                        [116.030036, 40.597364],
                        [116.032357, 40.599875],
                        [116.04457, 40.602032],
                        [116.050907, 40.606121],
                        [116.058289, 40.607006],
                        [116.062722, 40.610322],
                        [116.069811, 40.610258],
                        [116.073492, 40.612125],
                        [116.076691, 40.619883],
                        [116.08583, 40.623825],
                        [116.088507, 40.626626],
                        [116.098879, 40.630584],
                        [116.1044, 40.626996],
                        [116.118349, 40.627961],
                        [116.122071, 40.629989],
                        [116.120419, 40.633287],
                        [116.112744, 40.640946],
                        [116.111531, 40.646287],
                        [116.113225, 40.648845],
                        [116.125229, 40.654089],
                        [116.13694, 40.667648],
                        [116.142858, 40.666972],
                        [116.151432, 40.663338],
                        [116.162683, 40.662437],
                        [116.167597, 40.672633],
                        [116.168413, 40.67892],
                        [116.171487, 40.68167],
                        [116.173683, 40.689034],
                        [116.171341, 40.695979],
                        [116.176213, 40.700544],
                        [116.177907, 40.707889],
                        [116.181128, 40.712438],
                        [116.184913, 40.713675],
                        [116.192274, 40.724779],
                        [116.197753, 40.7269],
                        [116.2057, 40.733038],
                        [116.204717, 40.739946],
                        [116.210551, 40.741713],
                        [116.213249, 40.740139],
                        [116.220359, 40.744669],
                        [116.220485, 40.749183],
                        [116.223308, 40.753793],
                        [116.23366, 40.759896],
                        [116.229979, 40.762417],
                        [116.231757, 40.77149],
                        [116.235625, 40.775135],
                        [116.235019, 40.78313],
                        [116.245224, 40.78838],
                        [116.247943, 40.791831],
                        [116.257834, 40.787898],
                        [116.261013, 40.782938],
                        [116.269587, 40.777158],
                        [116.26988, 40.770703],
                        [116.274167, 40.766335],
                        [116.273456, 40.762883],
                        [116.277366, 40.76163],
                        [116.281402, 40.763926],
                        [116.290918, 40.763814],
                        [116.29786, 40.756812],
                        [116.304762, 40.755656],
                        [116.30794, 40.752122],
                        [116.311119, 40.75511],
                        [116.30794, 40.763734],
                        [116.313168, 40.770205],
                        [116.31756, 40.77218],
                        [116.330149, 40.77377],
                        [116.33314, 40.772694],
                        [116.342947, 40.773096],
                        [116.353111, 40.770221],
                        [116.361204, 40.772646],
                        [116.367687, 40.77088],
                        [116.37097, 40.772453],
                        [116.379837, 40.772325],
                        [116.392635, 40.778394],
                        [116.403217, 40.778635],
                        [116.407838, 40.780417],
                        [116.4143, 40.777912],
                        [116.416496, 40.76937],
                        [116.424861, 40.767443],
                        [116.431846, 40.768246],
                        [116.437722, 40.766865],
                        [116.444414, 40.76921],
                        [116.45395, 40.76587],
                        [116.465452, 40.772742],
                        [116.471517, 40.771233],
                        [116.4803, 40.771586],
                        [116.485193, 40.765179],
                        [116.491404, 40.7633],
                        [116.495482, 40.759735],
                        [116.50025, 40.760811],
                        [116.502906, 40.756635],
                        [116.501819, 40.746581],
                        [116.506461, 40.743432],
                        [116.513697, 40.741456],
                        [116.509493, 40.73548],
                        [116.510748, 40.72645],
                        [116.506858, 40.720039],
                        [116.504119, 40.720135],
                        [116.503115, 40.715893],
                        [116.506064, 40.710879],
                        [116.501923, 40.706796],
                        [116.501066, 40.70228],
                        [116.502676, 40.697361],
                        [116.496653, 40.696879],
                        [116.488811, 40.69196],
                        [116.483374, 40.679403],
                        [116.487138, 40.674338],
                        [116.492826, 40.673984],
                        [116.501568, 40.671186],
                        [116.505938, 40.673067],
                        [116.513488, 40.672344],
                        [116.517273, 40.665734],
                        [116.520096, 40.66411],
                        [116.518381, 40.660925],
                        [116.527039, 40.6584],
                        [116.529507, 40.654588],
                        [116.540046, 40.656679],
                        [116.544103, 40.653767],
                        [116.545023, 40.650116],
                        [116.550335, 40.647606],
                        [116.551151, 40.642828],
                        [116.55389, 40.642877],
                        [116.563886, 40.636908],
                        [116.573903, 40.63628],
                        [116.574092, 40.631678],
                        [116.568989, 40.625483],
                        [116.561231, 40.628557],
                        [116.551674, 40.625209],
                        [116.545003, 40.627076],
                        [116.539294, 40.625612],
                        [116.538938, 40.619673],
                        [116.535634, 40.615698],
                        [116.532915, 40.606459],
                        [116.535948, 40.59944],
                        [116.530929, 40.595883],
                        [116.531577, 40.59131],
                        [116.525136, 40.583002],
                        [116.517796, 40.579749],
                        [116.513153, 40.572792],
                        [116.509577, 40.57276],
                        [116.505144, 40.562581],
                        [116.499999, 40.560921],
                        [116.496277, 40.555106],
                        [116.484587, 40.552867],
                        [116.479651, 40.541396],
                        [116.470617, 40.535418],
                        [116.467125, 40.530068],
                        [116.460956, 40.524363],
                        [116.46587, 40.518802],
                        [116.470345, 40.518963],
                        [116.476306, 40.514192],
                        [116.488581, 40.515853],
                        [116.492073, 40.518093],
                        [116.497762, 40.518093],
                        [116.500459, 40.510904],
                        [116.506398, 40.508212],
                        [116.51194, 40.501135],
                        [116.519155, 40.496604],
                        [116.519092, 40.491799],
                        [116.511543, 40.486929],
                        [116.508322, 40.483172],
                        [116.492157, 40.481027],
                        [116.487347, 40.481737],
                        [116.483541, 40.484994],
                        [116.468212, 40.48493],
                        [116.465577, 40.48701],
                        [116.457903, 40.488445],
                        [116.455937, 40.480914],
                        [116.443201, 40.481801],
                        [116.433142, 40.478189],
                        [116.420971, 40.480301],
                        [116.416664, 40.483011],
                        [116.413673, 40.481527],
                        [116.4065, 40.481995],
                        [116.393702, 40.47256],
                        [116.38609, 40.475802],
                        [116.387344, 40.482043],
                        [116.376825, 40.485736],
                        [116.378603, 40.491525],
                        [116.377537, 40.49683],
                        [116.369632, 40.500312],
                        [116.365909, 40.499635],
                        [116.357042, 40.501941],
                        [116.348636, 40.499071],
                        [116.34232, 40.500457],
                        [116.336653, 40.498636],
                        [116.330567, 40.500748],
                        [116.323227, 40.500151],
                        [116.31321, 40.491799],
                        [116.31022, 40.491702],
                        [116.303779, 40.485817],
                        [116.29717, 40.486768],
                        [116.291691, 40.485317],
                        [116.294786, 40.47535],
                        [116.301646, 40.468108],
                        [116.306853, 40.466092],
                        [116.300955, 40.458429],
                        [116.293824, 40.452831],
                        [116.294368, 40.449975],
                        [116.289788, 40.440907],
                        [116.290667, 40.435856],
                        [116.294452, 40.429304],
                        [116.296648, 40.420701],
                        [116.291942, 40.416617],
                        [116.289433, 40.418021],
                        [116.288513, 40.413437],
                        [116.291608, 40.408448],
                        [116.287864, 40.404719],
                        [116.289746, 40.402539],
                        [116.286003, 40.396032],
                        [116.289872, 40.391672],
                        [116.290729, 40.383177],
                        [116.282845, 40.375263],
                        [116.270863, 40.382693],
                        [116.261264, 40.380561],
                        [116.258336, 40.383193],
                        [116.25338, 40.381239],
                        [116.252104, 40.376297],
                        [116.247796, 40.374471],
                        [116.24353, 40.379818],
                        [116.241962, 40.377508],
                        [116.23665, 40.377427],
                        [116.23184, 40.374988],
                        [116.226989, 40.38111],
                        [116.222221, 40.382111],
                        [116.211451, 40.381756],
                        [116.209129, 40.376232],
                        [116.192985, 40.372775],
                        [116.180354, 40.367687],
                        [116.177154, 40.370934],
                        [116.170713, 40.369351],
                        [116.168789, 40.366718],
                        [116.159295, 40.366265],
                        [116.148233, 40.361807],
                        [116.148651, 40.35696],
                        [116.145514, 40.351046],
                        [116.1507, 40.349252],
                        [116.155677, 40.344906],
                        [116.152603, 40.337714],
                        [116.144719, 40.336631],
                        [116.147543, 40.340655],
                        [116.144782, 40.348541],
                        [116.138404, 40.345229],
                        [116.140809, 40.343047],
                        [116.137567, 40.340769],
                        [116.137651, 40.336534],
                        [116.143904, 40.336082],
                        [116.13809, 40.330974],
                        [116.138383, 40.324671],
                        [116.141959, 40.316879],
                        [116.132737, 40.31198],
                        [116.122385, 40.312805],
                        [116.116237, 40.321955],
                        [116.116634, 40.323668],
                        [116.110381, 40.330813],
                        [116.102978, 40.331524],
                        [116.098649, 40.330005],
                        [116.086353, 40.330813],
                        [116.083342, 40.33571],
                        [116.077716, 40.339346],
                        [116.073429, 40.339831],
                        [116.06841, 40.336971],
                        [116.061802, 40.336809],
                        [116.053353, 40.326853],
                        [116.056971, 40.322181],
                        [116.051116, 40.315812],
                        [116.042479, 40.316846],
                        [116.040095, 40.312724],
                        [116.031144, 40.312352],
                        [116.026167, 40.320484],
                        [116.026481, 40.324283],
                        [116.01684, 40.33466],
                        [116.007597, 40.33314],
                        [115.999065, 40.325463],
                        [115.993398, 40.328986],
                        [115.982711, 40.324202],
                        [115.979658, 40.320532],
                        [115.973259, 40.318997],
                        [115.976417, 40.311511],
                        [115.975538, 40.308698],
                        [115.987919, 40.303799],
                        [115.990323, 40.299498],
                        [115.982732, 40.297977],
                        [115.978675, 40.289633],
                        [115.981227, 40.28525],
                        [115.978822, 40.281627],
                        [115.981812, 40.276903],
                        [115.976396, 40.270983],
                        [115.967006, 40.265612]
                    ]
                ]
            ]
        }
    }]
}

export const map_chengdu =
{
    "type": "FeatureCollection",
    "features": [{
        "type": "Feature",
        "properties": {
            "adcode": 510104,
            "name": "锦江区",
            "center": [104.080989, 30.657689],
            "centroid": [104.1151, 30.60117],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 0,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [104.059956, 30.647001],
                        [104.063917, 30.652741],
                        [104.066869, 30.653563],
                        [104.066108, 30.656325],
                        [104.068907, 30.658279],
                        [104.068869, 30.661634],
                        [104.071498, 30.659491],
                        [104.074374, 30.659896],
                        [104.079269, 30.667238],
                        [104.085916, 30.664274],
                        [104.089611, 30.670094],
                        [104.091916, 30.668882],
                        [104.096449, 30.664961],
                        [104.095954, 30.663425],
                        [104.093363, 30.662604],
                        [104.091897, 30.658333],
                        [104.088506, 30.653563],
                        [104.105953, 30.645586],
                        [104.123914, 30.637097],
                        [104.127781, 30.634657],
                        [104.12639, 30.631329],
                        [104.129133, 30.628134],
                        [104.126752, 30.625479],
                        [104.123609, 30.62525],
                        [104.126866, 30.624145],
                        [104.124371, 30.6218],
                        [104.128657, 30.618565],
                        [104.132942, 30.617271],
                        [104.134123, 30.618471],
                        [104.137818, 30.618821],
                        [104.139037, 30.616665],
                        [104.140332, 30.617217],
                        [104.142808, 30.616772],
                        [104.144675, 30.613753],
                        [104.145113, 30.610531],
                        [104.149322, 30.609156],
                        [104.149646, 30.606757],
                        [104.155646, 30.605315],
                        [104.158503, 30.60394],
                        [104.153303, 30.597617],
                        [104.156903, 30.595177],
                        [104.156655, 30.592615],
                        [104.161665, 30.591132],
                        [104.164807, 30.58942],
                        [104.167112, 30.590498],
                        [104.166788, 30.592372],
                        [104.169436, 30.594327],
                        [104.171626, 30.591334],
                        [104.166731, 30.583312],
                        [104.163512, 30.579954],
                        [104.162979, 30.577932],
                        [104.15936, 30.576057],
                        [104.163341, 30.573684],
                        [104.163246, 30.569126],
                        [104.165284, 30.569423],
                        [104.164884, 30.575248],
                        [104.167779, 30.572956],
                        [104.167379, 30.570218],
                        [104.168331, 30.567265],
                        [104.160865, 30.56713],
                        [104.161303, 30.566011],
                        [104.165017, 30.564568],
                        [104.164236, 30.563219],
                        [104.160827, 30.56268],
                        [104.156522, 30.563947],
                        [104.154103, 30.561695],
                        [104.151932, 30.563381],
                        [104.148808, 30.560994],
                        [104.146275, 30.561897],
                        [104.143913, 30.565808],
                        [104.140561, 30.567373],
                        [104.138428, 30.566968],
                        [104.13079, 30.563974],
                        [104.127838, 30.563421],
                        [104.125457, 30.561601],
                        [104.122924, 30.555046],
                        [104.128523, 30.551364],
                        [104.126828, 30.547789],
                        [104.123667, 30.548518],
                        [104.118524, 30.54845],
                        [104.115115, 30.549098],
                        [104.115019, 30.547708],
                        [104.110467, 30.546454],
                        [104.107039, 30.549529],
                        [104.106544, 30.554277],
                        [104.109801, 30.559699],
                        [104.112905, 30.56067],
                        [104.111286, 30.567373],
                        [104.109458, 30.56945],
                        [104.105477, 30.571297],
                        [104.099058, 30.571337],
                        [104.094011, 30.570043],
                        [104.091554, 30.5686],
                        [104.085916, 30.569193],
                        [104.082869, 30.567777],
                        [104.080831, 30.569975],
                        [104.077498, 30.569625],
                        [104.074031, 30.570866],
                        [104.073879, 30.573185],
                        [104.079859, 30.579482],
                        [104.078469, 30.587397],
                        [104.080202, 30.590202],
                        [104.08365, 30.59186],
                        [104.082278, 30.595001],
                        [104.081707, 30.599585],
                        [104.083173, 30.601419],
                        [104.087211, 30.60305],
                        [104.088049, 30.608887],
                        [104.084526, 30.61653],
                        [104.085707, 30.619333],
                        [104.084564, 30.623687],
                        [104.086468, 30.626032],
                        [104.092982, 30.62711],
                        [104.09422, 30.630223],
                        [104.09083, 30.637946],
                        [104.087707, 30.64122],
                        [104.084926, 30.641975],
                        [104.07864, 30.64529],
                        [104.064698, 30.646772],
                        [104.059956, 30.647001]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510105,
            "name": "青羊区",
            "center": [104.055731, 30.667648],
            "centroid": [103.981259, 30.679625],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 1,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [104.089611, 30.670094],
                        [104.085916, 30.664274],
                        [104.079269, 30.667238],
                        [104.074374, 30.659896],
                        [104.071498, 30.659491],
                        [104.068869, 30.661634],
                        [104.068907, 30.658279],
                        [104.066108, 30.656325],
                        [104.066869, 30.653563],
                        [104.063917, 30.652741],
                        [104.059956, 30.647001],
                        [104.056051, 30.64909],
                        [104.053956, 30.651717],
                        [104.039899, 30.651528],
                        [104.037271, 30.650814],
                        [104.026738, 30.650747],
                        [104.022281, 30.651582],
                        [104.018777, 30.657349],
                        [104.015272, 30.656743],
                        [104.013863, 30.654439],
                        [104.007844, 30.652822],
                        [104.005368, 30.654991],
                        [104.006415, 30.657187],
                        [104.005596, 30.659316],
                        [104.002644, 30.659491],
                        [104.000092, 30.661041],
                        [103.997825, 30.660192],
                        [103.997292, 30.655449],
                        [103.993749, 30.654695],
                        [103.994797, 30.657497],
                        [103.990854, 30.660717],
                        [103.989102, 30.658198],
                        [103.98855, 30.660407],
                        [103.985369, 30.661593],
                        [103.981655, 30.65778],
                        [103.977769, 30.660798],
                        [103.973122, 30.659074],
                        [103.971103, 30.656541],
                        [103.969236, 30.656231],
                        [103.967503, 30.658764],
                        [103.970132, 30.662253],
                        [103.958951, 30.664032],
                        [103.958437, 30.661647],
                        [103.955466, 30.661351],
                        [103.952875, 30.658521],
                        [103.949847, 30.658589],
                        [103.948533, 30.660273],
                        [103.946399, 30.659976],
                        [103.946076, 30.658387],
                        [103.942971, 30.657942],
                        [103.942019, 30.660475],
                        [103.935124, 30.660529],
                        [103.932876, 30.658858],
                        [103.928496, 30.659114],
                        [103.929105, 30.662819],
                        [103.926572, 30.665419],
                        [103.924172, 30.667992],
                        [103.907563, 30.672007],
                        [103.90364, 30.673812],
                        [103.903525, 30.675402],
                        [103.89943, 30.675348],
                        [103.896231, 30.679887],
                        [103.897392, 30.681827],
                        [103.902592, 30.681531],
                        [103.905087, 30.682608],
                        [103.906268, 30.685814],
                        [103.910649, 30.686717],
                        [103.91383, 30.690932],
                        [103.918591, 30.695431],
                        [103.919087, 30.701141],
                        [103.923962, 30.703148],
                        [103.926839, 30.708682],
                        [103.931372, 30.707955],
                        [103.933791, 30.711281],
                        [103.930591, 30.717193],
                        [103.931467, 30.720505],
                        [103.936876, 30.716883],
                        [103.939752, 30.717772],
                        [103.937924, 30.721205],
                        [103.940724, 30.723157],
                        [103.944152, 30.723817],
                        [103.947161, 30.720559],
                        [103.953066, 30.721744],
                        [103.954837, 30.720882],
                        [103.953732, 30.71726],
                        [103.95457, 30.716129],
                        [103.957256, 30.716869],
                        [103.960703, 30.716008],
                        [103.961865, 30.711295],
                        [103.964913, 30.711833],
                        [103.970722, 30.710958],
                        [103.971522, 30.708453],
                        [103.97116, 30.705423],
                        [103.973808, 30.704966],
                        [103.973446, 30.698919],
                        [103.978703, 30.695336],
                        [103.980702, 30.692804],
                        [103.987712, 30.693626],
                        [103.990988, 30.696239],
                        [103.989121, 30.697451],
                        [103.989673, 30.700185],
                        [103.986721, 30.701141],
                        [103.989864, 30.704036],
                        [103.997673, 30.703363],
                        [103.999159, 30.702784],
                        [104.00112, 30.698178],
                        [104.004758, 30.698286],
                        [104.007253, 30.699592],
                        [104.009044, 30.69904],
                        [104.008111, 30.696724],
                        [104.010491, 30.693155],
                        [104.010263, 30.689047],
                        [104.005673, 30.688696],
                        [104.003692, 30.687552],
                        [104.005006, 30.685706],
                        [104.010168, 30.685922],
                        [104.011463, 30.683443],
                        [104.014053, 30.681975],
                        [104.017748, 30.682245],
                        [104.020339, 30.683659],
                        [104.027481, 30.681585],
                        [104.030414, 30.679712],
                        [104.032547, 30.67947],
                        [104.031271, 30.676466],
                        [104.032414, 30.671711],
                        [104.034262, 30.669245],
                        [104.038052, 30.667736],
                        [104.046756, 30.663075],
                        [104.050699, 30.667804],
                        [104.050813, 30.670835],
                        [104.052908, 30.675307],
                        [104.058584, 30.678352],
                        [104.060984, 30.678055],
                        [104.063098, 30.68246],
                        [104.068108, 30.68044],
                        [104.071022, 30.678406],
                        [104.074755, 30.677907],
                        [104.08325, 30.673031],
                        [104.085592, 30.672842],
                        [104.089611, 30.670094]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510106,
            "name": "金牛区",
            "center": [104.043487, 30.692058],
            "centroid": [104.056074, 30.729844],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 2,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [103.954837, 30.720882],
                        [103.958494, 30.722188],
                        [103.961199, 30.721905],
                        [103.961256, 30.724033],
                        [103.963256, 30.726294],
                        [103.965979, 30.724665],
                        [103.966227, 30.722713],
                        [103.971217, 30.719414],
                        [103.974265, 30.719185],
                        [103.980226, 30.720666],
                        [103.973427, 30.727304],
                        [103.97676, 30.728368],
                        [103.97695, 30.730064],
                        [103.980531, 30.729862],
                        [103.982912, 30.731801],
                        [103.984931, 30.730684],
                        [103.989712, 30.725904],
                        [103.992397, 30.725971],
                        [103.995064, 30.724706],
                        [103.995978, 30.726335],
                        [103.994473, 30.727668],
                        [103.999959, 30.734507],
                        [103.999044, 30.735503],
                        [104.00133, 30.737428],
                        [104.001444, 30.739555],
                        [103.997044, 30.744052],
                        [103.996625, 30.750674],
                        [103.997654, 30.754335],
                        [103.999368, 30.756812],
                        [104.00392, 30.758427],
                        [104.008625, 30.758925],
                        [104.011691, 30.758481],
                        [104.016872, 30.75381],
                        [104.015272, 30.750916],
                        [104.013044, 30.750176],
                        [104.012815, 30.748413],
                        [104.016624, 30.746865],
                        [104.019786, 30.748722],
                        [104.021329, 30.747646],
                        [104.020758, 30.7414],
                        [104.022548, 30.740646],
                        [104.02531, 30.741494],
                        [104.027862, 30.738573],
                        [104.0255, 30.73794],
                        [104.028643, 30.733592],
                        [104.037233, 30.729741],
                        [104.039271, 30.734736],
                        [104.036204, 30.738896],
                        [104.032814, 30.741777],
                        [104.031424, 30.745061],
                        [104.036738, 30.745923],
                        [104.042756, 30.750486],
                        [104.048566, 30.752505],
                        [104.05007, 30.751253],
                        [104.054775, 30.74984],
                        [104.067231, 30.740511],
                        [104.072698, 30.739528],
                        [104.075212, 30.74148],
                        [104.077231, 30.749153],
                        [104.078983, 30.752128],
                        [104.081935, 30.753582],
                        [104.086069, 30.753958],
                        [104.091287, 30.756152],
                        [104.095382, 30.758925],
                        [104.096582, 30.760702],
                        [104.094716, 30.763084],
                        [104.096792, 30.764591],
                        [104.095973, 30.766179],
                        [104.094011, 30.765237],
                        [104.08963, 30.765318],
                        [104.089078, 30.768292],
                        [104.084811, 30.767592],
                        [104.081288, 30.764928],
                        [104.080412, 30.761576],
                        [104.075612, 30.761267],
                        [104.075517, 30.763716],
                        [104.073364, 30.761375],
                        [104.07026, 30.762424],
                        [104.069155, 30.764093],
                        [104.072507, 30.765627],
                        [104.071174, 30.767619],
                        [104.06925, 30.767592],
                        [104.072012, 30.773137],
                        [104.073098, 30.778291],
                        [104.071307, 30.781574],
                        [104.067136, 30.783956],
                        [104.065746, 30.783848],
                        [104.065136, 30.780538],
                        [104.062736, 30.780215],
                        [104.056737, 30.784225],
                        [104.057137, 30.787871],
                        [104.059289, 30.789338],
                        [104.061098, 30.792379],
                        [104.061155, 30.798164],
                        [104.063155, 30.799159],
                        [104.065936, 30.796361],
                        [104.069631, 30.795944],
                        [104.071764, 30.797316],
                        [104.072583, 30.802321],
                        [104.075688, 30.80224],
                        [104.081154, 30.804971],
                        [104.083783, 30.804608],
                        [104.084811, 30.80668],
                        [104.087192, 30.806693],
                        [104.089725, 30.803209],
                        [104.086316, 30.799846],
                        [104.086697, 30.798406],
                        [104.089402, 30.799106],
                        [104.091363, 30.802039],
                        [104.093135, 30.801541],
                        [104.093897, 30.798487],
                        [104.09064, 30.795096],
                        [104.091916, 30.793455],
                        [104.098411, 30.795742],
                        [104.101268, 30.794262],
                        [104.102868, 30.790993],
                        [104.107439, 30.788154],
                        [104.110886, 30.787024],
                        [104.119305, 30.785705],
                        [104.122981, 30.783741],
                        [104.125686, 30.779636],
                        [104.125647, 30.77743],
                        [104.123762, 30.775411],
                        [104.11761, 30.77128],
                        [104.117819, 30.767835],
                        [104.122067, 30.765654],
                        [104.132314, 30.76556],
                        [104.13719, 30.76272],
                        [104.138961, 30.758252],
                        [104.139818, 30.748965],
                        [104.139609, 30.743984],
                        [104.137209, 30.74385],
                        [104.134923, 30.74809],
                        [104.130142, 30.747699],
                        [104.127228, 30.749328],
                        [104.125705, 30.746771],
                        [104.126009, 30.742678],
                        [104.128352, 30.74144],
                        [104.126752, 30.739852],
                        [104.122143, 30.739367],
                        [104.121057, 30.736378],
                        [104.118695, 30.736715],
                        [104.119591, 30.733538],
                        [104.115324, 30.730118],
                        [104.113458, 30.730832],
                        [104.107134, 30.728866],
                        [104.104353, 30.731316],
                        [104.102258, 30.729418],
                        [104.102982, 30.724167],
                        [104.100315, 30.722282],
                        [104.092716, 30.721932],
                        [104.089402, 30.720868],
                        [104.088202, 30.718983],
                        [104.088621, 30.713719],
                        [104.082164, 30.713288],
                        [104.082259, 30.715321],
                        [104.077574, 30.715281],
                        [104.074526, 30.713315],
                        [104.072203, 30.713584],
                        [104.073688, 30.7166],
                        [104.071669, 30.718391],
                        [104.070755, 30.716237],
                        [104.071288, 30.708723],
                        [104.069688, 30.708292],
                        [104.071822, 30.705585],
                        [104.071669, 30.697747],
                        [104.093001, 30.697397],
                        [104.091287, 30.695431],
                        [104.093649, 30.694313],
                        [104.093306, 30.692185],
                        [104.091421, 30.690542],
                        [104.091859, 30.688333],
                        [104.093859, 30.687296],
                        [104.088792, 30.679672],
                        [104.094716, 30.676722],
                        [104.089611, 30.670094],
                        [104.085592, 30.672842],
                        [104.08325, 30.673031],
                        [104.074755, 30.677907],
                        [104.071022, 30.678406],
                        [104.068108, 30.68044],
                        [104.063098, 30.68246],
                        [104.060984, 30.678055],
                        [104.058584, 30.678352],
                        [104.052908, 30.675307],
                        [104.050813, 30.670835],
                        [104.050699, 30.667804],
                        [104.046756, 30.663075],
                        [104.038052, 30.667736],
                        [104.034262, 30.669245],
                        [104.032414, 30.671711],
                        [104.031271, 30.676466],
                        [104.032547, 30.67947],
                        [104.030414, 30.679712],
                        [104.027481, 30.681585],
                        [104.020339, 30.683659],
                        [104.017748, 30.682245],
                        [104.014053, 30.681975],
                        [104.011463, 30.683443],
                        [104.010168, 30.685922],
                        [104.005006, 30.685706],
                        [104.003692, 30.687552],
                        [104.005673, 30.688696],
                        [104.010263, 30.689047],
                        [104.010491, 30.693155],
                        [104.008111, 30.696724],
                        [104.009044, 30.69904],
                        [104.007253, 30.699592],
                        [104.004758, 30.698286],
                        [104.00112, 30.698178],
                        [103.999159, 30.702784],
                        [103.997673, 30.703363],
                        [103.989864, 30.704036],
                        [103.986721, 30.701141],
                        [103.989673, 30.700185],
                        [103.989121, 30.697451],
                        [103.990988, 30.696239],
                        [103.987712, 30.693626],
                        [103.980702, 30.692804],
                        [103.978703, 30.695336],
                        [103.973446, 30.698919],
                        [103.973808, 30.704966],
                        [103.97116, 30.705423],
                        [103.971522, 30.708453],
                        [103.970722, 30.710958],
                        [103.964913, 30.711833],
                        [103.961865, 30.711295],
                        [103.960703, 30.716008],
                        [103.957256, 30.716869],
                        [103.95457, 30.716129],
                        [103.953732, 30.71726],
                        [103.954837, 30.720882]
                    ]
                ],
                [
                    [
                        [103.96137, 30.77677],
                        [103.959942, 30.776945],
                        [103.957523, 30.772679],
                        [103.95278, 30.772101],
                        [103.952266, 30.768898],
                        [103.948742, 30.769234],
                        [103.948704, 30.773164],
                        [103.944876, 30.775505],
                        [103.946838, 30.778183],
                        [103.949047, 30.776757],
                        [103.952342, 30.777026],
                        [103.948476, 30.779892],
                        [103.95537, 30.785167],
                        [103.959865, 30.783646],
                        [103.963751, 30.782274],
                        [103.963675, 30.780148],
                        [103.96137, 30.77677]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510107,
            "name": "武侯区",
            "center": [104.05167, 30.630862],
            "centroid": [104.025627, 30.604738],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 3,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [103.949847, 30.658589],
                        [103.952875, 30.658521],
                        [103.955466, 30.661351],
                        [103.958437, 30.661647],
                        [103.958951, 30.664032],
                        [103.970132, 30.662253],
                        [103.967503, 30.658764],
                        [103.969236, 30.656231],
                        [103.971103, 30.656541],
                        [103.973122, 30.659074],
                        [103.977769, 30.660798],
                        [103.981655, 30.65778],
                        [103.985369, 30.661593],
                        [103.98855, 30.660407],
                        [103.989102, 30.658198],
                        [103.990854, 30.660717],
                        [103.994797, 30.657497],
                        [103.993749, 30.654695],
                        [103.997292, 30.655449],
                        [103.997825, 30.660192],
                        [104.000092, 30.661041],
                        [104.002644, 30.659491],
                        [104.005596, 30.659316],
                        [104.006415, 30.657187],
                        [104.005368, 30.654991],
                        [104.007844, 30.652822],
                        [104.013863, 30.654439],
                        [104.015272, 30.656743],
                        [104.018777, 30.657349],
                        [104.022281, 30.651582],
                        [104.026738, 30.650747],
                        [104.037271, 30.650814],
                        [104.039899, 30.651528],
                        [104.053956, 30.651717],
                        [104.056051, 30.64909],
                        [104.059956, 30.647001],
                        [104.064698, 30.646772],
                        [104.07864, 30.64529],
                        [104.084926, 30.641975],
                        [104.087707, 30.64122],
                        [104.09083, 30.637946],
                        [104.09422, 30.630223],
                        [104.092982, 30.62711],
                        [104.086468, 30.626032],
                        [104.084564, 30.623687],
                        [104.085707, 30.619333],
                        [104.084526, 30.61653],
                        [104.088049, 30.608887],
                        [104.087211, 30.60305],
                        [104.083173, 30.601419],
                        [104.081707, 30.599585],
                        [104.082278, 30.595001],
                        [104.08365, 30.59186],
                        [104.080202, 30.590202],
                        [104.078469, 30.587397],
                        [104.079859, 30.579482],
                        [104.073879, 30.573185],
                        [104.074031, 30.570866],
                        [104.077498, 30.569625],
                        [104.080831, 30.569975],
                        [104.082869, 30.567777],
                        [104.079745, 30.561668],
                        [104.083878, 30.558121],
                        [104.084945, 30.555788],
                        [104.084659, 30.553063],
                        [104.081764, 30.550932],
                        [104.076659, 30.550298],
                        [104.074717, 30.547722],
                        [104.076907, 30.541409],
                        [104.081212, 30.539952],
                        [104.080126, 30.537025],
                        [104.075269, 30.536647],
                        [104.072907, 30.53577],
                        [104.068907, 30.532222],
                        [104.063898, 30.529821],
                        [104.063917, 30.53403],
                        [104.05746, 30.534178],
                        [104.057384, 30.533194],
                        [104.05268, 30.53345],
                        [104.052642, 30.536458],
                        [104.046661, 30.536445],
                        [104.044014, 30.535622],
                        [104.043842, 30.530482],
                        [104.03049, 30.529106],
                        [104.020358, 30.530293],
                        [104.019577, 30.533463],
                        [104.016815, 30.534785],
                        [104.018643, 30.537551],
                        [104.015786, 30.538495],
                        [104.011748, 30.537214],
                        [104.010929, 30.540235],
                        [104.014586, 30.542461],
                        [104.017996, 30.543136],
                        [104.017862, 30.545645],
                        [104.021272, 30.549179],
                        [104.022377, 30.554493],
                        [104.026072, 30.560333],
                        [104.026472, 30.562599],
                        [104.032528, 30.563718],
                        [104.0343, 30.567696],
                        [104.034566, 30.573145],
                        [104.031386, 30.577446],
                        [104.029843, 30.577932],
                        [104.026167, 30.576678],
                        [104.023386, 30.578053],
                        [104.018796, 30.583878],
                        [104.016205, 30.585011],
                        [104.009672, 30.586534],
                        [104.007177, 30.585375],
                        [104.009253, 30.583312],
                        [104.00573, 30.579631],
                        [104.005596, 30.577217],
                        [104.003387, 30.577406],
                        [104.003806, 30.580966],
                        [103.998835, 30.581249],
                        [103.991102, 30.584808],
                        [103.986531, 30.584741],
                        [103.982683, 30.582678],
                        [103.979274, 30.579307],
                        [103.978855, 30.574871],
                        [103.977636, 30.572254],
                        [103.970722, 30.572133],
                        [103.966322, 30.574951],
                        [103.968246, 30.577554],
                        [103.965789, 30.578242],
                        [103.966037, 30.580426],
                        [103.964532, 30.582826],
                        [103.96217, 30.582732],
                        [103.958399, 30.585523],
                        [103.957047, 30.587478],
                        [103.958532, 30.589716],
                        [103.962913, 30.588435],
                        [103.962703, 30.585577],
                        [103.965579, 30.583662],
                        [103.965332, 30.587289],
                        [103.966779, 30.589487],
                        [103.965275, 30.594206],
                        [103.966322, 30.596525],
                        [103.965484, 30.599342],
                        [103.966722, 30.601001],
                        [103.96676, 30.606568],
                        [103.963941, 30.605193],
                        [103.961999, 30.607889],
                        [103.957694, 30.607579],
                        [103.956266, 30.610828],
                        [103.956475, 30.616961],
                        [103.955694, 30.619077],
                        [103.958589, 30.621301],
                        [103.958665, 30.624415],
                        [103.961637, 30.623768],
                        [103.961694, 30.625008],
                        [103.956894, 30.628768],
                        [103.956323, 30.630641],
                        [103.953142, 30.633067],
                        [103.953942, 30.636557],
                        [103.951504, 30.637919],
                        [103.952685, 30.640749],
                        [103.952399, 30.644724],
                        [103.949542, 30.644549],
                        [103.947885, 30.648025],
                        [103.950761, 30.650976],
                        [103.951637, 30.653442],
                        [103.949847, 30.658589]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510108,
            "name": "成华区",
            "center": [104.103077, 30.660275],
            "centroid": [104.143973, 30.688388],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 4,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [104.089611, 30.670094],
                        [104.094716, 30.676722],
                        [104.088792, 30.679672],
                        [104.093859, 30.687296],
                        [104.091859, 30.688333],
                        [104.091421, 30.690542],
                        [104.093306, 30.692185],
                        [104.093649, 30.694313],
                        [104.091287, 30.695431],
                        [104.093001, 30.697397],
                        [104.071669, 30.697747],
                        [104.071822, 30.705585],
                        [104.069688, 30.708292],
                        [104.071288, 30.708723],
                        [104.070755, 30.716237],
                        [104.071669, 30.718391],
                        [104.073688, 30.7166],
                        [104.072203, 30.713584],
                        [104.074526, 30.713315],
                        [104.077574, 30.715281],
                        [104.082259, 30.715321],
                        [104.082164, 30.713288],
                        [104.088621, 30.713719],
                        [104.088202, 30.718983],
                        [104.089402, 30.720868],
                        [104.092716, 30.721932],
                        [104.100315, 30.722282],
                        [104.102982, 30.724167],
                        [104.102258, 30.729418],
                        [104.104353, 30.731316],
                        [104.107134, 30.728866],
                        [104.113458, 30.730832],
                        [104.115324, 30.730118],
                        [104.119591, 30.733538],
                        [104.118695, 30.736715],
                        [104.121057, 30.736378],
                        [104.122143, 30.739367],
                        [104.126752, 30.739852],
                        [104.128352, 30.74144],
                        [104.126009, 30.742678],
                        [104.125705, 30.746771],
                        [104.127228, 30.749328],
                        [104.130142, 30.747699],
                        [104.134923, 30.74809],
                        [104.137209, 30.74385],
                        [104.139609, 30.743984],
                        [104.140847, 30.741103],
                        [104.133399, 30.738317],
                        [104.136923, 30.735759],
                        [104.138333, 30.735759],
                        [104.142808, 30.738573],
                        [104.14677, 30.739057],
                        [104.157722, 30.738855],
                        [104.164084, 30.736755],
                        [104.164922, 30.734345],
                        [104.162769, 30.732905],
                        [104.162979, 30.729983],
                        [104.165779, 30.724019],
                        [104.168712, 30.724773],
                        [104.171626, 30.727856],
                        [104.176616, 30.730266],
                        [104.182235, 30.728785],
                        [104.181416, 30.722215],
                        [104.183149, 30.721784],
                        [104.186311, 30.725473],
                        [104.188387, 30.725837],
                        [104.191587, 30.723817],
                        [104.188749, 30.715079],
                        [104.189054, 30.713072],
                        [104.193054, 30.712372],
                        [104.196406, 30.710662],
                        [104.20191, 30.711362],
                        [104.207815, 30.707053],
                        [104.210329, 30.706703],
                        [104.212995, 30.712183],
                        [104.215376, 30.713651],
                        [104.220481, 30.714728],
                        [104.224442, 30.714809],
                        [104.229223, 30.712183],
                        [104.228976, 30.710541],
                        [104.225719, 30.709733],
                        [104.223395, 30.708063],
                        [104.2233, 30.706312],
                        [104.225185, 30.7037],
                        [104.228595, 30.701868],
                        [104.228042, 30.695862],
                        [104.229528, 30.693963],
                        [104.233851, 30.691713],
                        [104.236251, 30.689383],
                        [104.236251, 30.686959],
                        [104.232823, 30.687525],
                        [104.225166, 30.682096],
                        [104.219795, 30.681706],
                        [104.212386, 30.68273],
                        [104.208786, 30.681463],
                        [104.204882, 30.683807],
                        [104.200272, 30.682689],
                        [104.198787, 30.684225],
                        [104.192292, 30.682083],
                        [104.189968, 30.676587],
                        [104.188006, 30.674634],
                        [104.182083, 30.672142],
                        [104.176559, 30.671226],
                        [104.174083, 30.669569],
                        [104.169245, 30.669838],
                        [104.16715, 30.673421],
                        [104.164122, 30.673704],
                        [104.161112, 30.671401],
                        [104.158427, 30.667238],
                        [104.158065, 30.664813],
                        [104.159208, 30.661566],
                        [104.156884, 30.661741],
                        [104.15517, 30.665514],
                        [104.148732, 30.666713],
                        [104.147799, 30.665029],
                        [104.149475, 30.660919],
                        [104.151075, 30.660825],
                        [104.15317, 30.663075],
                        [104.155246, 30.661701],
                        [104.155608, 30.65324],
                        [104.157341, 30.650639],
                        [104.160236, 30.648537],
                        [104.157951, 30.647702],
                        [104.157741, 30.643821],
                        [104.161531, 30.64343],
                        [104.16395, 30.639414],
                        [104.164674, 30.635803],
                        [104.161798, 30.628795],
                        [104.161665, 30.625992],
                        [104.163931, 30.622609],
                        [104.162236, 30.619131],
                        [104.158312, 30.619037],
                        [104.156046, 30.622231],
                        [104.145532, 30.621813],
                        [104.141609, 30.61994],
                        [104.140332, 30.617217],
                        [104.139037, 30.616665],
                        [104.137818, 30.618821],
                        [104.134123, 30.618471],
                        [104.132942, 30.617271],
                        [104.128657, 30.618565],
                        [104.124371, 30.6218],
                        [104.126866, 30.624145],
                        [104.123609, 30.62525],
                        [104.126752, 30.625479],
                        [104.129133, 30.628134],
                        [104.12639, 30.631329],
                        [104.127781, 30.634657],
                        [104.123914, 30.637097],
                        [104.105953, 30.645586],
                        [104.088506, 30.653563],
                        [104.091897, 30.658333],
                        [104.093363, 30.662604],
                        [104.095954, 30.663425],
                        [104.096449, 30.664961],
                        [104.091916, 30.668882],
                        [104.089611, 30.670094]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510112,
            "name": "龙泉驿区",
            "center": [104.269181, 30.56065],
            "centroid": [104.294729, 30.597369],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 5,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [104.236251, 30.686959],
                        [104.234861, 30.681854],
                        [104.235318, 30.680386],
                        [104.241432, 30.679268],
                        [104.243984, 30.676331],
                        [104.246194, 30.676385],
                        [104.249965, 30.678581],
                        [104.247679, 30.678123],
                        [104.248441, 30.680951],
                        [104.252746, 30.681005],
                        [104.252689, 30.684831],
                        [104.251317, 30.686312],
                        [104.25267, 30.687484],
                        [104.25465, 30.686178],
                        [104.255774, 30.687902],
                        [104.253165, 30.690434],
                        [104.256517, 30.692737],
                        [104.257184, 30.695646],
                        [104.264174, 30.693155],
                        [104.264936, 30.697424],
                        [104.262574, 30.698192],
                        [104.260479, 30.701289],
                        [104.265393, 30.704521],
                        [104.264974, 30.706299],
                        [104.267183, 30.710244],
                        [104.269526, 30.711308],
                        [104.268059, 30.712197],
                        [104.270421, 30.716492],
                        [104.273392, 30.717866],
                        [104.275049, 30.71726],
                        [104.277335, 30.714432],
                        [104.281144, 30.714055],
                        [104.285049, 30.712439],
                        [104.288058, 30.717112],
                        [104.293467, 30.715577],
                        [104.296801, 30.715927],
                        [104.301048, 30.718593],
                        [104.306019, 30.717987],
                        [104.319409, 30.714553],
                        [104.320952, 30.71493],
                        [104.320666, 30.720047],
                        [104.321657, 30.72208],
                        [104.32419, 30.722578],
                        [104.327485, 30.721057],
                        [104.33697, 30.712022],
                        [104.339579, 30.710339],
                        [104.371406, 30.69799],
                        [104.375044, 30.699282],
                        [104.39091, 30.69671],
                        [104.39392, 30.69504],
                        [104.394662, 30.691821],
                        [104.394129, 30.684063],
                        [104.394967, 30.681194],
                        [104.397253, 30.679146],
                        [104.413747, 30.672505],
                        [104.415423, 30.6752],
                        [104.416833, 30.683376],
                        [104.418071, 30.68545],
                        [104.423728, 30.685868],
                        [104.428908, 30.684076],
                        [104.436051, 30.679685],
                        [104.438908, 30.675321],
                        [104.439727, 30.668464],
                        [104.440127, 30.663978],
                        [104.436508, 30.66003],
                        [104.432222, 30.649143],
                        [104.432146, 30.64277],
                        [104.43068, 30.638336],
                        [104.431156, 30.635708],
                        [104.433365, 30.634563],
                        [104.436641, 30.635089],
                        [104.439689, 30.637272],
                        [104.442165, 30.646139],
                        [104.44586, 30.650989],
                        [104.449707, 30.653576],
                        [104.452355, 30.651609],
                        [104.454202, 30.643147],
                        [104.45464, 30.635304],
                        [104.454412, 30.63176],
                        [104.452945, 30.627649],
                        [104.448888, 30.623741],
                        [104.44786, 30.620196],
                        [104.448031, 30.617028],
                        [104.441593, 30.611825],
                        [104.438489, 30.610248],
                        [104.436032, 30.610221],
                        [104.432584, 30.612189],
                        [104.429499, 30.612472],
                        [104.428299, 30.611219],
                        [104.427918, 30.605867],
                        [104.425956, 30.601756],
                        [104.421137, 30.598493],
                        [104.415861, 30.598291],
                        [104.410357, 30.596215],
                        [104.405443, 30.591429],
                        [104.4051, 30.587451],
                        [104.40251, 30.58284],
                        [104.402148, 30.578174],
                        [104.403043, 30.571081],
                        [104.407366, 30.564015],
                        [104.407519, 30.562369],
                        [104.40331, 30.556583],
                        [104.402605, 30.554641],
                        [104.401862, 30.54292],
                        [104.40211, 30.537254],
                        [104.398567, 30.532735],
                        [104.398967, 30.530468],
                        [104.400967, 30.527635],
                        [104.404186, 30.524748],
                        [104.407614, 30.523345],
                        [104.412014, 30.523669],
                        [104.414642, 30.522333],
                        [104.415766, 30.519081],
                        [104.414776, 30.515533],
                        [104.411271, 30.511863],
                        [104.404205, 30.508287],
                        [104.398319, 30.506033],
                        [104.395767, 30.504306],
                        [104.395558, 30.500703],
                        [104.397348, 30.496681],
                        [104.396872, 30.490648],
                        [104.39251, 30.486815],
                        [104.390091, 30.486302],
                        [104.385044, 30.48807],
                        [104.383463, 30.487693],
                        [104.373349, 30.489798],
                        [104.366645, 30.48969],
                        [104.363083, 30.484102],
                        [104.361083, 30.482766],
                        [104.352912, 30.483805],
                        [104.350969, 30.481281],
                        [104.348798, 30.482159],
                        [104.342303, 30.480863],
                        [104.340037, 30.481781],
                        [104.340284, 30.484615],
                        [104.34436, 30.488097],
                        [104.345103, 30.491485],
                        [104.342722, 30.498921],
                        [104.336818, 30.510365],
                        [104.331504, 30.514912],
                        [104.327237, 30.516639],
                        [104.324494, 30.515209],
                        [104.323371, 30.510095],
                        [104.32518, 30.508853],
                        [104.329713, 30.50915],
                        [104.331827, 30.508516],
                        [104.33257, 30.506195],
                        [104.329561, 30.501296],
                        [104.333313, 30.495682],
                        [104.329904, 30.492011],
                        [104.327504, 30.492997],
                        [104.320609, 30.492902],
                        [104.314705, 30.492079],
                        [104.312743, 30.49297],
                        [104.304991, 30.499056],
                        [104.301239, 30.500622],
                        [104.299391, 30.504063],
                        [104.294877, 30.504927],
                        [104.293582, 30.503928],
                        [104.292401, 30.499272],
                        [104.289392, 30.496425],
                        [104.282916, 30.492929],
                        [104.273659, 30.487085],
                        [104.26465, 30.485992],
                        [104.258536, 30.483252],
                        [104.25526, 30.4795],
                        [104.254212, 30.476773],
                        [104.254898, 30.474816],
                        [104.260155, 30.47082],
                        [104.259412, 30.468134],
                        [104.254612, 30.467283],
                        [104.249851, 30.46569],
                        [104.247851, 30.463976],
                        [104.227642, 30.468174],
                        [104.223166, 30.470334],
                        [104.22269, 30.475342],
                        [104.220671, 30.475342],
                        [104.218957, 30.477623],
                        [104.217186, 30.477353],
                        [104.214519, 30.480296],
                        [104.209319, 30.480984],
                        [104.2073, 30.480525],
                        [104.204958, 30.482402],
                        [104.207815, 30.483414],
                        [104.205929, 30.485573],
                        [104.204139, 30.484453],
                        [104.202539, 30.488043],
                        [104.200482, 30.48996],
                        [104.202044, 30.492254],
                        [104.20092, 30.494441],
                        [104.200786, 30.498166],
                        [104.19871, 30.503024],
                        [104.196444, 30.503348],
                        [104.193892, 30.509434],
                        [104.188101, 30.518177],
                        [104.185892, 30.526664],
                        [104.183721, 30.5309],
                        [104.180311, 30.533801],
                        [104.178026, 30.532816],
                        [104.176083, 30.534758],
                        [104.174502, 30.538927],
                        [104.171055, 30.541935],
                        [104.165093, 30.542879],
                        [104.162407, 30.543904],
                        [104.156046, 30.547938],
                        [104.154103, 30.549961],
                        [104.153798, 30.553994],
                        [104.155379, 30.558728],
                        [104.154103, 30.561695],
                        [104.156522, 30.563947],
                        [104.160827, 30.56268],
                        [104.164236, 30.563219],
                        [104.165017, 30.564568],
                        [104.161303, 30.566011],
                        [104.160865, 30.56713],
                        [104.168331, 30.567265],
                        [104.167379, 30.570218],
                        [104.167779, 30.572956],
                        [104.164884, 30.575248],
                        [104.165284, 30.569423],
                        [104.163246, 30.569126],
                        [104.163341, 30.573684],
                        [104.15936, 30.576057],
                        [104.162979, 30.577932],
                        [104.163512, 30.579954],
                        [104.166731, 30.583312],
                        [104.171626, 30.591334],
                        [104.169436, 30.594327],
                        [104.166788, 30.592372],
                        [104.167112, 30.590498],
                        [104.164807, 30.58942],
                        [104.161665, 30.591132],
                        [104.156655, 30.592615],
                        [104.156903, 30.595177],
                        [104.153303, 30.597617],
                        [104.158503, 30.60394],
                        [104.155646, 30.605315],
                        [104.149646, 30.606757],
                        [104.149322, 30.609156],
                        [104.145113, 30.610531],
                        [104.144675, 30.613753],
                        [104.142808, 30.616772],
                        [104.140332, 30.617217],
                        [104.141609, 30.61994],
                        [104.145532, 30.621813],
                        [104.156046, 30.622231],
                        [104.158312, 30.619037],
                        [104.162236, 30.619131],
                        [104.163931, 30.622609],
                        [104.161665, 30.625992],
                        [104.161798, 30.628795],
                        [104.164674, 30.635803],
                        [104.16395, 30.639414],
                        [104.161531, 30.64343],
                        [104.157741, 30.643821],
                        [104.157951, 30.647702],
                        [104.160236, 30.648537],
                        [104.157341, 30.650639],
                        [104.155608, 30.65324],
                        [104.155246, 30.661701],
                        [104.15317, 30.663075],
                        [104.151075, 30.660825],
                        [104.149475, 30.660919],
                        [104.147799, 30.665029],
                        [104.148732, 30.666713],
                        [104.15517, 30.665514],
                        [104.156884, 30.661741],
                        [104.159208, 30.661566],
                        [104.158065, 30.664813],
                        [104.158427, 30.667238],
                        [104.161112, 30.671401],
                        [104.164122, 30.673704],
                        [104.16715, 30.673421],
                        [104.169245, 30.669838],
                        [104.174083, 30.669569],
                        [104.176559, 30.671226],
                        [104.182083, 30.672142],
                        [104.188006, 30.674634],
                        [104.189968, 30.676587],
                        [104.192292, 30.682083],
                        [104.198787, 30.684225],
                        [104.200272, 30.682689],
                        [104.204882, 30.683807],
                        [104.208786, 30.681463],
                        [104.212386, 30.68273],
                        [104.219795, 30.681706],
                        [104.225166, 30.682096],
                        [104.232823, 30.687525],
                        [104.236251, 30.686959]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510113,
            "name": "青白江区",
            "center": [104.25494, 30.883438],
            "centroid": [104.340354, 30.793354],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 6,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [104.188539, 30.910141],
                        [104.19433, 30.912895],
                        [104.202348, 30.913151],
                        [104.205243, 30.911511],
                        [104.206729, 30.909227],
                        [104.206158, 30.905155],
                        [104.211853, 30.905169],
                        [104.21191, 30.903516],
                        [104.215757, 30.898395],
                        [104.217738, 30.898341],
                        [104.219528, 30.901258],
                        [104.222957, 30.900801],
                        [104.228557, 30.894874],
                        [104.230214, 30.894874],
                        [104.233375, 30.897777],
                        [104.246784, 30.897199],
                        [104.254212, 30.900935],
                        [104.25745, 30.905128],
                        [104.260212, 30.905424],
                        [104.262364, 30.904134],
                        [104.262726, 30.900021],
                        [104.266707, 30.898893],
                        [104.269697, 30.901097],
                        [104.273983, 30.901742],
                        [104.282916, 30.900357],
                        [104.288687, 30.902897],
                        [104.301886, 30.899914],
                        [104.304229, 30.898503],
                        [104.31, 30.89767],
                        [104.314971, 30.894041],
                        [104.321028, 30.891729],
                        [104.32358, 30.892388],
                        [104.327047, 30.895156],
                        [104.330799, 30.89982],
                        [104.33537, 30.901459],
                        [104.337922, 30.901459],
                        [104.338894, 30.898489],
                        [104.34537, 30.902467],
                        [104.34657, 30.905666],
                        [104.348646, 30.905128],
                        [104.351312, 30.902252],
                        [104.35476, 30.900532],
                        [104.352188, 30.896809],
                        [104.352512, 30.895344],
                        [104.357293, 30.888987],
                        [104.35895, 30.882844],
                        [104.362093, 30.879645],
                        [104.365045, 30.880035],
                        [104.369502, 30.882696],
                        [104.372511, 30.882737],
                        [104.374797, 30.879901],
                        [104.381863, 30.87861],
                        [104.384244, 30.874846],
                        [104.386129, 30.866269],
                        [104.385501, 30.862814],
                        [104.380606, 30.858646],
                        [104.379063, 30.856643],
                        [104.37832, 30.84879],
                        [104.37552, 30.845697],
                        [104.371406, 30.84645],
                        [104.36495, 30.846464],
                        [104.360969, 30.844985],
                        [104.352741, 30.845321],
                        [104.35076, 30.843559],
                        [104.350779, 30.841677],
                        [104.35316, 30.835894],
                        [104.353979, 30.832021],
                        [104.357007, 30.83194],
                        [104.361769, 30.835396],
                        [104.363064, 30.839243],
                        [104.36594, 30.838974],
                        [104.368854, 30.833527],
                        [104.371273, 30.830663],
                        [104.371654, 30.828659],
                        [104.367673, 30.822794],
                        [104.367349, 30.819876],
                        [104.371006, 30.813634],
                        [104.371959, 30.809814],
                        [104.374397, 30.808603],
                        [104.375844, 30.805859],
                        [104.382149, 30.80333],
                        [104.383387, 30.801245],
                        [104.381273, 30.798177],
                        [104.381596, 30.794141],
                        [104.377025, 30.792136],
                        [104.37613, 30.790751],
                        [104.377197, 30.787616],
                        [104.379444, 30.785409],
                        [104.383672, 30.784171],
                        [104.391158, 30.78588],
                        [104.393729, 30.785073],
                        [104.401691, 30.781305],
                        [104.405233, 30.780363],
                        [104.410281, 30.781197],
                        [104.41388, 30.783781],
                        [104.416833, 30.786808],
                        [104.419099, 30.787831],
                        [104.426051, 30.788894],
                        [104.430661, 30.792527],
                        [104.431841, 30.791881],
                        [104.429956, 30.789069],
                        [104.423232, 30.784763],
                        [104.421728, 30.782301],
                        [104.425099, 30.77494],
                        [104.427861, 30.772666],
                        [104.431232, 30.772128],
                        [104.434356, 30.773218],
                        [104.43807, 30.777443],
                        [104.440241, 30.778331],
                        [104.442565, 30.777685],
                        [104.448088, 30.772006],
                        [104.450679, 30.770647],
                        [104.452717, 30.77128],
                        [104.462735, 30.779394],
                        [104.466449, 30.779569],
                        [104.472296, 30.778291],
                        [104.474639, 30.77638],
                        [104.47582, 30.77346],
                        [104.475477, 30.770903],
                        [104.473649, 30.767323],
                        [104.473535, 30.764362],
                        [104.475211, 30.755304],
                        [104.475439, 30.746636],
                        [104.477058, 30.742625],
                        [104.479249, 30.739273],
                        [104.47523, 30.732474],
                        [104.468887, 30.727641],
                        [104.467859, 30.723709],
                        [104.468449, 30.72002],
                        [104.470239, 30.718903],
                        [104.477325, 30.719711],
                        [104.481648, 30.721555],
                        [104.48222, 30.722861],
                        [104.479801, 30.724127],
                        [104.479249, 30.726227],
                        [104.48321, 30.725352],
                        [104.487381, 30.722309],
                        [104.48782, 30.718647],
                        [104.483591, 30.717246],
                        [104.485534, 30.714244],
                        [104.487362, 30.709625],
                        [104.487096, 30.707147],
                        [104.485229, 30.70238],
                        [104.479439, 30.694892],
                        [104.479001, 30.69236],
                        [104.486581, 30.691579],
                        [104.491553, 30.688979],
                        [104.493953, 30.684157],
                        [104.491876, 30.680965],
                        [104.484201, 30.679712],
                        [104.48302, 30.678419],
                        [104.481667, 30.669582],
                        [104.484715, 30.665392],
                        [104.483248, 30.662644],
                        [104.477839, 30.661068],
                        [104.469763, 30.66356],
                        [104.458202, 30.669582],
                        [104.452259, 30.671024],
                        [104.447231, 30.671455],
                        [104.453421, 30.663883],
                        [104.452697, 30.661175],
                        [104.456088, 30.660596],
                        [104.456926, 30.658979],
                        [104.451307, 30.658225],
                        [104.447536, 30.661445],
                        [104.446145, 30.666335],
                        [104.439727, 30.668464],
                        [104.438908, 30.675321],
                        [104.436051, 30.679685],
                        [104.428908, 30.684076],
                        [104.423728, 30.685868],
                        [104.418071, 30.68545],
                        [104.416833, 30.683376],
                        [104.415423, 30.6752],
                        [104.413747, 30.672505],
                        [104.397253, 30.679146],
                        [104.394967, 30.681194],
                        [104.394129, 30.684063],
                        [104.394662, 30.691821],
                        [104.39392, 30.69504],
                        [104.39091, 30.69671],
                        [104.375044, 30.699282],
                        [104.371406, 30.69799],
                        [104.339579, 30.710339],
                        [104.33697, 30.712022],
                        [104.327485, 30.721057],
                        [104.326818, 30.727802],
                        [104.324418, 30.736176],
                        [104.327009, 30.739475],
                        [104.323809, 30.739973],
                        [104.321771, 30.742921],
                        [104.319409, 30.743217],
                        [104.318914, 30.746232],
                        [104.3176, 30.746596],
                        [104.310819, 30.740834],
                        [104.308438, 30.74113],
                        [104.305295, 30.744294],
                        [104.302248, 30.745748],
                        [104.29762, 30.746057],
                        [104.291049, 30.745734],
                        [104.287792, 30.742652],
                        [104.288153, 30.739488],
                        [104.285639, 30.737671],
                        [104.282782, 30.738478],
                        [104.279811, 30.737657],
                        [104.279373, 30.736365],
                        [104.274573, 30.740471],
                        [104.266402, 30.744132],
                        [104.261907, 30.748332],
                        [104.259431, 30.751764],
                        [104.258974, 30.754174],
                        [104.259812, 30.757606],
                        [104.265221, 30.760809],
                        [104.268574, 30.768615],
                        [104.268707, 30.77093],
                        [104.267316, 30.772639],
                        [104.263298, 30.775007],
                        [104.261641, 30.777134],
                        [104.259279, 30.784413],
                        [104.255641, 30.787306],
                        [104.255241, 30.789755],
                        [104.257222, 30.791571],
                        [104.253908, 30.795702],
                        [104.251946, 30.802334],
                        [104.24907, 30.80403],
                        [104.241337, 30.803962],
                        [104.240213, 30.805738],
                        [104.241089, 30.808482],
                        [104.238537, 30.81276],
                        [104.23269, 30.817966],
                        [104.23109, 30.821073],
                        [104.231623, 30.825283],
                        [104.23528, 30.832061],
                        [104.237318, 30.8335],
                        [104.242632, 30.830192],
                        [104.24627, 30.830649],
                        [104.243813, 30.835396],
                        [104.247241, 30.836365],
                        [104.247184, 30.838153],
                        [104.244308, 30.83966],
                        [104.241965, 30.843358],
                        [104.239127, 30.842631],
                        [104.238708, 30.844366],
                        [104.240175, 30.847163],
                        [104.239889, 30.849758],
                        [104.233775, 30.856414],
                        [104.231071, 30.858135],
                        [104.220309, 30.863069],
                        [104.215129, 30.863607],
                        [104.210215, 30.86108],
                        [104.207815, 30.864898],
                        [104.205662, 30.865772],
                        [104.200063, 30.859937],
                        [104.197149, 30.858404],
                        [104.194273, 30.858606],
                        [104.18972, 30.862774],
                        [104.184425, 30.864737],
                        [104.176731, 30.86436],
                        [104.173912, 30.86319],
                        [104.173493, 30.861523],
                        [104.169455, 30.855271],
                        [104.167207, 30.856199],
                        [104.165284, 30.859923],
                        [104.166674, 30.86233],
                        [104.16056, 30.867143],
                        [104.161131, 30.870074],
                        [104.16296, 30.871028],
                        [104.168274, 30.871754],
                        [104.170655, 30.876513],
                        [104.170731, 30.880936],
                        [104.170045, 30.885922],
                        [104.177188, 30.888557],
                        [104.181911, 30.892146],
                        [104.186863, 30.900814],
                        [104.188539, 30.910141]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510114,
            "name": "新都区",
            "center": [104.16022, 30.824223],
            "centroid": [104.11552, 30.830214],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 7,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [104.327485, 30.721057],
                        [104.32419, 30.722578],
                        [104.321657, 30.72208],
                        [104.320666, 30.720047],
                        [104.320952, 30.71493],
                        [104.319409, 30.714553],
                        [104.306019, 30.717987],
                        [104.301048, 30.718593],
                        [104.296801, 30.715927],
                        [104.293467, 30.715577],
                        [104.288058, 30.717112],
                        [104.285049, 30.712439],
                        [104.281144, 30.714055],
                        [104.277335, 30.714432],
                        [104.275049, 30.71726],
                        [104.273392, 30.717866],
                        [104.270421, 30.716492],
                        [104.268059, 30.712197],
                        [104.269526, 30.711308],
                        [104.267183, 30.710244],
                        [104.264974, 30.706299],
                        [104.265393, 30.704521],
                        [104.260479, 30.701289],
                        [104.262574, 30.698192],
                        [104.264936, 30.697424],
                        [104.264174, 30.693155],
                        [104.257184, 30.695646],
                        [104.256517, 30.692737],
                        [104.253165, 30.690434],
                        [104.255774, 30.687902],
                        [104.25465, 30.686178],
                        [104.25267, 30.687484],
                        [104.251317, 30.686312],
                        [104.252689, 30.684831],
                        [104.252746, 30.681005],
                        [104.248441, 30.680951],
                        [104.247679, 30.678123],
                        [104.249965, 30.678581],
                        [104.246194, 30.676385],
                        [104.243984, 30.676331],
                        [104.241432, 30.679268],
                        [104.235318, 30.680386],
                        [104.234861, 30.681854],
                        [104.236251, 30.686959],
                        [104.236251, 30.689383],
                        [104.233851, 30.691713],
                        [104.229528, 30.693963],
                        [104.228042, 30.695862],
                        [104.228595, 30.701868],
                        [104.225185, 30.7037],
                        [104.2233, 30.706312],
                        [104.223395, 30.708063],
                        [104.225719, 30.709733],
                        [104.228976, 30.710541],
                        [104.229223, 30.712183],
                        [104.224442, 30.714809],
                        [104.220481, 30.714728],
                        [104.215376, 30.713651],
                        [104.212995, 30.712183],
                        [104.210329, 30.706703],
                        [104.207815, 30.707053],
                        [104.20191, 30.711362],
                        [104.196406, 30.710662],
                        [104.193054, 30.712372],
                        [104.189054, 30.713072],
                        [104.188749, 30.715079],
                        [104.191587, 30.723817],
                        [104.188387, 30.725837],
                        [104.186311, 30.725473],
                        [104.183149, 30.721784],
                        [104.181416, 30.722215],
                        [104.182235, 30.728785],
                        [104.176616, 30.730266],
                        [104.171626, 30.727856],
                        [104.168712, 30.724773],
                        [104.165779, 30.724019],
                        [104.162979, 30.729983],
                        [104.162769, 30.732905],
                        [104.164922, 30.734345],
                        [104.164084, 30.736755],
                        [104.157722, 30.738855],
                        [104.14677, 30.739057],
                        [104.142808, 30.738573],
                        [104.138333, 30.735759],
                        [104.136923, 30.735759],
                        [104.133399, 30.738317],
                        [104.140847, 30.741103],
                        [104.139609, 30.743984],
                        [104.139818, 30.748965],
                        [104.138961, 30.758252],
                        [104.13719, 30.76272],
                        [104.132314, 30.76556],
                        [104.122067, 30.765654],
                        [104.117819, 30.767835],
                        [104.11761, 30.77128],
                        [104.123762, 30.775411],
                        [104.125647, 30.77743],
                        [104.125686, 30.779636],
                        [104.122981, 30.783741],
                        [104.119305, 30.785705],
                        [104.110886, 30.787024],
                        [104.107439, 30.788154],
                        [104.102868, 30.790993],
                        [104.101268, 30.794262],
                        [104.098411, 30.795742],
                        [104.091916, 30.793455],
                        [104.09064, 30.795096],
                        [104.093897, 30.798487],
                        [104.093135, 30.801541],
                        [104.091363, 30.802039],
                        [104.089402, 30.799106],
                        [104.086697, 30.798406],
                        [104.086316, 30.799846],
                        [104.089725, 30.803209],
                        [104.087192, 30.806693],
                        [104.084811, 30.80668],
                        [104.083783, 30.804608],
                        [104.081154, 30.804971],
                        [104.075688, 30.80224],
                        [104.072583, 30.802321],
                        [104.071764, 30.797316],
                        [104.069631, 30.795944],
                        [104.065936, 30.796361],
                        [104.063155, 30.799159],
                        [104.061155, 30.798164],
                        [104.061098, 30.792379],
                        [104.059289, 30.789338],
                        [104.057137, 30.787871],
                        [104.056737, 30.784225],
                        [104.062736, 30.780215],
                        [104.065136, 30.780538],
                        [104.065746, 30.783848],
                        [104.067136, 30.783956],
                        [104.071307, 30.781574],
                        [104.073098, 30.778291],
                        [104.072012, 30.773137],
                        [104.06925, 30.767592],
                        [104.071174, 30.767619],
                        [104.072507, 30.765627],
                        [104.069155, 30.764093],
                        [104.07026, 30.762424],
                        [104.073364, 30.761375],
                        [104.075517, 30.763716],
                        [104.075612, 30.761267],
                        [104.080412, 30.761576],
                        [104.081288, 30.764928],
                        [104.084811, 30.767592],
                        [104.089078, 30.768292],
                        [104.08963, 30.765318],
                        [104.094011, 30.765237],
                        [104.095973, 30.766179],
                        [104.096792, 30.764591],
                        [104.094716, 30.763084],
                        [104.096582, 30.760702],
                        [104.095382, 30.758925],
                        [104.091287, 30.756152],
                        [104.086069, 30.753958],
                        [104.081935, 30.753582],
                        [104.078983, 30.752128],
                        [104.077231, 30.749153],
                        [104.075212, 30.74148],
                        [104.072698, 30.739528],
                        [104.067231, 30.740511],
                        [104.054775, 30.74984],
                        [104.05007, 30.751253],
                        [104.048566, 30.752505],
                        [104.048242, 30.754605],
                        [104.042433, 30.755843],
                        [104.032605, 30.761886],
                        [104.032795, 30.767121],
                        [104.032033, 30.771078],
                        [104.029233, 30.776097],
                        [104.029843, 30.779569],
                        [104.034852, 30.779287],
                        [104.04049, 30.776703],
                        [104.043899, 30.77708],
                        [104.046109, 30.780673],
                        [104.044413, 30.785799],
                        [104.042623, 30.787454],
                        [104.038452, 30.785947],
                        [104.034224, 30.785853],
                        [104.032243, 30.786929],
                        [104.030986, 30.790051],
                        [104.0339, 30.792258],
                        [104.034928, 30.794827],
                        [104.030871, 30.798675],
                        [104.028281, 30.799442],
                        [104.027157, 30.802321],
                        [104.024395, 30.80524],
                        [104.019367, 30.807366],
                        [104.018834, 30.80937],
                        [104.020034, 30.814051],
                        [104.016929, 30.817145],
                        [104.013482, 30.819149],
                        [104.008034, 30.821301],
                        [104.00453, 30.823427],
                        [103.998378, 30.821692],
                        [103.993692, 30.824166],
                        [103.990569, 30.82344],
                        [103.988969, 30.82765],
                        [103.987635, 30.828269],
                        [103.98274, 30.827206],
                        [103.980741, 30.828215],
                        [103.976912, 30.832572],
                        [103.97476, 30.833756],
                        [103.970093, 30.833783],
                        [103.96596, 30.836176],
                        [103.96756, 30.840076],
                        [103.96556, 30.844608],
                        [103.963484, 30.846007],
                        [103.956989, 30.845671],
                        [103.949371, 30.847217],
                        [103.944533, 30.851789],
                        [103.944, 30.857234],
                        [103.942133, 30.858485],
                        [103.937543, 30.86479],
                        [103.936819, 30.867963],
                        [103.946209, 30.876352],
                        [103.94619, 30.878113],
                        [103.942476, 30.880331],
                        [103.942514, 30.882172],
                        [103.947428, 30.886957],
                        [103.945866, 30.889686],
                        [103.936609, 30.895223],
                        [103.935124, 30.897226],
                        [103.93541, 30.902279],
                        [103.940552, 30.905867],
                        [103.935162, 30.907493],
                        [103.930648, 30.910262],
                        [103.923658, 30.91303],
                        [103.91762, 30.916376],
                        [103.910611, 30.918606],
                        [103.908039, 30.920286],
                        [103.903297, 30.925728],
                        [103.903106, 30.92699],
                        [103.906116, 30.925929],
                        [103.908916, 30.923752],
                        [103.912687, 30.922086],
                        [103.917353, 30.922046],
                        [103.926572, 30.922879],
                        [103.941752, 30.921361],
                        [103.948666, 30.916524],
                        [103.952285, 30.915596],
                        [103.95478, 30.919789],
                        [103.959389, 30.91694],
                        [103.961694, 30.916886],
                        [103.964379, 30.920017],
                        [103.964037, 30.926278],
                        [103.966417, 30.929812],
                        [103.971027, 30.932002],
                        [103.976207, 30.936287],
                        [103.978245, 30.937201],
                        [103.986321, 30.937725],
                        [103.990492, 30.939324],
                        [103.996092, 30.937362],
                        [104.001749, 30.93845],
                        [104.001578, 30.941177],
                        [104.006606, 30.940667],
                        [104.011577, 30.942239],
                        [104.014206, 30.946537],
                        [104.017862, 30.94827],
                        [104.02331, 30.951897],
                        [104.028014, 30.95692],
                        [104.032052, 30.958438],
                        [104.036738, 30.958062],
                        [104.04108, 30.960077],
                        [104.045404, 30.964871],
                        [104.049861, 30.964186],
                        [104.051251, 30.958505],
                        [104.053251, 30.956719],
                        [104.060946, 30.952192],
                        [104.062889, 30.950312],
                        [104.063536, 30.943125],
                        [104.067079, 30.937752],
                        [104.068031, 30.932566],
                        [104.066965, 30.927259],
                        [104.068965, 30.922933],
                        [104.075688, 30.917814],
                        [104.08165, 30.915785],
                        [104.091306, 30.914898],
                        [104.09843, 30.913016],
                        [104.101496, 30.912855],
                        [104.114067, 30.91471],
                        [104.121038, 30.911538],
                        [104.124581, 30.911538],
                        [104.131552, 30.914508],
                        [104.137894, 30.914723],
                        [104.144446, 30.915771],
                        [104.150008, 30.913097],
                        [104.156693, 30.912546],
                        [104.158332, 30.913473],
                        [104.160389, 30.917397],
                        [104.168807, 30.918499],
                        [104.172845, 30.912439],
                        [104.17734, 30.912035],
                        [104.179969, 30.9135],
                        [104.18214, 30.913164],
                        [104.18454, 30.911068],
                        [104.188539, 30.910141],
                        [104.186863, 30.900814],
                        [104.181911, 30.892146],
                        [104.177188, 30.888557],
                        [104.170045, 30.885922],
                        [104.170731, 30.880936],
                        [104.170655, 30.876513],
                        [104.168274, 30.871754],
                        [104.16296, 30.871028],
                        [104.161131, 30.870074],
                        [104.16056, 30.867143],
                        [104.166674, 30.86233],
                        [104.165284, 30.859923],
                        [104.167207, 30.856199],
                        [104.169455, 30.855271],
                        [104.173493, 30.861523],
                        [104.173912, 30.86319],
                        [104.176731, 30.86436],
                        [104.184425, 30.864737],
                        [104.18972, 30.862774],
                        [104.194273, 30.858606],
                        [104.197149, 30.858404],
                        [104.200063, 30.859937],
                        [104.205662, 30.865772],
                        [104.207815, 30.864898],
                        [104.210215, 30.86108],
                        [104.215129, 30.863607],
                        [104.220309, 30.863069],
                        [104.231071, 30.858135],
                        [104.233775, 30.856414],
                        [104.239889, 30.849758],
                        [104.240175, 30.847163],
                        [104.238708, 30.844366],
                        [104.239127, 30.842631],
                        [104.241965, 30.843358],
                        [104.244308, 30.83966],
                        [104.247184, 30.838153],
                        [104.247241, 30.836365],
                        [104.243813, 30.835396],
                        [104.24627, 30.830649],
                        [104.242632, 30.830192],
                        [104.237318, 30.8335],
                        [104.23528, 30.832061],
                        [104.231623, 30.825283],
                        [104.23109, 30.821073],
                        [104.23269, 30.817966],
                        [104.238537, 30.81276],
                        [104.241089, 30.808482],
                        [104.240213, 30.805738],
                        [104.241337, 30.803962],
                        [104.24907, 30.80403],
                        [104.251946, 30.802334],
                        [104.253908, 30.795702],
                        [104.257222, 30.791571],
                        [104.255241, 30.789755],
                        [104.255641, 30.787306],
                        [104.259279, 30.784413],
                        [104.261641, 30.777134],
                        [104.263298, 30.775007],
                        [104.267316, 30.772639],
                        [104.268707, 30.77093],
                        [104.268574, 30.768615],
                        [104.265221, 30.760809],
                        [104.259812, 30.757606],
                        [104.258974, 30.754174],
                        [104.259431, 30.751764],
                        [104.261907, 30.748332],
                        [104.266402, 30.744132],
                        [104.274573, 30.740471],
                        [104.279373, 30.736365],
                        [104.279811, 30.737657],
                        [104.282782, 30.738478],
                        [104.285639, 30.737671],
                        [104.288153, 30.739488],
                        [104.287792, 30.742652],
                        [104.291049, 30.745734],
                        [104.29762, 30.746057],
                        [104.302248, 30.745748],
                        [104.305295, 30.744294],
                        [104.308438, 30.74113],
                        [104.310819, 30.740834],
                        [104.3176, 30.746596],
                        [104.318914, 30.746232],
                        [104.319409, 30.743217],
                        [104.321771, 30.742921],
                        [104.323809, 30.739973],
                        [104.327009, 30.739475],
                        [104.324418, 30.736176],
                        [104.326818, 30.727802],
                        [104.327485, 30.721057]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510115,
            "name": "温江区",
            "center": [103.836776, 30.697996],
            "centroid": [103.810468, 30.724102],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 8,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [103.715821, 30.861241],
                        [103.718868, 30.856428],
                        [103.722525, 30.852246],
                        [103.722354, 30.849086],
                        [103.723516, 30.844891],
                        [103.726201, 30.841515],
                        [103.728734, 30.840601],
                        [103.731629, 30.836499],
                        [103.736962, 30.836607],
                        [103.739229, 30.834684],
                        [103.745648, 30.831577],
                        [103.748733, 30.831456],
                        [103.756333, 30.827852],
                        [103.759971, 30.823386],
                        [103.760752, 30.8204],
                        [103.760028, 30.818477],
                        [103.762218, 30.81389],
                        [103.766409, 30.811724],
                        [103.767818, 30.808523],
                        [103.769475, 30.807729],
                        [103.774903, 30.809397],
                        [103.779265, 30.809155],
                        [103.783474, 30.810567],
                        [103.78795, 30.806438],
                        [103.788674, 30.799375],
                        [103.791741, 30.796832],
                        [103.791931, 30.79367],
                        [103.794312, 30.792056],
                        [103.797855, 30.786916],
                        [103.798102, 30.785503],
                        [103.796217, 30.783095],
                        [103.796617, 30.781588],
                        [103.798959, 30.780915],
                        [103.802788, 30.781884],
                        [103.818482, 30.77712],
                        [103.820501, 30.775317],
                        [103.822463, 30.771805],
                        [103.826444, 30.768158],
                        [103.830482, 30.765358],
                        [103.835224, 30.761227],
                        [103.840633, 30.760365],
                        [103.852823, 30.753232],
                        [103.856594, 30.749651],
                        [103.859071, 30.748897],
                        [103.86827, 30.748036],
                        [103.875222, 30.74599],
                        [103.880784, 30.746286],
                        [103.881088, 30.74883],
                        [103.875489, 30.754672],
                        [103.878251, 30.755722],
                        [103.89204, 30.75023],
                        [103.89684, 30.74595],
                        [103.904421, 30.740659],
                        [103.90903, 30.739178],
                        [103.912554, 30.739111],
                        [103.914134, 30.74074],
                        [103.912706, 30.743352],
                        [103.915849, 30.744321],
                        [103.91981, 30.7428],
                        [103.925658, 30.738021],
                        [103.929448, 30.735853],
                        [103.931524, 30.732299],
                        [103.933924, 30.731289],
                        [103.938628, 30.731841],
                        [103.939066, 30.72927],
                        [103.944114, 30.72822],
                        [103.943847, 30.725769],
                        [103.94558, 30.72581],
                        [103.944152, 30.723817],
                        [103.940724, 30.723157],
                        [103.937924, 30.721205],
                        [103.939752, 30.717772],
                        [103.936876, 30.716883],
                        [103.931467, 30.720505],
                        [103.930591, 30.717193],
                        [103.933791, 30.711281],
                        [103.931372, 30.707955],
                        [103.926839, 30.708682],
                        [103.923962, 30.703148],
                        [103.919087, 30.701141],
                        [103.918591, 30.695431],
                        [103.91383, 30.690932],
                        [103.910649, 30.686717],
                        [103.906268, 30.685814],
                        [103.905087, 30.682608],
                        [103.902592, 30.681531],
                        [103.897392, 30.681827],
                        [103.896231, 30.679887],
                        [103.89943, 30.675348],
                        [103.903525, 30.675402],
                        [103.90364, 30.673812],
                        [103.907563, 30.672007],
                        [103.924172, 30.667992],
                        [103.926572, 30.665419],
                        [103.923258, 30.666012],
                        [103.920534, 30.664961],
                        [103.917791, 30.666618],
                        [103.914915, 30.664018],
                        [103.909563, 30.664773],
                        [103.903659, 30.664463],
                        [103.897773, 30.665231],
                        [103.894078, 30.663776],
                        [103.893221, 30.661836],
                        [103.894059, 30.657282],
                        [103.893393, 30.655032],
                        [103.890117, 30.654183],
                        [103.888764, 30.65231],
                        [103.891374, 30.650006],
                        [103.889679, 30.647459],
                        [103.886441, 30.647675],
                        [103.881336, 30.650046],
                        [103.878727, 30.649238],
                        [103.877984, 30.647756],
                        [103.875984, 30.649804],
                        [103.878422, 30.657026],
                        [103.878441, 30.65972],
                        [103.874822, 30.663533],
                        [103.873375, 30.663587],
                        [103.872841, 30.661054],
                        [103.870194, 30.655099],
                        [103.866594, 30.649871],
                        [103.860575, 30.646475],
                        [103.856594, 30.642824],
                        [103.857509, 30.629994],
                        [103.85429, 30.628727],
                        [103.848366, 30.633862],
                        [103.843452, 30.635318],
                        [103.842081, 30.632905],
                        [103.844747, 30.626261],
                        [103.845966, 30.619926],
                        [103.845376, 30.618605],
                        [103.841338, 30.617675],
                        [103.836215, 30.614144],
                        [103.831224, 30.614521],
                        [103.825929, 30.616004],
                        [103.819339, 30.615465],
                        [103.813625, 30.615761],
                        [103.80593, 30.617258],
                        [103.80315, 30.619131],
                        [103.80014, 30.622811],
                        [103.796426, 30.623444],
                        [103.792388, 30.621679],
                        [103.787741, 30.625021],
                        [103.788484, 30.626585],
                        [103.787646, 30.631019],
                        [103.786465, 30.632811],
                        [103.784541, 30.632919],
                        [103.780294, 30.639617],
                        [103.777608, 30.641517],
                        [103.777646, 30.643215],
                        [103.77277, 30.645788],
                        [103.770961, 30.64913],
                        [103.771304, 30.650882],
                        [103.768656, 30.65231],
                        [103.768047, 30.65646],
                        [103.763761, 30.661054],
                        [103.764523, 30.666389],
                        [103.761856, 30.667211],
                        [103.76338, 30.670862],
                        [103.765475, 30.672492],
                        [103.764999, 30.676075],
                        [103.762771, 30.679106],
                        [103.759361, 30.685841],
                        [103.75479, 30.693693],
                        [103.75279, 30.702999],
                        [103.752485, 30.714042],
                        [103.753114, 30.716237],
                        [103.751647, 30.717018],
                        [103.750143, 30.721299],
                        [103.746867, 30.722067],
                        [103.744905, 30.723709],
                        [103.744848, 30.726254],
                        [103.738791, 30.730616],
                        [103.73561, 30.731653],
                        [103.734924, 30.737886],
                        [103.732029, 30.740296],
                        [103.731191, 30.742773],
                        [103.731953, 30.745815],
                        [103.730029, 30.749544],
                        [103.728925, 30.755156],
                        [103.72622, 30.760971],
                        [103.724049, 30.764362],
                        [103.724658, 30.767485],
                        [103.721992, 30.76953],
                        [103.721897, 30.772329],
                        [103.723554, 30.773191],
                        [103.723954, 30.779798],
                        [103.718449, 30.793401],
                        [103.717859, 30.797666],
                        [103.718392, 30.801299],
                        [103.716468, 30.804756],
                        [103.714849, 30.811065],
                        [103.715306, 30.815343],
                        [103.71083, 30.818396],
                        [103.71123, 30.821113],
                        [103.708221, 30.823427],
                        [103.702507, 30.831833],
                        [103.700469, 30.836903],
                        [103.700183, 30.847768],
                        [103.698241, 30.852945],
                        [103.697307, 30.857234],
                        [103.695326, 30.859265],
                        [103.694107, 30.8651],
                        [103.69186, 30.866807],
                        [103.69226, 30.870813],
                        [103.689574, 30.874107],
                        [103.689612, 30.877951],
                        [103.687746, 30.882508],
                        [103.690203, 30.884377],
                        [103.693955, 30.884215],
                        [103.697117, 30.879659],
                        [103.701021, 30.877521],
                        [103.701574, 30.873838],
                        [103.706697, 30.870773],
                        [103.70984, 30.867103],
                        [103.71184, 30.866242],
                        [103.71523, 30.863016],
                        [103.715821, 30.861241]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510116,
            "name": "双流区",
            "center": [103.922706, 30.573243],
            "centroid": [104.035634, 30.447974],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 9,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [103.949847, 30.658589],
                        [103.951637, 30.653442],
                        [103.950761, 30.650976],
                        [103.947885, 30.648025],
                        [103.949542, 30.644549],
                        [103.952399, 30.644724],
                        [103.952685, 30.640749],
                        [103.951504, 30.637919],
                        [103.953942, 30.636557],
                        [103.953142, 30.633067],
                        [103.956323, 30.630641],
                        [103.956894, 30.628768],
                        [103.961694, 30.625008],
                        [103.961637, 30.623768],
                        [103.958665, 30.624415],
                        [103.958589, 30.621301],
                        [103.955694, 30.619077],
                        [103.956475, 30.616961],
                        [103.956266, 30.610828],
                        [103.957694, 30.607579],
                        [103.961999, 30.607889],
                        [103.963941, 30.605193],
                        [103.96676, 30.606568],
                        [103.966722, 30.601001],
                        [103.965484, 30.599342],
                        [103.966322, 30.596525],
                        [103.965275, 30.594206],
                        [103.966779, 30.589487],
                        [103.965332, 30.587289],
                        [103.965579, 30.583662],
                        [103.962703, 30.585577],
                        [103.962913, 30.588435],
                        [103.958532, 30.589716],
                        [103.957047, 30.587478],
                        [103.958399, 30.585523],
                        [103.96217, 30.582732],
                        [103.964532, 30.582826],
                        [103.966037, 30.580426],
                        [103.965789, 30.578242],
                        [103.968246, 30.577554],
                        [103.966322, 30.574951],
                        [103.970722, 30.572133],
                        [103.977636, 30.572254],
                        [103.978855, 30.574871],
                        [103.979274, 30.579307],
                        [103.982683, 30.582678],
                        [103.986531, 30.584741],
                        [103.991102, 30.584808],
                        [103.998835, 30.581249],
                        [104.003806, 30.580966],
                        [104.003387, 30.577406],
                        [104.005596, 30.577217],
                        [104.00573, 30.579631],
                        [104.009253, 30.583312],
                        [104.007177, 30.585375],
                        [104.009672, 30.586534],
                        [104.016205, 30.585011],
                        [104.018796, 30.583878],
                        [104.023386, 30.578053],
                        [104.026167, 30.576678],
                        [104.029843, 30.577932],
                        [104.031386, 30.577446],
                        [104.034566, 30.573145],
                        [104.0343, 30.567696],
                        [104.032528, 30.563718],
                        [104.026472, 30.562599],
                        [104.026072, 30.560333],
                        [104.022377, 30.554493],
                        [104.021272, 30.549179],
                        [104.017862, 30.545645],
                        [104.017996, 30.543136],
                        [104.014586, 30.542461],
                        [104.010929, 30.540235],
                        [104.011748, 30.537214],
                        [104.015786, 30.538495],
                        [104.018643, 30.537551],
                        [104.016815, 30.534785],
                        [104.019577, 30.533463],
                        [104.020358, 30.530293],
                        [104.03049, 30.529106],
                        [104.043842, 30.530482],
                        [104.044014, 30.535622],
                        [104.046661, 30.536445],
                        [104.052642, 30.536458],
                        [104.05268, 30.53345],
                        [104.057384, 30.533194],
                        [104.05746, 30.534178],
                        [104.063917, 30.53403],
                        [104.063898, 30.529821],
                        [104.068907, 30.532222],
                        [104.072907, 30.53577],
                        [104.075269, 30.536647],
                        [104.080126, 30.537025],
                        [104.081212, 30.539952],
                        [104.076907, 30.541409],
                        [104.074717, 30.547722],
                        [104.076659, 30.550298],
                        [104.081764, 30.550932],
                        [104.084659, 30.553063],
                        [104.084945, 30.555788],
                        [104.083878, 30.558121],
                        [104.079745, 30.561668],
                        [104.082869, 30.567777],
                        [104.085916, 30.569193],
                        [104.091554, 30.5686],
                        [104.094011, 30.570043],
                        [104.099058, 30.571337],
                        [104.105477, 30.571297],
                        [104.109458, 30.56945],
                        [104.111286, 30.567373],
                        [104.112905, 30.56067],
                        [104.109801, 30.559699],
                        [104.106544, 30.554277],
                        [104.107039, 30.549529],
                        [104.110467, 30.546454],
                        [104.115019, 30.547708],
                        [104.115115, 30.549098],
                        [104.118524, 30.54845],
                        [104.123667, 30.548518],
                        [104.126828, 30.547789],
                        [104.128523, 30.551364],
                        [104.122924, 30.555046],
                        [104.125457, 30.561601],
                        [104.127838, 30.563421],
                        [104.13079, 30.563974],
                        [104.138428, 30.566968],
                        [104.140561, 30.567373],
                        [104.143913, 30.565808],
                        [104.146275, 30.561897],
                        [104.148808, 30.560994],
                        [104.151932, 30.563381],
                        [104.154103, 30.561695],
                        [104.155379, 30.558728],
                        [104.153798, 30.553994],
                        [104.154103, 30.549961],
                        [104.156046, 30.547938],
                        [104.162407, 30.543904],
                        [104.165093, 30.542879],
                        [104.171055, 30.541935],
                        [104.174502, 30.538927],
                        [104.176083, 30.534758],
                        [104.178026, 30.532816],
                        [104.180311, 30.533801],
                        [104.183721, 30.5309],
                        [104.185892, 30.526664],
                        [104.188101, 30.518177],
                        [104.193892, 30.509434],
                        [104.196444, 30.503348],
                        [104.19871, 30.503024],
                        [104.200786, 30.498166],
                        [104.20092, 30.494441],
                        [104.202044, 30.492254],
                        [104.200482, 30.48996],
                        [104.202539, 30.488043],
                        [104.204139, 30.484453],
                        [104.205929, 30.485573],
                        [104.207815, 30.483414],
                        [104.204958, 30.482402],
                        [104.2073, 30.480525],
                        [104.209319, 30.480984],
                        [104.214519, 30.480296],
                        [104.217186, 30.477353],
                        [104.218957, 30.477623],
                        [104.220671, 30.475342],
                        [104.22269, 30.475342],
                        [104.223166, 30.470334],
                        [104.227642, 30.468174],
                        [104.247851, 30.463976],
                        [104.245813, 30.460344],
                        [104.247394, 30.457981],
                        [104.250365, 30.456969],
                        [104.253755, 30.45709],
                        [104.260364, 30.459007],
                        [104.269107, 30.457441],
                        [104.26844, 30.45416],
                        [104.263602, 30.446356],
                        [104.26046, 30.442724],
                        [104.258079, 30.437782],
                        [104.248841, 30.428585],
                        [104.247946, 30.426006],
                        [104.249794, 30.420833],
                        [104.24547, 30.419617],
                        [104.236785, 30.419469],
                        [104.233509, 30.418023],
                        [104.229147, 30.412634],
                        [104.228328, 30.410041],
                        [104.228747, 30.402773],
                        [104.22829, 30.398545],
                        [104.227109, 30.396167],
                        [104.219528, 30.393817],
                        [104.218005, 30.390588],
                        [104.218976, 30.388372],
                        [104.219262, 30.383792],
                        [104.218195, 30.375306],
                        [104.210424, 30.367631],
                        [104.207053, 30.362415],
                        [104.197777, 30.353508],
                        [104.196311, 30.348872],
                        [104.198291, 30.342857],
                        [104.198349, 30.339749],
                        [104.196044, 30.337086],
                        [104.191682, 30.329988],
                        [104.187854, 30.328826],
                        [104.185054, 30.323661],
                        [104.182559, 30.320728],
                        [104.178559, 30.318226],
                        [104.178254, 30.315685],
                        [104.179321, 30.31321],
                        [104.17574, 30.301906],
                        [104.174026, 30.29862],
                        [104.170826, 30.296659],
                        [104.168807, 30.29386],
                        [104.168236, 30.287896],
                        [104.166598, 30.283811],
                        [104.164255, 30.280714],
                        [104.159627, 30.277982],
                        [104.157817, 30.275398],
                        [104.156179, 30.268905],
                        [104.152256, 30.26532],
                        [104.151265, 30.261086],
                        [104.151018, 30.254592],
                        [104.150389, 30.25144],
                        [104.150522, 30.245622],
                        [104.147018, 30.241319],
                        [104.140961, 30.236597],
                        [104.135609, 30.233688],
                        [104.130961, 30.232632],
                        [104.128047, 30.230589],
                        [104.125819, 30.227747],
                        [104.1166, 30.227165],
                        [104.113077, 30.228897],
                        [104.110601, 30.235582],
                        [104.10641, 30.238031],
                        [104.098411, 30.239439],
                        [104.095192, 30.241319],
                        [104.091611, 30.248761],
                        [104.088468, 30.250344],
                        [104.082373, 30.248599],
                        [104.079955, 30.249762],
                        [104.079345, 30.251562],
                        [104.080545, 30.25462],
                        [104.076564, 30.256446],
                        [104.072945, 30.254376],
                        [104.070926, 30.254349],
                        [104.068165, 30.256081],
                        [104.062832, 30.265835],
                        [104.061155, 30.265929],
                        [104.057346, 30.262615],
                        [104.052965, 30.262967],
                        [104.051708, 30.264928],
                        [104.050489, 30.269717],
                        [104.047404, 30.270353],
                        [104.035995, 30.265767],
                        [104.030928, 30.264414],
                        [104.02929, 30.270664],
                        [104.02731, 30.271989],
                        [104.021177, 30.268026],
                        [104.017634, 30.269162],
                        [104.014529, 30.267945],
                        [104.009406, 30.264671],
                        [104.003616, 30.263589],
                        [104.000035, 30.263995],
                        [103.997064, 30.265307],
                        [103.992092, 30.272071],
                        [103.986226, 30.276521],
                        [103.98474, 30.28112],
                        [103.98236, 30.283635],
                        [103.977503, 30.286841],
                        [103.974703, 30.290763],
                        [103.974284, 30.292954],
                        [103.976493, 30.304719],
                        [103.975084, 30.306788],
                        [103.971027, 30.309046],
                        [103.968246, 30.311831],
                        [103.965827, 30.316766],
                        [103.963122, 30.319781],
                        [103.954094, 30.322607],
                        [103.943276, 30.332584],
                        [103.941657, 30.33691],
                        [103.9356, 30.34621],
                        [103.935048, 30.348007],
                        [103.935867, 30.351805],
                        [103.939238, 30.353819],
                        [103.942304, 30.356725],
                        [103.93979, 30.358576],
                        [103.937124, 30.358252],
                        [103.932057, 30.359577],
                        [103.925429, 30.360428],
                        [103.919029, 30.358698],
                        [103.921791, 30.366888],
                        [103.926877, 30.378792],
                        [103.927962, 30.384076],
                        [103.930857, 30.390264],
                        [103.933848, 30.399491],
                        [103.932838, 30.408339],
                        [103.9344, 30.413039],
                        [103.932629, 30.418604],
                        [103.931981, 30.423669],
                        [103.929657, 30.426303],
                        [103.926705, 30.42791],
                        [103.924496, 30.432907],
                        [103.924058, 30.435661],
                        [103.922267, 30.43874],
                        [103.912687, 30.447666],
                        [103.909201, 30.449718],
                        [103.910135, 30.453742],
                        [103.912515, 30.45786],
                        [103.916058, 30.4665],
                        [103.914725, 30.470334],
                        [103.910687, 30.47541],
                        [103.908935, 30.483643],
                        [103.906078, 30.488435],
                        [103.897526, 30.494211],
                        [103.89345, 30.49579],
                        [103.888936, 30.495588],
                        [103.885526, 30.493901],
                        [103.883374, 30.494144],
                        [103.881279, 30.499893],
                        [103.878498, 30.503334],
                        [103.875298, 30.505736],
                        [103.871222, 30.507571],
                        [103.85888, 30.508408],
                        [103.849319, 30.505426],
                        [103.844252, 30.505574],
                        [103.838824, 30.506681],
                        [103.835434, 30.504643],
                        [103.829034, 30.503591],
                        [103.825567, 30.511431],
                        [103.825244, 30.516693],
                        [103.821853, 30.521429],
                        [103.82033, 30.526273],
                        [103.815854, 30.531197],
                        [103.814292, 30.536728],
                        [103.81492, 30.543203],
                        [103.820825, 30.555626],
                        [103.821663, 30.56071],
                        [103.820653, 30.571243],
                        [103.820882, 30.573684],
                        [103.816501, 30.579294],
                        [103.811549, 30.586817],
                        [103.804978, 30.593694],
                        [103.801454, 30.602079],
                        [103.798255, 30.605881],
                        [103.798407, 30.610424],
                        [103.797817, 30.614306],
                        [103.792388, 30.621679],
                        [103.796426, 30.623444],
                        [103.80014, 30.622811],
                        [103.80315, 30.619131],
                        [103.80593, 30.617258],
                        [103.813625, 30.615761],
                        [103.819339, 30.615465],
                        [103.825929, 30.616004],
                        [103.831224, 30.614521],
                        [103.836215, 30.614144],
                        [103.841338, 30.617675],
                        [103.845376, 30.618605],
                        [103.845966, 30.619926],
                        [103.844747, 30.626261],
                        [103.842081, 30.632905],
                        [103.843452, 30.635318],
                        [103.848366, 30.633862],
                        [103.85429, 30.628727],
                        [103.857509, 30.629994],
                        [103.856594, 30.642824],
                        [103.860575, 30.646475],
                        [103.866594, 30.649871],
                        [103.870194, 30.655099],
                        [103.872841, 30.661054],
                        [103.873375, 30.663587],
                        [103.874822, 30.663533],
                        [103.878441, 30.65972],
                        [103.878422, 30.657026],
                        [103.875984, 30.649804],
                        [103.877984, 30.647756],
                        [103.878727, 30.649238],
                        [103.881336, 30.650046],
                        [103.886441, 30.647675],
                        [103.889679, 30.647459],
                        [103.891374, 30.650006],
                        [103.888764, 30.65231],
                        [103.890117, 30.654183],
                        [103.893393, 30.655032],
                        [103.894059, 30.657282],
                        [103.893221, 30.661836],
                        [103.894078, 30.663776],
                        [103.897773, 30.665231],
                        [103.903659, 30.664463],
                        [103.909563, 30.664773],
                        [103.914915, 30.664018],
                        [103.917791, 30.666618],
                        [103.920534, 30.664961],
                        [103.923258, 30.666012],
                        [103.926572, 30.665419],
                        [103.929105, 30.662819],
                        [103.928496, 30.659114],
                        [103.932876, 30.658858],
                        [103.935124, 30.660529],
                        [103.942019, 30.660475],
                        [103.942971, 30.657942],
                        [103.946076, 30.658387],
                        [103.946399, 30.659976],
                        [103.948533, 30.660273],
                        [103.949847, 30.658589]
                    ]
                ],
                [
                    [
                        [103.959808, 30.311574],
                        [103.959884, 30.310087],
                        [103.962437, 30.308248],
                        [103.956075, 30.306301],
                        [103.951009, 30.30388],
                        [103.948209, 30.309276],
                        [103.951656, 30.312453],
                        [103.954304, 30.313264],
                        [103.959808, 30.311574]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510117,
            "name": "郫都区",
            "center": [103.887842, 30.808752],
            "centroid": [103.862614, 30.839406],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 10,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [103.997654, 30.754335],
                        [103.996625, 30.750674],
                        [103.997044, 30.744052],
                        [104.001444, 30.739555],
                        [104.00133, 30.737428],
                        [103.999044, 30.735503],
                        [103.999959, 30.734507],
                        [103.994473, 30.727668],
                        [103.995978, 30.726335],
                        [103.995064, 30.724706],
                        [103.992397, 30.725971],
                        [103.989712, 30.725904],
                        [103.984931, 30.730684],
                        [103.982912, 30.731801],
                        [103.980531, 30.729862],
                        [103.97695, 30.730064],
                        [103.97676, 30.728368],
                        [103.973427, 30.727304],
                        [103.980226, 30.720666],
                        [103.974265, 30.719185],
                        [103.971217, 30.719414],
                        [103.966227, 30.722713],
                        [103.965979, 30.724665],
                        [103.963256, 30.726294],
                        [103.961256, 30.724033],
                        [103.961199, 30.721905],
                        [103.958494, 30.722188],
                        [103.954837, 30.720882],
                        [103.953066, 30.721744],
                        [103.947161, 30.720559],
                        [103.944152, 30.723817],
                        [103.94558, 30.72581],
                        [103.943847, 30.725769],
                        [103.944114, 30.72822],
                        [103.939066, 30.72927],
                        [103.938628, 30.731841],
                        [103.933924, 30.731289],
                        [103.931524, 30.732299],
                        [103.929448, 30.735853],
                        [103.925658, 30.738021],
                        [103.91981, 30.7428],
                        [103.915849, 30.744321],
                        [103.912706, 30.743352],
                        [103.914134, 30.74074],
                        [103.912554, 30.739111],
                        [103.90903, 30.739178],
                        [103.904421, 30.740659],
                        [103.89684, 30.74595],
                        [103.89204, 30.75023],
                        [103.878251, 30.755722],
                        [103.875489, 30.754672],
                        [103.881088, 30.74883],
                        [103.880784, 30.746286],
                        [103.875222, 30.74599],
                        [103.86827, 30.748036],
                        [103.859071, 30.748897],
                        [103.856594, 30.749651],
                        [103.852823, 30.753232],
                        [103.840633, 30.760365],
                        [103.835224, 30.761227],
                        [103.830482, 30.765358],
                        [103.826444, 30.768158],
                        [103.822463, 30.771805],
                        [103.820501, 30.775317],
                        [103.818482, 30.77712],
                        [103.802788, 30.781884],
                        [103.798959, 30.780915],
                        [103.796617, 30.781588],
                        [103.796217, 30.783095],
                        [103.798102, 30.785503],
                        [103.797855, 30.786916],
                        [103.794312, 30.792056],
                        [103.791931, 30.79367],
                        [103.791741, 30.796832],
                        [103.788674, 30.799375],
                        [103.78795, 30.806438],
                        [103.783474, 30.810567],
                        [103.779265, 30.809155],
                        [103.774903, 30.809397],
                        [103.769475, 30.807729],
                        [103.767818, 30.808523],
                        [103.766409, 30.811724],
                        [103.762218, 30.81389],
                        [103.760028, 30.818477],
                        [103.760752, 30.8204],
                        [103.759971, 30.823386],
                        [103.756333, 30.827852],
                        [103.748733, 30.831456],
                        [103.745648, 30.831577],
                        [103.739229, 30.834684],
                        [103.736962, 30.836607],
                        [103.731629, 30.836499],
                        [103.728734, 30.840601],
                        [103.726201, 30.841515],
                        [103.723516, 30.844891],
                        [103.722354, 30.849086],
                        [103.722525, 30.852246],
                        [103.718868, 30.856428],
                        [103.715821, 30.861241],
                        [103.726144, 30.863258],
                        [103.730582, 30.866619],
                        [103.735324, 30.875303],
                        [103.735534, 30.878005],
                        [103.744543, 30.879981],
                        [103.748809, 30.879175],
                        [103.751933, 30.879497],
                        [103.754657, 30.88189],
                        [103.759685, 30.882629],
                        [103.759666, 30.884887],
                        [103.756542, 30.891621],
                        [103.751724, 30.893933],
                        [103.74801, 30.898261],
                        [103.749267, 30.900962],
                        [103.75439, 30.899336],
                        [103.760161, 30.906445],
                        [103.761875, 30.915045],
                        [103.764828, 30.917478],
                        [103.767247, 30.923054],
                        [103.766828, 30.936086],
                        [103.767989, 30.9424],
                        [103.766428, 30.949479],
                        [103.767037, 30.953912],
                        [103.772675, 30.959902],
                        [103.777208, 30.959405],
                        [103.779056, 30.957847],
                        [103.780789, 30.956464],
                        [103.785055, 30.955429],
                        [103.789474, 30.950298],
                        [103.794331, 30.948095],
                        [103.795607, 30.945463],
                        [103.79934, 30.943166],
                        [103.801454, 30.943018],
                        [103.803664, 30.944549],
                        [103.812387, 30.944939],
                        [103.815397, 30.944066],
                        [103.818254, 30.941769],
                        [103.821644, 30.940627],
                        [103.824882, 30.938276],
                        [103.826291, 30.934568],
                        [103.827853, 30.933103],
                        [103.82871, 30.929382],
                        [103.83391, 30.927797],
                        [103.838043, 30.928038],
                        [103.840157, 30.927259],
                        [103.842938, 30.929167],
                        [103.844652, 30.935696],
                        [103.850519, 30.936892],
                        [103.854366, 30.935643],
                        [103.861051, 30.937926],
                        [103.864727, 30.936905],
                        [103.870841, 30.9318],
                        [103.874117, 30.930793],
                        [103.879336, 30.931102],
                        [103.887241, 30.929355],
                        [103.889431, 30.927071],
                        [103.892269, 30.926077],
                        [103.903106, 30.92699],
                        [103.903297, 30.925728],
                        [103.908039, 30.920286],
                        [103.910611, 30.918606],
                        [103.91762, 30.916376],
                        [103.923658, 30.91303],
                        [103.930648, 30.910262],
                        [103.935162, 30.907493],
                        [103.940552, 30.905867],
                        [103.93541, 30.902279],
                        [103.935124, 30.897226],
                        [103.936609, 30.895223],
                        [103.945866, 30.889686],
                        [103.947428, 30.886957],
                        [103.942514, 30.882172],
                        [103.942476, 30.880331],
                        [103.94619, 30.878113],
                        [103.946209, 30.876352],
                        [103.936819, 30.867963],
                        [103.937543, 30.86479],
                        [103.942133, 30.858485],
                        [103.944, 30.857234],
                        [103.944533, 30.851789],
                        [103.949371, 30.847217],
                        [103.956989, 30.845671],
                        [103.963484, 30.846007],
                        [103.96556, 30.844608],
                        [103.96756, 30.840076],
                        [103.96596, 30.836176],
                        [103.970093, 30.833783],
                        [103.97476, 30.833756],
                        [103.976912, 30.832572],
                        [103.980741, 30.828215],
                        [103.98274, 30.827206],
                        [103.959865, 30.783646],
                        [103.95537, 30.785167],
                        [103.948476, 30.779892],
                        [103.952342, 30.777026],
                        [103.949047, 30.776757],
                        [103.946838, 30.778183],
                        [103.944876, 30.775505],
                        [103.948704, 30.773164],
                        [103.948742, 30.769234],
                        [103.952266, 30.768898],
                        [103.95278, 30.772101],
                        [103.957523, 30.772679],
                        [103.959942, 30.776945],
                        [103.96137, 30.77677],
                        [103.997654, 30.754335]
                    ]
                ],
                [
                    [
                        [103.959865, 30.783646],
                        [103.98274, 30.827206],
                        [103.987635, 30.828269],
                        [103.988969, 30.82765],
                        [103.990569, 30.82344],
                        [103.993692, 30.824166],
                        [103.998378, 30.821692],
                        [104.00453, 30.823427],
                        [104.008034, 30.821301],
                        [104.013482, 30.819149],
                        [104.016929, 30.817145],
                        [104.020034, 30.814051],
                        [104.018834, 30.80937],
                        [104.019367, 30.807366],
                        [104.024395, 30.80524],
                        [104.027157, 30.802321],
                        [104.028281, 30.799442],
                        [104.030871, 30.798675],
                        [104.034928, 30.794827],
                        [104.0339, 30.792258],
                        [104.030986, 30.790051],
                        [104.032243, 30.786929],
                        [104.034224, 30.785853],
                        [104.038452, 30.785947],
                        [104.042623, 30.787454],
                        [104.044413, 30.785799],
                        [104.046109, 30.780673],
                        [104.043899, 30.77708],
                        [104.04049, 30.776703],
                        [104.034852, 30.779287],
                        [104.029843, 30.779569],
                        [104.029233, 30.776097],
                        [104.032033, 30.771078],
                        [104.032795, 30.767121],
                        [104.032605, 30.761886],
                        [104.042433, 30.755843],
                        [104.048242, 30.754605],
                        [104.048566, 30.752505],
                        [104.042756, 30.750486],
                        [104.036738, 30.745923],
                        [104.031424, 30.745061],
                        [104.032814, 30.741777],
                        [104.036204, 30.738896],
                        [104.039271, 30.734736],
                        [104.037233, 30.729741],
                        [104.028643, 30.733592],
                        [104.0255, 30.73794],
                        [104.027862, 30.738573],
                        [104.02531, 30.741494],
                        [104.022548, 30.740646],
                        [104.020758, 30.7414],
                        [104.021329, 30.747646],
                        [104.019786, 30.748722],
                        [104.016624, 30.746865],
                        [104.012815, 30.748413],
                        [104.013044, 30.750176],
                        [104.015272, 30.750916],
                        [104.016872, 30.75381],
                        [104.011691, 30.758481],
                        [104.008625, 30.758925],
                        [104.00392, 30.758427],
                        [103.999368, 30.756812],
                        [103.997654, 30.754335],
                        [103.96137, 30.77677],
                        [103.963675, 30.780148],
                        [103.963751, 30.782274],
                        [103.959865, 30.783646]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510118,
            "name": "新津区",
            "center": [103.812449, 30.414284],
            "centroid": [103.825572, 30.422245],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 11,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [103.919029, 30.358698],
                        [103.915468, 30.356765],
                        [103.913944, 30.353981],
                        [103.914839, 30.350832],
                        [103.918153, 30.345399],
                        [103.918458, 30.342019],
                        [103.917125, 30.340533],
                        [103.913925, 30.339924],
                        [103.911944, 30.336761],
                        [103.910973, 30.332206],
                        [103.909449, 30.330029],
                        [103.904002, 30.331692],
                        [103.897964, 30.331949],
                        [103.887679, 30.328799],
                        [103.88446, 30.329975],
                        [103.884364, 30.332679],
                        [103.882422, 30.335301],
                        [103.881527, 30.338572],
                        [103.877831, 30.344899],
                        [103.874289, 30.348115],
                        [103.873756, 30.351292],
                        [103.874213, 30.355738],
                        [103.872232, 30.355292],
                        [103.870232, 30.350494],
                        [103.866727, 30.347778],
                        [103.860175, 30.34798],
                        [103.855585, 30.34725],
                        [103.849395, 30.343844],
                        [103.843986, 30.343439],
                        [103.831053, 30.344777],
                        [103.815454, 30.343831],
                        [103.806845, 30.344615],
                        [103.799683, 30.346872],
                        [103.794731, 30.345899],
                        [103.78776, 30.342628],
                        [103.782922, 30.339194],
                        [103.773951, 30.334977],
                        [103.769818, 30.332084],
                        [103.766866, 30.328069],
                        [103.762847, 30.329029],
                        [103.758809, 30.328285],
                        [103.756371, 30.329732],
                        [103.758047, 30.33449],
                        [103.750105, 30.338856],
                        [103.747743, 30.336247],
                        [103.745114, 30.331773],
                        [103.739648, 30.331489],
                        [103.73662, 30.332233],
                        [103.733839, 30.334017],
                        [103.733591, 30.336802],
                        [103.736162, 30.341168],
                        [103.739858, 30.343736],
                        [103.744543, 30.346101],
                        [103.751228, 30.348413],
                        [103.755285, 30.352968],
                        [103.755038, 30.3554],
                        [103.750086, 30.360401],
                        [103.748143, 30.365185],
                        [103.747438, 30.375509],
                        [103.746771, 30.376671],
                        [103.739191, 30.384548],
                        [103.730449, 30.396762],
                        [103.722201, 30.40996],
                        [103.704926, 30.425641],
                        [103.704507, 30.427505],
                        [103.705497, 30.432366],
                        [103.707783, 30.434527],
                        [103.714487, 30.438551],
                        [103.719573, 30.442143],
                        [103.717078, 30.444155],
                        [103.717078, 30.446046],
                        [103.719611, 30.447882],
                        [103.728391, 30.452081],
                        [103.730068, 30.453782],
                        [103.731972, 30.459561],
                        [103.734639, 30.462545],
                        [103.735972, 30.465866],
                        [103.735153, 30.47244],
                        [103.73601, 30.477475],
                        [103.739496, 30.479945],
                        [103.740829, 30.482766],
                        [103.741781, 30.491566],
                        [103.743953, 30.496114],
                        [103.749571, 30.500338],
                        [103.755838, 30.499987],
                        [103.764809, 30.501647],
                        [103.777398, 30.50104],
                        [103.78715, 30.499826],
                        [103.796331, 30.49992],
                        [103.797969, 30.501715],
                        [103.792522, 30.503941],
                        [103.791303, 30.506897],
                        [103.78816, 30.509434],
                        [103.788446, 30.512956],
                        [103.79355, 30.517354],
                        [103.794636, 30.519918],
                        [103.798845, 30.521955],
                        [103.806845, 30.520471],
                        [103.813301, 30.521335],
                        [103.815625, 30.522603],
                        [103.818787, 30.526475],
                        [103.82033, 30.526273],
                        [103.821853, 30.521429],
                        [103.825244, 30.516693],
                        [103.825567, 30.511431],
                        [103.829034, 30.503591],
                        [103.835434, 30.504643],
                        [103.838824, 30.506681],
                        [103.844252, 30.505574],
                        [103.849319, 30.505426],
                        [103.85888, 30.508408],
                        [103.871222, 30.507571],
                        [103.875298, 30.505736],
                        [103.878498, 30.503334],
                        [103.881279, 30.499893],
                        [103.883374, 30.494144],
                        [103.885526, 30.493901],
                        [103.888936, 30.495588],
                        [103.89345, 30.49579],
                        [103.897526, 30.494211],
                        [103.906078, 30.488435],
                        [103.908935, 30.483643],
                        [103.910687, 30.47541],
                        [103.914725, 30.470334],
                        [103.916058, 30.4665],
                        [103.912515, 30.45786],
                        [103.910135, 30.453742],
                        [103.909201, 30.449718],
                        [103.912687, 30.447666],
                        [103.922267, 30.43874],
                        [103.924058, 30.435661],
                        [103.924496, 30.432907],
                        [103.926705, 30.42791],
                        [103.929657, 30.426303],
                        [103.931981, 30.423669],
                        [103.932629, 30.418604],
                        [103.9344, 30.413039],
                        [103.932838, 30.408339],
                        [103.933848, 30.399491],
                        [103.930857, 30.390264],
                        [103.927962, 30.384076],
                        [103.926877, 30.378792],
                        [103.921791, 30.366888],
                        [103.919029, 30.358698]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510121,
            "name": "金堂县",
            "center": [104.415604, 30.858417],
            "centroid": [104.608828, 30.722683],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 12,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [104.875686, 30.509015],
                        [104.872752, 30.508853],
                        [104.868581, 30.510014],
                        [104.861439, 30.509123],
                        [104.851325, 30.504778],
                        [104.845306, 30.508584],
                        [104.839859, 30.510378],
                        [104.836049, 30.510972],
                        [104.826755, 30.510297],
                        [104.819669, 30.508705],
                        [104.817136, 30.509528],
                        [104.811727, 30.50884],
                        [104.806584, 30.505008],
                        [104.806718, 30.498908],
                        [104.808565, 30.493725],
                        [104.807137, 30.491296],
                        [104.803956, 30.491647],
                        [104.802604, 30.49023],
                        [104.80068, 30.491107],
                        [104.794775, 30.488624],
                        [104.792985, 30.489839],
                        [104.785804, 30.488826],
                        [104.785442, 30.49023],
                        [104.782909, 30.489272],
                        [104.779957, 30.486464],
                        [104.778376, 30.486545],
                        [104.777195, 30.484413],
                        [104.766586, 30.483967],
                        [104.763253, 30.485857],
                        [104.763748, 30.487288],
                        [104.769729, 30.491202],
                        [104.767634, 30.492578],
                        [104.763406, 30.493591],
                        [104.765748, 30.496371],
                        [104.765539, 30.498085],
                        [104.761234, 30.496884],
                        [104.760682, 30.500662],
                        [104.758491, 30.502295],
                        [104.759425, 30.505143],
                        [104.750549, 30.50915],
                        [104.735407, 30.512915],
                        [104.732036, 30.514413],
                        [104.731998, 30.521901],
                        [104.732607, 30.525625],
                        [104.73114, 30.528107],
                        [104.730226, 30.533517],
                        [104.728722, 30.537133],
                        [104.726074, 30.539966],
                        [104.720132, 30.542056],
                        [104.709884, 30.544957],
                        [104.70577, 30.547182],
                        [104.702513, 30.547803],
                        [104.690666, 30.552497],
                        [104.687638, 30.554628],
                        [104.684381, 30.560387],
                        [104.684533, 30.564824],
                        [104.686495, 30.573387],
                        [104.687143, 30.578808],
                        [104.693847, 30.582166],
                        [104.697447, 30.58768],
                        [104.700799, 30.591887],
                        [104.70158, 30.595851],
                        [104.700456, 30.597037],
                        [104.697714, 30.59697],
                        [104.692285, 30.600043],
                        [104.686133, 30.600718],
                        [104.683314, 30.601594],
                        [104.681333, 30.604951],
                        [104.679143, 30.606878],
                        [104.67701, 30.607094],
                        [104.675772, 30.605207],
                        [104.674229, 30.607175],
                        [104.675124, 30.608523],
                        [104.671905, 30.609237],
                        [104.669144, 30.606204],
                        [104.667087, 30.608078],
                        [104.667391, 30.609992],
                        [104.664325, 30.610841],
                        [104.662077, 30.610397],
                        [104.661887, 30.607701],
                        [104.659049, 30.608631],
                        [104.656001, 30.605679],
                        [104.653716, 30.607997],
                        [104.654782, 30.610491],
                        [104.651278, 30.610936],
                        [104.646059, 30.612836],
                        [104.645278, 30.61467],
                        [104.64244, 30.613901],
                        [104.641659, 30.615613],
                        [104.637393, 30.618322],
                        [104.634898, 30.616557],
                        [104.634079, 30.618161],
                        [104.629984, 30.616489],
                        [104.630403, 30.614413],
                        [104.627946, 30.61351],
                        [104.626232, 30.615492],
                        [104.627622, 30.617635],
                        [104.624346, 30.618632],
                        [104.623832, 30.619926],
                        [104.618899, 30.620304],
                        [104.617546, 30.617055],
                        [104.613566, 30.618012],
                        [104.61328, 30.61994],
                        [104.611699, 30.618161],
                        [104.611547, 30.620587],
                        [104.607509, 30.622164],
                        [104.601147, 30.63021],
                        [104.597452, 30.633579],
                        [104.594976, 30.633593],
                        [104.587643, 30.629954],
                        [104.585091, 30.630722],
                        [104.579167, 30.639374],
                        [104.579034, 30.642608],
                        [104.576577, 30.643578],
                        [104.570425, 30.640344],
                        [104.56873, 30.638552],
                        [104.568292, 30.631571],
                        [104.567015, 30.628741],
                        [104.563111, 30.628202],
                        [104.550026, 30.633471],
                        [104.548255, 30.632932],
                        [104.54795, 30.634833],
                        [104.544769, 30.633148],
                        [104.54435, 30.631571],
                        [104.546807, 30.629994],
                        [104.545245, 30.627245],
                        [104.542064, 30.626652],
                        [104.541131, 30.628121],
                        [104.538731, 30.626948],
                        [104.539093, 30.625156],
                        [104.535398, 30.626531],
                        [104.534312, 30.62866],
                        [104.529608, 30.630143],
                        [104.529646, 30.627231],
                        [104.532789, 30.623808],
                        [104.528484, 30.624307],
                        [104.526922, 30.622865],
                        [104.525151, 30.623458],
                        [104.528122, 30.620358],
                        [104.525703, 30.618673],
                        [104.527322, 30.616139],
                        [104.526484, 30.614818],
                        [104.522732, 30.613793],
                        [104.518713, 30.614063],
                        [104.516104, 30.612526],
                        [104.513094, 30.607539],
                        [104.505361, 30.60243],
                        [104.505266, 30.599342],
                        [104.503533, 30.597981],
                        [104.501171, 30.598008],
                        [104.495362, 30.600623],
                        [104.494619, 30.600219],
                        [104.494581, 30.595325],
                        [104.492676, 30.594112],
                        [104.490543, 30.595311],
                        [104.48481, 30.593033],
                        [104.478125, 30.596107],
                        [104.474849, 30.595527],
                        [104.467859, 30.592184],
                        [104.461688, 30.590215],
                        [104.452926, 30.590175],
                        [104.450507, 30.591078],
                        [104.448374, 30.593815],
                        [104.444603, 30.593734],
                        [104.439517, 30.591523],
                        [104.43487, 30.592386],
                        [104.431365, 30.595648],
                        [104.428889, 30.596606],
                        [104.424013, 30.596794],
                        [104.421137, 30.598493],
                        [104.425956, 30.601756],
                        [104.427918, 30.605867],
                        [104.428299, 30.611219],
                        [104.429499, 30.612472],
                        [104.432584, 30.612189],
                        [104.436032, 30.610221],
                        [104.438489, 30.610248],
                        [104.441593, 30.611825],
                        [104.448031, 30.617028],
                        [104.44786, 30.620196],
                        [104.448888, 30.623741],
                        [104.452945, 30.627649],
                        [104.454412, 30.63176],
                        [104.45464, 30.635304],
                        [104.454202, 30.643147],
                        [104.452355, 30.651609],
                        [104.449707, 30.653576],
                        [104.44586, 30.650989],
                        [104.442165, 30.646139],
                        [104.439689, 30.637272],
                        [104.436641, 30.635089],
                        [104.433365, 30.634563],
                        [104.431156, 30.635708],
                        [104.43068, 30.638336],
                        [104.432146, 30.64277],
                        [104.432222, 30.649143],
                        [104.436508, 30.66003],
                        [104.440127, 30.663978],
                        [104.439727, 30.668464],
                        [104.446145, 30.666335],
                        [104.447536, 30.661445],
                        [104.451307, 30.658225],
                        [104.456926, 30.658979],
                        [104.456088, 30.660596],
                        [104.452697, 30.661175],
                        [104.453421, 30.663883],
                        [104.447231, 30.671455],
                        [104.452259, 30.671024],
                        [104.458202, 30.669582],
                        [104.469763, 30.66356],
                        [104.477839, 30.661068],
                        [104.483248, 30.662644],
                        [104.484715, 30.665392],
                        [104.481667, 30.669582],
                        [104.48302, 30.678419],
                        [104.484201, 30.679712],
                        [104.491876, 30.680965],
                        [104.493953, 30.684157],
                        [104.491553, 30.688979],
                        [104.486581, 30.691579],
                        [104.479001, 30.69236],
                        [104.479439, 30.694892],
                        [104.485229, 30.70238],
                        [104.487096, 30.707147],
                        [104.487362, 30.709625],
                        [104.485534, 30.714244],
                        [104.483591, 30.717246],
                        [104.48782, 30.718647],
                        [104.487381, 30.722309],
                        [104.48321, 30.725352],
                        [104.479249, 30.726227],
                        [104.479801, 30.724127],
                        [104.48222, 30.722861],
                        [104.481648, 30.721555],
                        [104.477325, 30.719711],
                        [104.470239, 30.718903],
                        [104.468449, 30.72002],
                        [104.467859, 30.723709],
                        [104.468887, 30.727641],
                        [104.47523, 30.732474],
                        [104.479249, 30.739273],
                        [104.477058, 30.742625],
                        [104.475439, 30.746636],
                        [104.475211, 30.755304],
                        [104.473535, 30.764362],
                        [104.473649, 30.767323],
                        [104.475477, 30.770903],
                        [104.47582, 30.77346],
                        [104.474639, 30.77638],
                        [104.472296, 30.778291],
                        [104.466449, 30.779569],
                        [104.462735, 30.779394],
                        [104.452717, 30.77128],
                        [104.450679, 30.770647],
                        [104.448088, 30.772006],
                        [104.442565, 30.777685],
                        [104.440241, 30.778331],
                        [104.43807, 30.777443],
                        [104.434356, 30.773218],
                        [104.431232, 30.772128],
                        [104.427861, 30.772666],
                        [104.425099, 30.77494],
                        [104.421728, 30.782301],
                        [104.423232, 30.784763],
                        [104.429956, 30.789069],
                        [104.431841, 30.791881],
                        [104.430661, 30.792527],
                        [104.426051, 30.788894],
                        [104.419099, 30.787831],
                        [104.416833, 30.786808],
                        [104.41388, 30.783781],
                        [104.410281, 30.781197],
                        [104.405233, 30.780363],
                        [104.401691, 30.781305],
                        [104.393729, 30.785073],
                        [104.391158, 30.78588],
                        [104.383672, 30.784171],
                        [104.379444, 30.785409],
                        [104.377197, 30.787616],
                        [104.37613, 30.790751],
                        [104.377025, 30.792136],
                        [104.381596, 30.794141],
                        [104.381273, 30.798177],
                        [104.383387, 30.801245],
                        [104.382149, 30.80333],
                        [104.375844, 30.805859],
                        [104.374397, 30.808603],
                        [104.371959, 30.809814],
                        [104.371006, 30.813634],
                        [104.367349, 30.819876],
                        [104.367673, 30.822794],
                        [104.371654, 30.828659],
                        [104.371273, 30.830663],
                        [104.368854, 30.833527],
                        [104.36594, 30.838974],
                        [104.363064, 30.839243],
                        [104.361769, 30.835396],
                        [104.357007, 30.83194],
                        [104.353979, 30.832021],
                        [104.35316, 30.835894],
                        [104.350779, 30.841677],
                        [104.35076, 30.843559],
                        [104.352741, 30.845321],
                        [104.360969, 30.844985],
                        [104.36495, 30.846464],
                        [104.371406, 30.84645],
                        [104.37552, 30.845697],
                        [104.37832, 30.84879],
                        [104.379063, 30.856643],
                        [104.380606, 30.858646],
                        [104.385501, 30.862814],
                        [104.386129, 30.866269],
                        [104.384244, 30.874846],
                        [104.381863, 30.87861],
                        [104.374797, 30.879901],
                        [104.372511, 30.882737],
                        [104.369502, 30.882696],
                        [104.365045, 30.880035],
                        [104.362093, 30.879645],
                        [104.35895, 30.882844],
                        [104.357293, 30.888987],
                        [104.352512, 30.895344],
                        [104.352188, 30.896809],
                        [104.35476, 30.900532],
                        [104.351312, 30.902252],
                        [104.353388, 30.904752],
                        [104.354322, 30.908353],
                        [104.358759, 30.912398],
                        [104.357426, 30.915166],
                        [104.359026, 30.919023],
                        [104.362093, 30.923443],
                        [104.363597, 30.926816],
                        [104.366035, 30.929973],
                        [104.367159, 30.933668],
                        [104.37133, 30.937604],
                        [104.375654, 30.936167],
                        [104.378244, 30.932915],
                        [104.382777, 30.932271],
                        [104.384339, 30.926816],
                        [104.386263, 30.924626],
                        [104.38971, 30.92566],
                        [104.391634, 30.930712],
                        [104.394034, 30.934178],
                        [104.394758, 30.939646],
                        [104.396053, 30.942373],
                        [104.398986, 30.942292],
                        [104.401576, 30.94013],
                        [104.403367, 30.93704],
                        [104.409652, 30.938316],
                        [104.415252, 30.940774],
                        [104.424185, 30.943421],
                        [104.426604, 30.943716],
                        [104.434489, 30.941392],
                        [104.436165, 30.943112],
                        [104.44506, 30.940425],
                        [104.448717, 30.942695],
                        [104.449498, 30.945637],
                        [104.45285, 30.944872],
                        [104.454183, 30.947827],
                        [104.456145, 30.947612],
                        [104.457764, 30.949224],
                        [104.46563, 30.950688],
                        [104.468297, 30.947948],
                        [104.474106, 30.9469],
                        [104.475915, 30.944858],
                        [104.480296, 30.944119],
                        [104.483896, 30.944791],
                        [104.489762, 30.939176],
                        [104.4934, 30.938222],
                        [104.495762, 30.935455],
                        [104.499686, 30.936905],
                        [104.506466, 30.934366],
                        [104.511952, 30.935858],
                        [104.514694, 30.933614],
                        [104.516885, 30.929839],
                        [104.522332, 30.925445],
                        [104.531379, 30.921132],
                        [104.533074, 30.917908],
                        [104.528922, 30.905988],
                        [104.529132, 30.896957],
                        [104.52757, 30.893933],
                        [104.524141, 30.892589],
                        [104.521037, 30.890062],
                        [104.519551, 30.887065],
                        [104.520732, 30.882428],
                        [104.528522, 30.881729],
                        [104.541455, 30.879444],
                        [104.550693, 30.874228],
                        [104.557702, 30.873004],
                        [104.561549, 30.871606],
                        [104.571111, 30.869092],
                        [104.576025, 30.865503],
                        [104.585319, 30.862908],
                        [104.587472, 30.862975],
                        [104.591986, 30.864911],
                        [104.596347, 30.864508],
                        [104.598766, 30.861093],
                        [104.604709, 30.857665],
                        [104.605985, 30.856226],
                        [104.607299, 30.849315],
                        [104.610042, 30.847755],
                        [104.613965, 30.847782],
                        [104.618803, 30.84922],
                        [104.623565, 30.851668],
                        [104.630688, 30.852407],
                        [104.632822, 30.850848],
                        [104.632365, 30.847768],
                        [104.634898, 30.842134],
                        [104.638631, 30.838772],
                        [104.645678, 30.836835],
                        [104.654002, 30.836096],
                        [104.661487, 30.833312],
                        [104.666287, 30.832102],
                        [104.676591, 30.831322],
                        [104.679295, 30.827502],
                        [104.683238, 30.825431],
                        [104.688819, 30.82496],
                        [104.69838, 30.825525],
                        [104.702913, 30.824193],
                        [104.704018, 30.821194],
                        [104.70078, 30.817629],
                        [104.699694, 30.814522],
                        [104.701066, 30.810298],
                        [104.705713, 30.80485],
                        [104.709675, 30.798487],
                        [104.713865, 30.784804],
                        [104.715046, 30.778156],
                        [104.713503, 30.776555],
                        [104.710722, 30.778883],
                        [104.710037, 30.778116],
                        [104.710322, 30.773043],
                        [104.713675, 30.771145],
                        [104.718132, 30.771791],
                        [104.72217, 30.774684],
                        [104.724455, 30.777793],
                        [104.72796, 30.77934],
                        [104.732112, 30.778277],
                        [104.734093, 30.775128],
                        [104.734226, 30.772195],
                        [104.736035, 30.767014],
                        [104.736245, 30.76408],
                        [104.739731, 30.7563],
                        [104.745064, 30.752491],
                        [104.74573, 30.749045],
                        [104.741769, 30.741817],
                        [104.742435, 30.739784],
                        [104.746892, 30.738048],
                        [104.748606, 30.736028],
                        [104.746854, 30.731397],
                        [104.74874, 30.727775],
                        [104.750739, 30.726887],
                        [104.756282, 30.728435],
                        [104.759425, 30.727991],
                        [104.761196, 30.726362],
                        [104.764834, 30.727156],
                        [104.767729, 30.725823],
                        [104.766701, 30.723157],
                        [104.76691, 30.718822],
                        [104.768034, 30.718149],
                        [104.771805, 30.720357],
                        [104.775976, 30.721609],
                        [104.782719, 30.720545],
                        [104.788585, 30.721299],
                        [104.79329, 30.719832],
                        [104.794471, 30.716398],
                        [104.78948, 30.7112],
                        [104.788585, 30.707807],
                        [104.789576, 30.699687],
                        [104.788699, 30.694043],
                        [104.790528, 30.691282],
                        [104.793671, 30.690717],
                        [104.800965, 30.691013],
                        [104.804261, 30.689262],
                        [104.806032, 30.684413],
                        [104.809898, 30.681598],
                        [104.812127, 30.678163],
                        [104.813003, 30.672465],
                        [104.818298, 30.664341],
                        [104.820241, 30.654021],
                        [104.821441, 30.650033],
                        [104.82125, 30.643861],
                        [104.823364, 30.642244],
                        [104.826202, 30.642015],
                        [104.82984, 30.648146],
                        [104.83784, 30.648308],
                        [104.842716, 30.649359],
                        [104.842544, 30.647203],
                        [104.845039, 30.643498],
                        [104.84782, 30.640695],
                        [104.848468, 30.635762],
                        [104.847287, 30.631113],
                        [104.842068, 30.625223],
                        [104.83704, 30.622123],
                        [104.836811, 30.618093],
                        [104.834069, 30.614818],
                        [104.831707, 30.608563],
                        [104.828412, 30.608927],
                        [104.827402, 30.605045],
                        [104.824012, 30.603319],
                        [104.820012, 30.597806],
                        [104.819498, 30.590593],
                        [104.816317, 30.58884],
                        [104.816317, 30.585456],
                        [104.817955, 30.583689],
                        [104.817193, 30.582098],
                        [104.819193, 30.57959],
                        [104.817269, 30.577392],
                        [104.820069, 30.576772],
                        [104.823041, 30.578646],
                        [104.827421, 30.578377],
                        [104.828164, 30.580076],
                        [104.83245, 30.582975],
                        [104.834164, 30.581073],
                        [104.83704, 30.580278],
                        [104.837821, 30.582058],
                        [104.840335, 30.581775],
                        [104.84144, 30.587977],
                        [104.845058, 30.585172],
                        [104.846392, 30.586588],
                        [104.84803, 30.585253],
                        [104.849039, 30.581518],
                        [104.849706, 30.583527],
                        [104.851858, 30.58435],
                        [104.85281, 30.586494],
                        [104.856601, 30.58706],
                        [104.858982, 30.581532],
                        [104.861896, 30.579887],
                        [104.864867, 30.576516],
                        [104.86561, 30.57301],
                        [104.865572, 30.56864],
                        [104.867591, 30.566011],
                        [104.870752, 30.564257],
                        [104.87201, 30.561682],
                        [104.875686, 30.560158],
                        [104.876162, 30.556395],
                        [104.875419, 30.552861],
                        [104.879114, 30.550635],
                        [104.882447, 30.554183],
                        [104.886199, 30.55599],
                        [104.889494, 30.555518],
                        [104.891628, 30.55305],
                        [104.892789, 30.549192],
                        [104.892732, 30.541652],
                        [104.890123, 30.537376],
                        [104.889951, 30.535271],
                        [104.888028, 30.53171],
                        [104.881533, 30.5229],
                        [104.881095, 30.520296],
                        [104.881857, 30.515398],
                        [104.878543, 30.515101],
                        [104.876124, 30.513063],
                        [104.875686, 30.509015]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510129,
            "name": "大邑县",
            "center": [103.522397, 30.586602],
            "centroid": [103.364446, 30.61507],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 13,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [103.12027, 30.79402],
                        [103.121203, 30.790132],
                        [103.121318, 30.782758],
                        [103.122346, 30.779354],
                        [103.124441, 30.776555],
                        [103.128251, 30.775142],
                        [103.130365, 30.773473],
                        [103.135812, 30.765426],
                        [103.138079, 30.763824],
                        [103.141164, 30.763111],
                        [103.148211, 30.763784],
                        [103.150745, 30.762344],
                        [103.158897, 30.75416],
                        [103.165125, 30.750499],
                        [103.168953, 30.744375],
                        [103.17122, 30.742369],
                        [103.174229, 30.741534],
                        [103.187352, 30.739528],
                        [103.193638, 30.73763],
                        [103.197885, 30.733686],
                        [103.200514, 30.733497],
                        [103.204399, 30.734992],
                        [103.208951, 30.737913],
                        [103.222703, 30.751293],
                        [103.229883, 30.755695],
                        [103.233845, 30.757135],
                        [103.240054, 30.756449],
                        [103.242721, 30.755008],
                        [103.247045, 30.74957],
                        [103.248244, 30.743971],
                        [103.249654, 30.742046],
                        [103.252911, 30.7407],
                        [103.257653, 30.741561],
                        [103.259158, 30.740605],
                        [103.263253, 30.733915],
                        [103.265139, 30.732945],
                        [103.26851, 30.726847],
                        [103.271234, 30.717314],
                        [103.273462, 30.716115],
                        [103.2763, 30.716048],
                        [103.283747, 30.717866],
                        [103.291385, 30.715779],
                        [103.292795, 30.714553],
                        [103.295537, 30.714998],
                        [103.30268, 30.723534],
                        [103.308546, 30.726429],
                        [103.313384, 30.730589],
                        [103.317403, 30.73137],
                        [103.318869, 30.729499],
                        [103.319746, 30.72235],
                        [103.320641, 30.720707],
                        [103.324298, 30.717799],
                        [103.331269, 30.710635],
                        [103.334735, 30.709167],
                        [103.337992, 30.70914],
                        [103.34104, 30.712399],
                        [103.340887, 30.719791],
                        [103.341687, 30.721434],
                        [103.349382, 30.726752],
                        [103.359058, 30.735557],
                        [103.36102, 30.736769],
                        [103.366143, 30.736823],
                        [103.36921, 30.735072],
                        [103.374181, 30.729337],
                        [103.377571, 30.727358],
                        [103.385247, 30.724813],
                        [103.391647, 30.725621],
                        [103.399989, 30.730212],
                        [103.413569, 30.735571],
                        [103.416064, 30.735046],
                        [103.419379, 30.733013],
                        [103.433378, 30.720693],
                        [103.437778, 30.718849],
                        [103.442444, 30.722107],
                        [103.448044, 30.722942],
                        [103.452615, 30.717933],
                        [103.455548, 30.717179],
                        [103.462272, 30.717246],
                        [103.464843, 30.718539],
                        [103.467148, 30.721178],
                        [103.470595, 30.723548],
                        [103.474576, 30.72037],
                        [103.484823, 30.717354],
                        [103.489699, 30.713086],
                        [103.496099, 30.713503],
                        [103.49926, 30.712938],
                        [103.504555, 30.709261],
                        [103.506365, 30.70646],
                        [103.508879, 30.699781],
                        [103.512288, 30.699336],
                        [103.516669, 30.701868],
                        [103.521735, 30.702474],
                        [103.530211, 30.694555],
                        [103.536611, 30.689761],
                        [103.543963, 30.685383],
                        [103.546325, 30.681221],
                        [103.550496, 30.677261],
                        [103.55461, 30.672573],
                        [103.553124, 30.664032],
                        [103.553467, 30.648066],
                        [103.553829, 30.646152],
                        [103.557695, 30.640829],
                        [103.557467, 30.635304],
                        [103.560667, 30.631288],
                        [103.565009, 30.624118],
                        [103.564019, 30.618889],
                        [103.564724, 30.613079],
                        [103.564152, 30.60611],
                        [103.565847, 30.60394],
                        [103.563581, 30.600017],
                        [103.565009, 30.598089],
                        [103.568857, 30.598008],
                        [103.569676, 30.596875],
                        [103.569047, 30.593653],
                        [103.567428, 30.591402],
                        [103.563295, 30.589649],
                        [103.561162, 30.586817],
                        [103.558876, 30.579469],
                        [103.557619, 30.573954],
                        [103.558286, 30.569018],
                        [103.561009, 30.562288],
                        [103.565676, 30.554506],
                        [103.565904, 30.552591],
                        [103.55901, 30.544673],
                        [103.559867, 30.539831],
                        [103.563866, 30.53434],
                        [103.567009, 30.533301],
                        [103.574247, 30.535986],
                        [103.577123, 30.535905],
                        [103.584704, 30.533342],
                        [103.596055, 30.53314],
                        [103.602055, 30.531966],
                        [103.614473, 30.542232],
                        [103.623863, 30.54439],
                        [103.62533, 30.54435],
                        [103.629387, 30.540289],
                        [103.629825, 30.538549],
                        [103.626549, 30.532829],
                        [103.628378, 30.527406],
                        [103.633234, 30.526623],
                        [103.63472, 30.525315],
                        [103.632015, 30.523952],
                        [103.629749, 30.521078],
                        [103.630625, 30.516018],
                        [103.628758, 30.510554],
                        [103.632111, 30.509758],
                        [103.640586, 30.513117],
                        [103.647596, 30.520255],
                        [103.652338, 30.5263],
                        [103.658319, 30.536202],
                        [103.665595, 30.538333],
                        [103.669994, 30.541665],
                        [103.67428, 30.546791],
                        [103.678242, 30.548599],
                        [103.682222, 30.548032],
                        [103.684165, 30.54586],
                        [103.686432, 30.546899],
                        [103.687251, 30.549111],
                        [103.690222, 30.550797],
                        [103.697326, 30.551445],
                        [103.698222, 30.557555],
                        [103.703021, 30.559537],
                        [103.708545, 30.556786],
                        [103.710507, 30.556759],
                        [103.716106, 30.561628],
                        [103.71984, 30.561439],
                        [103.723554, 30.55715],
                        [103.727572, 30.55367],
                        [103.741362, 30.542704],
                        [103.747476, 30.538832],
                        [103.749533, 30.536485],
                        [103.753076, 30.528445],
                        [103.758695, 30.518852],
                        [103.761742, 30.510837],
                        [103.764809, 30.501647],
                        [103.755838, 30.499987],
                        [103.749571, 30.500338],
                        [103.743953, 30.496114],
                        [103.741781, 30.491566],
                        [103.740829, 30.482766],
                        [103.739496, 30.479945],
                        [103.73601, 30.477475],
                        [103.735153, 30.47244],
                        [103.735972, 30.465866],
                        [103.734639, 30.462545],
                        [103.731972, 30.459561],
                        [103.730068, 30.453782],
                        [103.728391, 30.452081],
                        [103.719611, 30.447882],
                        [103.717078, 30.446046],
                        [103.717078, 30.444155],
                        [103.719573, 30.442143],
                        [103.714487, 30.438551],
                        [103.707783, 30.434527],
                        [103.699098, 30.443156],
                        [103.697212, 30.446694],
                        [103.700031, 30.450002],
                        [103.698622, 30.452014],
                        [103.691593, 30.455295],
                        [103.686375, 30.454498],
                        [103.681651, 30.456415],
                        [103.679651, 30.45948],
                        [103.67447, 30.464205],
                        [103.672147, 30.462599],
                        [103.668395, 30.461478],
                        [103.662395, 30.464894],
                        [103.659785, 30.468417],
                        [103.6559, 30.470901],
                        [103.648929, 30.47001],
                        [103.641463, 30.46376],
                        [103.638567, 30.460735],
                        [103.635939, 30.459115],
                        [103.632358, 30.458508],
                        [103.628701, 30.461896],
                        [103.627558, 30.460978],
                        [103.625425, 30.454984],
                        [103.618854, 30.450609],
                        [103.619407, 30.44853],
                        [103.622225, 30.443939],
                        [103.627901, 30.443845],
                        [103.628587, 30.441873],
                        [103.628663, 30.433082],
                        [103.625482, 30.427964],
                        [103.622759, 30.427532],
                        [103.617197, 30.428193],
                        [103.606855, 30.427491],
                        [103.601217, 30.429679],
                        [103.599141, 30.429652],
                        [103.590265, 30.426735],
                        [103.585903, 30.427181],
                        [103.583389, 30.428788],
                        [103.578551, 30.426924],
                        [103.575618, 30.427397],
                        [103.570171, 30.429936],
                        [103.566609, 30.433906],
                        [103.562552, 30.434703],
                        [103.559924, 30.433042],
                        [103.556991, 30.429625],
                        [103.555353, 30.429679],
                        [103.552838, 30.433676],
                        [103.555676, 30.439375],
                        [103.554191, 30.442062],
                        [103.54882, 30.443048],
                        [103.544706, 30.445208],
                        [103.540515, 30.444776],
                        [103.53922, 30.446235],
                        [103.535716, 30.447625],
                        [103.536439, 30.448611],
                        [103.533773, 30.450434],
                        [103.531716, 30.450029],
                        [103.529544, 30.451906],
                        [103.530363, 30.454079],
                        [103.528554, 30.456942],
                        [103.529697, 30.458332],
                        [103.525221, 30.461586],
                        [103.525449, 30.463287],
                        [103.522764, 30.465245],
                        [103.52284, 30.467297],
                        [103.52065, 30.468066],
                        [103.515907, 30.474411],
                        [103.516212, 30.476921],
                        [103.514212, 30.478015],
                        [103.509926, 30.478258],
                        [103.502251, 30.483684],
                        [103.497737, 30.485533],
                        [103.487451, 30.487396],
                        [103.482042, 30.4861],
                        [103.480899, 30.484116],
                        [103.481471, 30.481511],
                        [103.480233, 30.478379],
                        [103.478138, 30.47603],
                        [103.476004, 30.476354],
                        [103.474995, 30.480093],
                        [103.472576, 30.481619],
                        [103.461929, 30.48228],
                        [103.459453, 30.483171],
                        [103.456901, 30.488151],
                        [103.453948, 30.488367],
                        [103.452177, 30.49023],
                        [103.453072, 30.496884],
                        [103.450444, 30.502133],
                        [103.449149, 30.507895],
                        [103.447853, 30.509582],
                        [103.438978, 30.516747],
                        [103.431607, 30.525234],
                        [103.427569, 30.529079],
                        [103.413341, 30.535298],
                        [103.40797, 30.536539],
                        [103.40317, 30.543149],
                        [103.399722, 30.544458],
                        [103.395627, 30.542637],
                        [103.390028, 30.545577],
                        [103.383533, 30.546508],
                        [103.379571, 30.545456],
                        [103.374543, 30.540249],
                        [103.3726, 30.539318],
                        [103.368962, 30.540896],
                        [103.352658, 30.552402],
                        [103.349439, 30.553468],
                        [103.34582, 30.552753],
                        [103.341649, 30.548612],
                        [103.338335, 30.543311],
                        [103.335078, 30.541099],
                        [103.330278, 30.540357],
                        [103.321307, 30.542232],
                        [103.312127, 30.543203],
                        [103.305384, 30.541989],
                        [103.299423, 30.540303],
                        [103.297232, 30.538752],
                        [103.296223, 30.534543],
                        [103.297537, 30.531696],
                        [103.303594, 30.526799],
                        [103.304756, 30.520174],
                        [103.303804, 30.515398],
                        [103.301632, 30.510176],
                        [103.299594, 30.509015],
                        [103.296985, 30.509717],
                        [103.289176, 30.516207],
                        [103.285462, 30.518191],
                        [103.275138, 30.520795],
                        [103.271558, 30.520377],
                        [103.266244, 30.518272],
                        [103.263729, 30.516045],
                        [103.26392, 30.514102],
                        [103.256568, 30.510095],
                        [103.257254, 30.505035],
                        [103.25672, 30.502767],
                        [103.254206, 30.500946],
                        [103.251425, 30.500716],
                        [103.246454, 30.501566],
                        [103.24373, 30.503186],
                        [103.239159, 30.507504],
                        [103.234436, 30.507828],
                        [103.22855, 30.504589],
                        [103.224855, 30.504063],
                        [103.216989, 30.505615],
                        [103.212437, 30.509447],
                        [103.21137, 30.512254],
                        [103.211465, 30.51896],
                        [103.208646, 30.520673],
                        [103.201161, 30.519027],
                        [103.199561, 30.51927],
                        [103.196171, 30.522077],
                        [103.194533, 30.525355],
                        [103.190895, 30.528229],
                        [103.185676, 30.525935],
                        [103.180857, 30.525193],
                        [103.170458, 30.524073],
                        [103.164363, 30.524424],
                        [103.158706, 30.527082],
                        [103.157754, 30.529983],
                        [103.158592, 30.533099],
                        [103.164382, 30.546778],
                        [103.16623, 30.555747],
                        [103.164325, 30.56214],
                        [103.161887, 30.565188],
                        [103.154325, 30.570636],
                        [103.151564, 30.574844],
                        [103.151202, 30.582179],
                        [103.150421, 30.584377],
                        [103.147811, 30.585887],
                        [103.140936, 30.583487],
                        [103.137279, 30.582894],
                        [103.130784, 30.586844],
                        [103.128117, 30.590013],
                        [103.12686, 30.593936],
                        [103.126708, 30.597495],
                        [103.127717, 30.599518],
                        [103.127527, 30.609763],
                        [103.128136, 30.613079],
                        [103.133165, 30.619562],
                        [103.135564, 30.624064],
                        [103.134765, 30.630075],
                        [103.133298, 30.636477],
                        [103.134003, 30.646974],
                        [103.13345, 30.651636],
                        [103.131603, 30.654722],
                        [103.127946, 30.65778],
                        [103.125641, 30.660663],
                        [103.123717, 30.667251],
                        [103.119051, 30.670916],
                        [103.108804, 30.671522],
                        [103.103147, 30.67299],
                        [103.098138, 30.676223],
                        [103.0949, 30.680453],
                        [103.091338, 30.69069],
                        [103.088576, 30.693182],
                        [103.080158, 30.698111],
                        [103.077625, 30.700198],
                        [103.07711, 30.703686],
                        [103.078367, 30.708184],
                        [103.07852, 30.712076],
                        [103.075987, 30.715334],
                        [103.073244, 30.716465],
                        [103.068749, 30.716196],
                        [103.040807, 30.703861],
                        [103.035874, 30.70242],
                        [103.032713, 30.702366],
                        [103.031322, 30.7037],
                        [103.033951, 30.719105],
                        [103.033684, 30.720653],
                        [103.029741, 30.726214],
                        [103.020294, 30.735867],
                        [103.011856, 30.739596],
                        [103.007704, 30.743217],
                        [103.005152, 30.746474],
                        [102.997438, 30.759356],
                        [102.995057, 30.764753],
                        [102.994048, 30.769974],
                        [102.994143, 30.775209],
                        [102.992886, 30.778331],
                        [102.99641, 30.779919],
                        [103.002695, 30.78152],
                        [103.005323, 30.784117],
                        [103.007323, 30.790401],
                        [103.009514, 30.791585],
                        [103.016866, 30.792002],
                        [103.023361, 30.794881],
                        [103.031151, 30.799361],
                        [103.037912, 30.802361],
                        [103.052959, 30.802725],
                        [103.055588, 30.803653],
                        [103.063092, 30.809437],
                        [103.070768, 30.813661],
                        [103.077339, 30.814294],
                        [103.083681, 30.812693],
                        [103.092881, 30.806666],
                        [103.10029, 30.804178],
                        [103.112785, 30.797437],
                        [103.12027, 30.79402]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510131,
            "name": "蒲江县",
            "center": [103.511541, 30.194359],
            "centroid": [103.491481, 30.234295],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 14,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [103.44393, 30.117487],
                        [103.443854, 30.120021],
                        [103.449377, 30.121348],
                        [103.447796, 30.124695],
                        [103.443644, 30.127458],
                        [103.442863, 30.126347],
                        [103.436121, 30.124668],
                        [103.437187, 30.120129],
                        [103.439682, 30.119533],
                        [103.439682, 30.119492],
                        [103.437797, 30.116891],
                        [103.437625, 30.113193],
                        [103.436559, 30.110374],
                        [103.432216, 30.107583],
                        [103.430197, 30.108166],
                        [103.42715, 30.111621],
                        [103.425893, 30.114642],
                        [103.423683, 30.115171],
                        [103.420579, 30.11177],
                        [103.415931, 30.109629],
                        [103.403456, 30.095808],
                        [103.401303, 30.094304],
                        [103.397227, 30.09429],
                        [103.39357, 30.095686],
                        [103.389971, 30.098613],
                        [103.38898, 30.104602],
                        [103.387571, 30.105781],
                        [103.380333, 30.109196],
                        [103.378562, 30.112691],
                        [103.373571, 30.117785],
                        [103.3742, 30.12101],
                        [103.368867, 30.129951],
                        [103.365896, 30.131996],
                        [103.362315, 30.132633],
                        [103.360448, 30.134692],
                        [103.361096, 30.137455],
                        [103.368276, 30.140855],
                        [103.369857, 30.142724],
                        [103.372029, 30.147492],
                        [103.371686, 30.149631],
                        [103.369076, 30.154656],
                        [103.371419, 30.159938],
                        [103.371895, 30.162727],
                        [103.369476, 30.165341],
                        [103.363629, 30.166722],
                        [103.360924, 30.168022],
                        [103.359077, 30.170811],
                        [103.359115, 30.174061],
                        [103.364124, 30.179477],
                        [103.364353, 30.183566],
                        [103.361172, 30.18821],
                        [103.360924, 30.192623],
                        [103.365667, 30.194721],
                        [103.370086, 30.199337],
                        [103.369191, 30.206742],
                        [103.372162, 30.209422],
                        [103.373343, 30.213807],
                        [103.373324, 30.217867],
                        [103.372048, 30.222225],
                        [103.371952, 30.225473],
                        [103.370314, 30.228261],
                        [103.366181, 30.229073],
                        [103.36241, 30.231495],
                        [103.357515, 30.23178],
                        [103.348601, 30.236353],
                        [103.344716, 30.23519],
                        [103.338068, 30.23703],
                        [103.324393, 30.232186],
                        [103.32106, 30.232768],
                        [103.320317, 30.234906],
                        [103.321536, 30.244553],
                        [103.319955, 30.250994],
                        [103.315936, 30.258597],
                        [103.313898, 30.260396],
                        [103.308603, 30.261668],
                        [103.315632, 30.268905],
                        [103.326221, 30.27322],
                        [103.327669, 30.275506],
                        [103.327878, 30.2873],
                        [103.330202, 30.289316],
                        [103.33184, 30.288301],
                        [103.333288, 30.283121],
                        [103.33325, 30.277062],
                        [103.33424, 30.276047],
                        [103.338088, 30.278347],
                        [103.34123, 30.283554],
                        [103.340811, 30.287044],
                        [103.33763, 30.288978],
                        [103.336888, 30.291398],
                        [103.338297, 30.292494],
                        [103.347306, 30.291912],
                        [103.356163, 30.297957],
                        [103.361267, 30.300391],
                        [103.368695, 30.301311],
                        [103.368924, 30.305895],
                        [103.371648, 30.309235],
                        [103.3742, 30.310831],
                        [103.379476, 30.312737],
                        [103.382619, 30.312385],
                        [103.386504, 30.310695],
                        [103.395304, 30.311128],
                        [103.400103, 30.312331],
                        [103.40376, 30.314643],
                        [103.406294, 30.317997],
                        [103.405036, 30.32116],
                        [103.406694, 30.323945],
                        [103.418312, 30.328907],
                        [103.42534, 30.33372],
                        [103.429988, 30.333084],
                        [103.43214, 30.329705],
                        [103.433187, 30.325933],
                        [103.436006, 30.323283],
                        [103.442273, 30.322296],
                        [103.449225, 30.325446],
                        [103.456215, 30.326392],
                        [103.460748, 30.32765],
                        [103.465795, 30.327744],
                        [103.469909, 30.329488],
                        [103.473014, 30.332435],
                        [103.47768, 30.333125],
                        [103.482918, 30.327055],
                        [103.489223, 30.326271],
                        [103.490251, 30.327636],
                        [103.487375, 30.331868],
                        [103.488842, 30.333233],
                        [103.497127, 30.332936],
                        [103.503241, 30.33207],
                        [103.506079, 30.332908],
                        [103.514345, 30.328231],
                        [103.520573, 30.328042],
                        [103.523069, 30.329231],
                        [103.523583, 30.332435],
                        [103.526402, 30.335626],
                        [103.529563, 30.335964],
                        [103.53402, 30.333206],
                        [103.53882, 30.332706],
                        [103.542439, 30.333544],
                        [103.550991, 30.338451],
                        [103.556248, 30.338721],
                        [103.558724, 30.337843],
                        [103.560438, 30.332841],
                        [103.556857, 30.322985],
                        [103.557314, 30.31851],
                        [103.559219, 30.316577],
                        [103.564514, 30.315184],
                        [103.568781, 30.312859],
                        [103.576399, 30.312142],
                        [103.584132, 30.312602],
                        [103.589446, 30.314278],
                        [103.594779, 30.31728],
                        [103.599941, 30.320836],
                        [103.608398, 30.32062],
                        [103.614778, 30.32112],
                        [103.622568, 30.320674],
                        [103.625673, 30.31947],
                        [103.62933, 30.314576],
                        [103.637101, 30.312345],
                        [103.641082, 30.312656],
                        [103.646738, 30.316225],
                        [103.649672, 30.31563],
                        [103.651272, 30.309505],
                        [103.652757, 30.307815],
                        [103.657138, 30.306625],
                        [103.661862, 30.308437],
                        [103.664014, 30.308059],
                        [103.669766, 30.303339],
                        [103.674775, 30.300973],
                        [103.679994, 30.29647],
                        [103.686603, 30.294414],
                        [103.692431, 30.284514],
                        [103.69106, 30.280768],
                        [103.684946, 30.279442],
                        [103.682889, 30.27767],
                        [103.682356, 30.274505],
                        [103.683479, 30.271421],
                        [103.681937, 30.270339],
                        [103.681632, 30.264928],
                        [103.682165, 30.263481],
                        [103.686755, 30.261979],
                        [103.687422, 30.260653],
                        [103.687041, 30.255878],
                        [103.69165, 30.254579],
                        [103.690165, 30.251711],
                        [103.691174, 30.247097],
                        [103.693117, 30.245933],
                        [103.689327, 30.243146],
                        [103.684032, 30.240386],
                        [103.67767, 30.23883],
                        [103.667652, 30.237395],
                        [103.654719, 30.23611],
                        [103.651272, 30.234527],
                        [103.648034, 30.229263],
                        [103.647177, 30.225379],
                        [103.647805, 30.221806],
                        [103.651424, 30.218328],
                        [103.650129, 30.212873],
                        [103.653405, 30.207446],
                        [103.653633, 30.201693],
                        [103.652986, 30.200177],
                        [103.649557, 30.199825],
                        [103.64112, 30.204603],
                        [103.634739, 30.207473],
                        [103.631787, 30.213509],
                        [103.628054, 30.214863],
                        [103.625006, 30.207148],
                        [103.617502, 30.195398],
                        [103.614473, 30.193598],
                        [103.609388, 30.193192],
                        [103.608245, 30.194613],
                        [103.609426, 30.197659],
                        [103.611521, 30.199581],
                        [103.611807, 30.201666],
                        [103.601865, 30.203317],
                        [103.597255, 30.203493],
                        [103.593065, 30.201788],
                        [103.58798, 30.201233],
                        [103.584456, 30.197063],
                        [103.581656, 30.196386],
                        [103.577275, 30.197672],
                        [103.56779, 30.194085],
                        [103.563447, 30.191824],
                        [103.561752, 30.187438],
                        [103.559524, 30.185678],
                        [103.543029, 30.181413],
                        [103.533868, 30.178123],
                        [103.535106, 30.172815],
                        [103.540591, 30.165693],
                        [103.542096, 30.162917],
                        [103.543848, 30.162632],
                        [103.544134, 30.160479],
                        [103.54242, 30.156606],
                        [103.539525, 30.153871],
                        [103.537563, 30.150647],
                        [103.533792, 30.146679],
                        [103.530211, 30.144661],
                        [103.520078, 30.140963],
                        [103.516193, 30.139121],
                        [103.514231, 30.136399],
                        [103.513355, 30.130127],
                        [103.510974, 30.127472],
                        [103.507393, 30.129219],
                        [103.504155, 30.128528],
                        [103.497546, 30.121755],
                        [103.491032, 30.112894],
                        [103.486194, 30.104169],
                        [103.483509, 30.102976],
                        [103.482004, 30.110971],
                        [103.479604, 30.116146],
                        [103.473947, 30.11937],
                        [103.473433, 30.121308],
                        [103.4745, 30.124383],
                        [103.474557, 30.131265],
                        [103.472424, 30.131752],
                        [103.469643, 30.130154],
                        [103.466291, 30.130791],
                        [103.462215, 30.134353],
                        [103.45511, 30.134651],
                        [103.450901, 30.132213],
                        [103.450825, 30.130086],
                        [103.453663, 30.124762],
                        [103.456881, 30.12166],
                        [103.462348, 30.119154],
                        [103.468138, 30.114263],
                        [103.469928, 30.106879],
                        [103.468309, 30.102177],
                        [103.466271, 30.099291],
                        [103.462538, 30.096039],
                        [103.459738, 30.094914],
                        [103.455358, 30.094778],
                        [103.450463, 30.096499],
                        [103.448406, 30.098423],
                        [103.447644, 30.101242],
                        [103.44292, 30.10845],
                        [103.442368, 30.112949],
                        [103.445015, 30.115184],
                        [103.44393, 30.117487]
                    ]
                ],
                [
                    [
                        [103.443854, 30.120021],
                        [103.44393, 30.117487],
                        [103.439682, 30.119492],
                        [103.439682, 30.119533],
                        [103.443854, 30.120021]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510181,
            "name": "都江堰市",
            "center": [103.627898, 30.99114],
            "centroid": [103.63078, 31.033076],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 15,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [103.43294, 30.878301],
                        [103.439663, 30.883463],
                        [103.443739, 30.884551],
                        [103.451377, 30.892562],
                        [103.453948, 30.898315],
                        [103.455224, 30.903381],
                        [103.454672, 30.924706],
                        [103.456977, 30.930927],
                        [103.460119, 30.935535],
                        [103.465091, 30.94154],
                        [103.478766, 30.951037],
                        [103.485109, 30.954301],
                        [103.498289, 30.961729],
                        [103.502917, 30.964764],
                        [103.50526, 30.969867],
                        [103.50705, 30.971009],
                        [103.516497, 30.971774],
                        [103.51884, 30.975521],
                        [103.516383, 30.978435],
                        [103.514669, 30.986035],
                        [103.516726, 30.993823],
                        [103.519716, 30.997649],
                        [103.52065, 31.001153],
                        [103.520726, 31.009517],
                        [103.517945, 31.01949],
                        [103.517145, 31.030147],
                        [103.515812, 31.032375],
                        [103.505031, 31.03832],
                        [103.504803, 31.041071],
                        [103.50926, 31.049042],
                        [103.513602, 31.055241],
                        [103.517164, 31.058515],
                        [103.520116, 31.063506],
                        [103.521145, 31.067759],
                        [103.520459, 31.079899],
                        [103.524021, 31.084554],
                        [103.528097, 31.088001],
                        [103.52863, 31.090228],
                        [103.526059, 31.096639],
                        [103.525697, 31.101118],
                        [103.529316, 31.104337],
                        [103.532078, 31.111391],
                        [103.534382, 31.112825],
                        [103.542287, 31.123096],
                        [103.545163, 31.129974],
                        [103.547029, 31.138635],
                        [103.550591, 31.142134],
                        [103.552305, 31.144828],
                        [103.555162, 31.146571],
                        [103.557714, 31.150914],
                        [103.557105, 31.153849],
                        [103.560343, 31.157522],
                        [103.562838, 31.163767],
                        [103.564819, 31.175011],
                        [103.568876, 31.176566],
                        [103.574437, 31.180251],
                        [103.58217, 31.189041],
                        [103.583218, 31.191399],
                        [103.58337, 31.199987],
                        [103.582646, 31.208815],
                        [103.576742, 31.215848],
                        [103.580894, 31.233862],
                        [103.581523, 31.239125],
                        [103.581389, 31.246611],
                        [103.580189, 31.249329],
                        [103.574152, 31.257965],
                        [103.569123, 31.262008],
                        [103.569523, 31.273254],
                        [103.570247, 31.275824],
                        [103.573999, 31.280884],
                        [103.579085, 31.288741],
                        [103.579732, 31.291271],
                        [103.578132, 31.294188],
                        [103.574495, 31.29831],
                        [103.573009, 31.30179],
                        [103.572247, 31.307237],
                        [103.570342, 31.312335],
                        [103.570323, 31.316282],
                        [103.571828, 31.319895],
                        [103.571942, 31.322424],
                        [103.56939, 31.327347],
                        [103.568628, 31.331642],
                        [103.56958, 31.338451],
                        [103.573504, 31.341622],
                        [103.57878, 31.340043],
                        [103.58377, 31.340966],
                        [103.590779, 31.341113],
                        [103.59537, 31.34209],
                        [103.598093, 31.343709],
                        [103.602417, 31.348136],
                        [103.603788, 31.350611],
                        [103.60714, 31.351306],
                        [103.610683, 31.349153],
                        [103.612969, 31.346571],
                        [103.617845, 31.346892],
                        [103.62434, 31.345488],
                        [103.627082, 31.344123],
                        [103.628758, 31.344819],
                        [103.631406, 31.34815],
                        [103.634739, 31.350517],
                        [103.643672, 31.352911],
                        [103.649234, 31.352604],
                        [103.657481, 31.350169],
                        [103.668033, 31.354128],
                        [103.670699, 31.355854],
                        [103.674204, 31.361444],
                        [103.679061, 31.36662],
                        [103.68586, 31.361391],
                        [103.689422, 31.356924],
                        [103.691517, 31.353045],
                        [103.696945, 31.348765],
                        [103.694527, 31.338211],
                        [103.695669, 31.335187],
                        [103.698641, 31.332512],
                        [103.698983, 31.327923],
                        [103.700602, 31.324377],
                        [103.703098, 31.322384],
                        [103.70845, 31.320511],
                        [103.711002, 31.317781],
                        [103.710888, 31.315252],
                        [103.713706, 31.311037],
                        [103.71384, 31.309485],
                        [103.711135, 31.305002],
                        [103.708735, 31.302807],
                        [103.709554, 31.300238],
                        [103.712488, 31.298873],
                        [103.714068, 31.293037],
                        [103.715744, 31.28937],
                        [103.721725, 31.284351],
                        [103.722544, 31.279947],
                        [103.722316, 31.27055],
                        [103.721192, 31.267845],
                        [103.718011, 31.263481],
                        [103.713497, 31.259277],
                        [103.707288, 31.25443],
                        [103.703383, 31.249838],
                        [103.697726, 31.245446],
                        [103.695669, 31.242982],
                        [103.694279, 31.239299],
                        [103.693308, 31.233741],
                        [103.68866, 31.228505],
                        [103.684775, 31.219036],
                        [103.68386, 31.21278],
                        [103.684622, 31.209913],
                        [103.686832, 31.207636],
                        [103.693822, 31.19862],
                        [103.69706, 31.19227],
                        [103.696736, 31.188826],
                        [103.698812, 31.186723],
                        [103.703897, 31.186455],
                        [103.706031, 31.185611],
                        [103.714678, 31.175668],
                        [103.718163, 31.17213],
                        [103.720716, 31.168351],
                        [103.723268, 31.166984],
                        [103.731687, 31.163982],
                        [103.739553, 31.164237],
                        [103.739896, 31.160403],
                        [103.737134, 31.152884],
                        [103.734944, 31.149319],
                        [103.73502, 31.14578],
                        [103.740848, 31.139265],
                        [103.741667, 31.137482],
                        [103.741077, 31.133299],
                        [103.741838, 31.127052],
                        [103.744943, 31.119543],
                        [103.747514, 31.114756],
                        [103.749667, 31.113094],
                        [103.754562, 31.112597],
                        [103.756219, 31.108239],
                        [103.761856, 31.104002],
                        [103.763666, 31.10203],
                        [103.764085, 31.099562],
                        [103.762904, 31.091261],
                        [103.763456, 31.088618],
                        [103.767094, 31.085198],
                        [103.769932, 31.083857],
                        [103.77997, 31.084661],
                        [103.784008, 31.084339],
                        [103.78517, 31.082743],
                        [103.783646, 31.080007],
                        [103.771342, 31.079484],
                        [103.767399, 31.07892],
                        [103.759914, 31.076318],
                        [103.754314, 31.076076],
                        [103.746524, 31.071395],
                        [103.739058, 31.070335],
                        [103.730525, 31.071663],
                        [103.727668, 31.071234],
                        [103.726887, 31.068805],
                        [103.727953, 31.065988],
                        [103.734696, 31.061172],
                        [103.740143, 31.059588],
                        [103.740753, 31.053631],
                        [103.742638, 31.046238],
                        [103.747076, 31.034965],
                        [103.750505, 31.033596],
                        [103.753666, 31.029221],
                        [103.753819, 31.02545],
                        [103.750428, 31.017316],
                        [103.751076, 31.013584],
                        [103.759628, 31.005194],
                        [103.763952, 31.002872],
                        [103.766447, 31.000119],
                        [103.770104, 30.99205],
                        [103.774084, 30.988251],
                        [103.774256, 30.982678],
                        [103.776694, 30.981027],
                        [103.782598, 30.980006],
                        [103.782636, 30.978381],
                        [103.780275, 30.974756],
                        [103.78256, 30.961675],
                        [103.779056, 30.957847],
                        [103.777208, 30.959405],
                        [103.772675, 30.959902],
                        [103.767037, 30.953912],
                        [103.766428, 30.949479],
                        [103.767989, 30.9424],
                        [103.766828, 30.936086],
                        [103.767247, 30.923054],
                        [103.764828, 30.917478],
                        [103.761875, 30.915045],
                        [103.760161, 30.906445],
                        [103.75439, 30.899336],
                        [103.749267, 30.900962],
                        [103.74801, 30.898261],
                        [103.751724, 30.893933],
                        [103.756542, 30.891621],
                        [103.759666, 30.884887],
                        [103.759685, 30.882629],
                        [103.754657, 30.88189],
                        [103.751933, 30.879497],
                        [103.748809, 30.879175],
                        [103.744543, 30.879981],
                        [103.735534, 30.878005],
                        [103.735324, 30.875303],
                        [103.730582, 30.866619],
                        [103.726144, 30.863258],
                        [103.715821, 30.861241],
                        [103.71523, 30.863016],
                        [103.71184, 30.866242],
                        [103.70984, 30.867103],
                        [103.706697, 30.870773],
                        [103.701574, 30.873838],
                        [103.701021, 30.877521],
                        [103.697117, 30.879659],
                        [103.693955, 30.884215],
                        [103.690203, 30.884377],
                        [103.687746, 30.882508],
                        [103.689612, 30.877951],
                        [103.689574, 30.874107],
                        [103.69226, 30.870813],
                        [103.69186, 30.866807],
                        [103.694107, 30.8651],
                        [103.695326, 30.859265],
                        [103.697307, 30.857234],
                        [103.698241, 30.852945],
                        [103.700183, 30.847768],
                        [103.700469, 30.836903],
                        [103.702507, 30.831833],
                        [103.708221, 30.823427],
                        [103.71123, 30.821113],
                        [103.71083, 30.818396],
                        [103.715306, 30.815343],
                        [103.714849, 30.811065],
                        [103.716468, 30.804756],
                        [103.718392, 30.801299],
                        [103.717859, 30.797666],
                        [103.718449, 30.793401],
                        [103.723954, 30.779798],
                        [103.723554, 30.773191],
                        [103.721897, 30.772329],
                        [103.721992, 30.76953],
                        [103.724658, 30.767485],
                        [103.724049, 30.764362],
                        [103.72622, 30.760971],
                        [103.728925, 30.755156],
                        [103.730029, 30.749544],
                        [103.716583, 30.748776],
                        [103.715783, 30.749369],
                        [103.712468, 30.756623],
                        [103.709497, 30.761523],
                        [103.70424, 30.766718],
                        [103.699402, 30.769423],
                        [103.681384, 30.774281],
                        [103.675004, 30.774509],
                        [103.664338, 30.773352],
                        [103.655824, 30.770297],
                        [103.611312, 30.761899],
                        [103.610816, 30.764268],
                        [103.608626, 30.766314],
                        [103.606969, 30.769638],
                        [103.603903, 30.772289],
                        [103.605845, 30.775586],
                        [103.607579, 30.780444],
                        [103.609826, 30.782112],
                        [103.610683, 30.78479],
                        [103.610302, 30.789257],
                        [103.609369, 30.790858],
                        [103.601941, 30.79359],
                        [103.599693, 30.795648],
                        [103.599027, 30.799711],
                        [103.595751, 30.808751],
                        [103.591979, 30.810904],
                        [103.585542, 30.809585],
                        [103.582075, 30.810339],
                        [103.579351, 30.812397],
                        [103.578304, 30.816674],
                        [103.576247, 30.818679],
                        [103.571733, 30.819028],
                        [103.56299, 30.823279],
                        [103.557829, 30.823561],
                        [103.552743, 30.819835],
                        [103.549086, 30.819459],
                        [103.544839, 30.823763],
                        [103.543829, 30.826278],
                        [103.544401, 30.830689],
                        [103.543753, 30.833796],
                        [103.541639, 30.836082],
                        [103.532535, 30.837562],
                        [103.524078, 30.836916],
                        [103.517221, 30.841246],
                        [103.513926, 30.84013],
                        [103.50966, 30.841919],
                        [103.50425, 30.843102],
                        [103.500955, 30.847405],
                        [103.50067, 30.85195],
                        [103.499698, 30.854787],
                        [103.497375, 30.856307],
                        [103.493222, 30.8555],
                        [103.487356, 30.856616],
                        [103.481204, 30.855204],
                        [103.478728, 30.855379],
                        [103.477242, 30.857113],
                        [103.475376, 30.862343],
                        [103.470576, 30.867936],
                        [103.467548, 30.868313],
                        [103.4625, 30.867493],
                        [103.455815, 30.869281],
                        [103.441492, 30.874403],
                        [103.436921, 30.87451],
                        [103.43374, 30.873703],
                        [103.431302, 30.874698],
                        [103.43294, 30.878301]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510182,
            "name": "彭州市",
            "center": [103.941173, 30.985161],
            "centroid": [103.8832, 31.142706],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 16,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [104.150008, 30.913097],
                        [104.144446, 30.915771],
                        [104.137894, 30.914723],
                        [104.131552, 30.914508],
                        [104.124581, 30.911538],
                        [104.121038, 30.911538],
                        [104.114067, 30.91471],
                        [104.101496, 30.912855],
                        [104.09843, 30.913016],
                        [104.091306, 30.914898],
                        [104.08165, 30.915785],
                        [104.075688, 30.917814],
                        [104.068965, 30.922933],
                        [104.066965, 30.927259],
                        [104.068031, 30.932566],
                        [104.067079, 30.937752],
                        [104.063536, 30.943125],
                        [104.062889, 30.950312],
                        [104.060946, 30.952192],
                        [104.053251, 30.956719],
                        [104.051251, 30.958505],
                        [104.049861, 30.964186],
                        [104.045404, 30.964871],
                        [104.04108, 30.960077],
                        [104.036738, 30.958062],
                        [104.032052, 30.958438],
                        [104.028014, 30.95692],
                        [104.02331, 30.951897],
                        [104.017862, 30.94827],
                        [104.014206, 30.946537],
                        [104.011577, 30.942239],
                        [104.006606, 30.940667],
                        [104.001578, 30.941177],
                        [104.001749, 30.93845],
                        [103.996092, 30.937362],
                        [103.990492, 30.939324],
                        [103.986321, 30.937725],
                        [103.978245, 30.937201],
                        [103.976207, 30.936287],
                        [103.971027, 30.932002],
                        [103.966417, 30.929812],
                        [103.964037, 30.926278],
                        [103.964379, 30.920017],
                        [103.961694, 30.916886],
                        [103.959389, 30.91694],
                        [103.95478, 30.919789],
                        [103.952285, 30.915596],
                        [103.948666, 30.916524],
                        [103.941752, 30.921361],
                        [103.926572, 30.922879],
                        [103.917353, 30.922046],
                        [103.912687, 30.922086],
                        [103.908916, 30.923752],
                        [103.906116, 30.925929],
                        [103.903106, 30.92699],
                        [103.892269, 30.926077],
                        [103.889431, 30.927071],
                        [103.887241, 30.929355],
                        [103.879336, 30.931102],
                        [103.874117, 30.930793],
                        [103.870841, 30.9318],
                        [103.864727, 30.936905],
                        [103.861051, 30.937926],
                        [103.854366, 30.935643],
                        [103.850519, 30.936892],
                        [103.844652, 30.935696],
                        [103.842938, 30.929167],
                        [103.840157, 30.927259],
                        [103.838043, 30.928038],
                        [103.83391, 30.927797],
                        [103.82871, 30.929382],
                        [103.827853, 30.933103],
                        [103.826291, 30.934568],
                        [103.824882, 30.938276],
                        [103.821644, 30.940627],
                        [103.818254, 30.941769],
                        [103.815397, 30.944066],
                        [103.812387, 30.944939],
                        [103.803664, 30.944549],
                        [103.801454, 30.943018],
                        [103.79934, 30.943166],
                        [103.795607, 30.945463],
                        [103.794331, 30.948095],
                        [103.789474, 30.950298],
                        [103.785055, 30.955429],
                        [103.780789, 30.956464],
                        [103.779056, 30.957847],
                        [103.78256, 30.961675],
                        [103.780275, 30.974756],
                        [103.782636, 30.978381],
                        [103.782598, 30.980006],
                        [103.776694, 30.981027],
                        [103.774256, 30.982678],
                        [103.774084, 30.988251],
                        [103.770104, 30.99205],
                        [103.766447, 31.000119],
                        [103.763952, 31.002872],
                        [103.759628, 31.005194],
                        [103.751076, 31.013584],
                        [103.750428, 31.017316],
                        [103.753819, 31.02545],
                        [103.753666, 31.029221],
                        [103.750505, 31.033596],
                        [103.747076, 31.034965],
                        [103.742638, 31.046238],
                        [103.740753, 31.053631],
                        [103.740143, 31.059588],
                        [103.734696, 31.061172],
                        [103.727953, 31.065988],
                        [103.726887, 31.068805],
                        [103.727668, 31.071234],
                        [103.730525, 31.071663],
                        [103.739058, 31.070335],
                        [103.746524, 31.071395],
                        [103.754314, 31.076076],
                        [103.759914, 31.076318],
                        [103.767399, 31.07892],
                        [103.771342, 31.079484],
                        [103.783646, 31.080007],
                        [103.78517, 31.082743],
                        [103.784008, 31.084339],
                        [103.77997, 31.084661],
                        [103.769932, 31.083857],
                        [103.767094, 31.085198],
                        [103.763456, 31.088618],
                        [103.762904, 31.091261],
                        [103.764085, 31.099562],
                        [103.763666, 31.10203],
                        [103.761856, 31.104002],
                        [103.756219, 31.108239],
                        [103.754562, 31.112597],
                        [103.749667, 31.113094],
                        [103.747514, 31.114756],
                        [103.744943, 31.119543],
                        [103.741838, 31.127052],
                        [103.741077, 31.133299],
                        [103.741667, 31.137482],
                        [103.740848, 31.139265],
                        [103.73502, 31.14578],
                        [103.734944, 31.149319],
                        [103.737134, 31.152884],
                        [103.739896, 31.160403],
                        [103.739553, 31.164237],
                        [103.731687, 31.163982],
                        [103.723268, 31.166984],
                        [103.720716, 31.168351],
                        [103.718163, 31.17213],
                        [103.714678, 31.175668],
                        [103.706031, 31.185611],
                        [103.703897, 31.186455],
                        [103.698812, 31.186723],
                        [103.696736, 31.188826],
                        [103.69706, 31.19227],
                        [103.693822, 31.19862],
                        [103.686832, 31.207636],
                        [103.684622, 31.209913],
                        [103.68386, 31.21278],
                        [103.684775, 31.219036],
                        [103.68866, 31.228505],
                        [103.693308, 31.233741],
                        [103.694279, 31.239299],
                        [103.695669, 31.242982],
                        [103.697726, 31.245446],
                        [103.703383, 31.249838],
                        [103.707288, 31.25443],
                        [103.713497, 31.259277],
                        [103.718011, 31.263481],
                        [103.721192, 31.267845],
                        [103.722316, 31.27055],
                        [103.722544, 31.279947],
                        [103.721725, 31.284351],
                        [103.715744, 31.28937],
                        [103.714068, 31.293037],
                        [103.712488, 31.298873],
                        [103.709554, 31.300238],
                        [103.708735, 31.302807],
                        [103.711135, 31.305002],
                        [103.71384, 31.309485],
                        [103.713706, 31.311037],
                        [103.710888, 31.315252],
                        [103.711002, 31.317781],
                        [103.70845, 31.320511],
                        [103.703098, 31.322384],
                        [103.700602, 31.324377],
                        [103.698983, 31.327923],
                        [103.698641, 31.332512],
                        [103.695669, 31.335187],
                        [103.694527, 31.338211],
                        [103.696945, 31.348765],
                        [103.691517, 31.353045],
                        [103.689422, 31.356924],
                        [103.68586, 31.361391],
                        [103.679061, 31.36662],
                        [103.681918, 31.371956],
                        [103.68906, 31.376008],
                        [103.697783, 31.38379],
                        [103.699574, 31.386544],
                        [103.700831, 31.39113],
                        [103.705631, 31.392307],
                        [103.712792, 31.391946],
                        [103.717402, 31.392708],
                        [103.722411, 31.394901],
                        [103.729896, 31.394633],
                        [103.73382, 31.397173],
                        [103.739915, 31.398858],
                        [103.741438, 31.400355],
                        [103.744867, 31.409994],
                        [103.745076, 31.414365],
                        [103.750295, 31.419163],
                        [103.754543, 31.421716],
                        [103.760142, 31.423814],
                        [103.769608, 31.426167],
                        [103.773037, 31.428853],
                        [103.778084, 31.431218],
                        [103.785741, 31.434065],
                        [103.78896, 31.434092],
                        [103.790998, 31.432261],
                        [103.79395, 31.431392],
                        [103.799169, 31.431472],
                        [103.801892, 31.429815],
                        [103.805359, 31.432461],
                        [103.806311, 31.435067],
                        [103.808883, 31.435321],
                        [103.816044, 31.431927],
                        [103.816844, 31.429294],
                        [103.817473, 31.422651],
                        [103.828634, 31.412453],
                        [103.831643, 31.411357],
                        [103.837034, 31.414405],
                        [103.839891, 31.414298],
                        [103.844557, 31.412908],
                        [103.851223, 31.413375],
                        [103.856156, 31.414806],
                        [103.860747, 31.417332],
                        [103.864804, 31.420647],
                        [103.868461, 31.420994],
                        [103.873356, 31.416182],
                        [103.876022, 31.414979],
                        [103.879222, 31.414819],
                        [103.883698, 31.415741],
                        [103.887164, 31.418027],
                        [103.889964, 31.421008],
                        [103.894554, 31.419925],
                        [103.896916, 31.41776],
                        [103.89745, 31.415233],
                        [103.894745, 31.408884],
                        [103.897602, 31.403764],
                        [103.898688, 31.400061],
                        [103.902725, 31.396411],
                        [103.908154, 31.388202],
                        [103.907982, 31.382185],
                        [103.910382, 31.379712],
                        [103.912496, 31.378883],
                        [103.92021, 31.37098],
                        [103.92082, 31.369549],
                        [103.92002, 31.362889],
                        [103.925391, 31.360388],
                        [103.928, 31.357405],
                        [103.928324, 31.355118],
                        [103.92661, 31.34938],
                        [103.923601, 31.346518],
                        [103.91941, 31.345822],
                        [103.914268, 31.343856],
                        [103.908211, 31.339602],
                        [103.902402, 31.334264],
                        [103.894421, 31.32601],
                        [103.892974, 31.322798],
                        [103.891926, 31.315975],
                        [103.891621, 31.308013],
                        [103.892231, 31.303771],
                        [103.896097, 31.297869],
                        [103.900516, 31.296276],
                        [103.902783, 31.29364],
                        [103.907278, 31.286131],
                        [103.912363, 31.283628],
                        [103.914172, 31.278983],
                        [103.928019, 31.272477],
                        [103.931753, 31.26802],
                        [103.932972, 31.265155],
                        [103.932229, 31.263441],
                        [103.926762, 31.259987],
                        [103.925962, 31.25826],
                        [103.926781, 31.253627],
                        [103.932076, 31.247561],
                        [103.93461, 31.243611],
                        [103.933886, 31.24104],
                        [103.929105, 31.234438],
                        [103.929981, 31.229965],
                        [103.93501, 31.223174],
                        [103.936705, 31.222277],
                        [103.939295, 31.223188],
                        [103.941676, 31.222772],
                        [103.944476, 31.220857],
                        [103.94579, 31.218299],
                        [103.941352, 31.217951],
                        [103.941124, 31.216584],
                        [103.94619, 31.216504],
                        [103.94659, 31.215392],
                        [103.950323, 31.215111],
                        [103.948799, 31.213436],
                        [103.948514, 31.210423],
                        [103.94678, 31.209324],
                        [103.946495, 31.206953],
                        [103.947637, 31.204274],
                        [103.950933, 31.203256],
                        [103.954151, 31.204354],
                        [103.957313, 31.202974],
                        [103.959542, 31.203644],
                        [103.963522, 31.208185],
                        [103.966341, 31.204501],
                        [103.969408, 31.207301],
                        [103.973541, 31.20623],
                        [103.97356, 31.203095],
                        [103.977179, 31.2028],
                        [103.976588, 31.201755],
                        [103.979883, 31.200657],
                        [103.982988, 31.200938],
                        [103.984112, 31.197776],
                        [103.988054, 31.194145],
                        [103.986474, 31.192256],
                        [103.988512, 31.19101],
                        [103.990397, 31.191707],
                        [103.994092, 31.189416],
                        [103.99714, 31.186374],
                        [103.999368, 31.182743],
                        [103.999159, 31.181296],
                        [104.002358, 31.177196],
                        [104.006606, 31.177423],
                        [104.008168, 31.178495],
                        [104.010244, 31.173765],
                        [104.009787, 31.171929],
                        [104.01472, 31.1676],
                        [104.014072, 31.164277],
                        [104.010091, 31.163915],
                        [104.01091, 31.160511],
                        [104.009387, 31.153568],
                        [104.012377, 31.149064],
                        [104.017177, 31.147375],
                        [104.022872, 31.142683],
                        [104.020929, 31.140565],
                        [104.020872, 31.135806],
                        [104.023234, 31.133782],
                        [104.022034, 31.131892],
                        [104.024053, 31.12803],
                        [104.023157, 31.125885],
                        [104.024986, 31.123405],
                        [104.021615, 31.121461],
                        [104.021367, 31.116727],
                        [104.017291, 31.114823],
                        [104.018129, 31.113697],
                        [104.022338, 31.112866],
                        [104.024015, 31.113737],
                        [104.030262, 31.111082],
                        [104.028814, 31.109795],
                        [104.023843, 31.108668],
                        [104.020224, 31.105517],
                        [104.019862, 31.103934],
                        [104.025443, 31.10486],
                        [104.028624, 31.103492],
                        [104.026757, 31.101789],
                        [104.027043, 31.099938],
                        [104.030071, 31.100072],
                        [104.028186, 31.098127],
                        [104.030986, 31.098208],
                        [104.031424, 31.096236],
                        [104.034109, 31.093863],
                        [104.037042, 31.093272],
                        [104.043823, 31.090697],
                        [104.043899, 31.089155],
                        [104.04188, 31.087277],
                        [104.043309, 31.086097],
                        [104.043594, 31.082783],
                        [104.050661, 31.079591],
                        [104.057613, 31.078182],
                        [104.058279, 31.074359],
                        [104.059994, 31.074762],
                        [104.060565, 31.064137],
                        [104.068431, 31.062969],
                        [104.076469, 31.059401],
                        [104.078831, 31.057549],
                        [104.07904, 31.05241],
                        [104.07784, 31.050102],
                        [104.083764, 31.04656],
                        [104.084488, 31.044641],
                        [104.087935, 31.041071],
                        [104.086792, 31.037542],
                        [104.091554, 31.035905],
                        [104.092563, 31.03365],
                        [104.094887, 31.032764],
                        [104.105877, 31.030697],
                        [104.106448, 31.031798],
                        [104.106582, 31.031637],
                        [104.107153, 31.032013],
                        [104.10702, 31.032281],
                        [104.109077, 31.033408],
                        [104.110715, 31.029986],
                        [104.116905, 31.029355],
                        [104.1218, 31.029892],
                        [104.121686, 31.026483],
                        [104.117267, 31.025087],
                        [104.116181, 31.023852],
                        [104.115972, 31.020027],
                        [104.1174, 31.017557],
                        [104.120124, 31.018161],
                        [104.124219, 31.017759],
                        [104.1302, 31.014336],
                        [104.137894, 31.012403],
                        [104.143418, 31.011584],
                        [104.145323, 31.00604],
                        [104.149341, 31.005597],
                        [104.148542, 31.002643],
                        [104.151456, 31.002697],
                        [104.152275, 31.0051],
                        [104.154465, 31.005019],
                        [104.155608, 31.002482],
                        [104.159874, 31.000777],
                        [104.161874, 30.997837],
                        [104.168045, 30.991822],
                        [104.169455, 30.986169],
                        [104.166445, 30.984733],
                        [104.165684, 30.98288],
                        [104.169207, 30.976864],
                        [104.16995, 30.969787],
                        [104.167722, 30.966134],
                        [104.167664, 30.963072],
                        [104.163817, 30.959969],
                        [104.163817, 30.958317],
                        [104.166883, 30.953482],
                        [104.16635, 30.951279],
                        [104.160884, 30.950191],
                        [104.159589, 30.944818],
                        [104.157227, 30.9424],
                        [104.153494, 30.942051],
                        [104.152484, 30.94013],
                        [104.153151, 30.93794],
                        [104.152751, 30.929449],
                        [104.150599, 30.927918],
                        [104.144808, 30.927326],
                        [104.142561, 30.925029],
                        [104.144008, 30.923148],
                        [104.146656, 30.922113],
                        [104.148218, 30.916577],
                        [104.150008, 30.913097]
                    ]
                ],
                [
                    [
                        [104.107153, 31.032013],
                        [104.106582, 31.031637],
                        [104.106448, 31.031798],
                        [104.10702, 31.032281],
                        [104.107153, 31.032013]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510183,
            "name": "邛崃市",
            "center": [103.46143, 30.413271],
            "centroid": [103.369854, 30.382094],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 17,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [103.683479, 30.271421],
                        [103.682356, 30.274505],
                        [103.682889, 30.27767],
                        [103.684946, 30.279442],
                        [103.69106, 30.280768],
                        [103.692431, 30.284514],
                        [103.686603, 30.294414],
                        [103.679994, 30.29647],
                        [103.674775, 30.300973],
                        [103.669766, 30.303339],
                        [103.664014, 30.308059],
                        [103.661862, 30.308437],
                        [103.657138, 30.306625],
                        [103.652757, 30.307815],
                        [103.651272, 30.309505],
                        [103.649672, 30.31563],
                        [103.646738, 30.316225],
                        [103.641082, 30.312656],
                        [103.637101, 30.312345],
                        [103.62933, 30.314576],
                        [103.625673, 30.31947],
                        [103.622568, 30.320674],
                        [103.614778, 30.32112],
                        [103.608398, 30.32062],
                        [103.599941, 30.320836],
                        [103.594779, 30.31728],
                        [103.589446, 30.314278],
                        [103.584132, 30.312602],
                        [103.576399, 30.312142],
                        [103.568781, 30.312859],
                        [103.564514, 30.315184],
                        [103.559219, 30.316577],
                        [103.557314, 30.31851],
                        [103.556857, 30.322985],
                        [103.560438, 30.332841],
                        [103.558724, 30.337843],
                        [103.556248, 30.338721],
                        [103.550991, 30.338451],
                        [103.542439, 30.333544],
                        [103.53882, 30.332706],
                        [103.53402, 30.333206],
                        [103.529563, 30.335964],
                        [103.526402, 30.335626],
                        [103.523583, 30.332435],
                        [103.523069, 30.329231],
                        [103.520573, 30.328042],
                        [103.514345, 30.328231],
                        [103.506079, 30.332908],
                        [103.503241, 30.33207],
                        [103.497127, 30.332936],
                        [103.488842, 30.333233],
                        [103.487375, 30.331868],
                        [103.490251, 30.327636],
                        [103.489223, 30.326271],
                        [103.482918, 30.327055],
                        [103.47768, 30.333125],
                        [103.473014, 30.332435],
                        [103.469909, 30.329488],
                        [103.465795, 30.327744],
                        [103.460748, 30.32765],
                        [103.456215, 30.326392],
                        [103.449225, 30.325446],
                        [103.442273, 30.322296],
                        [103.436006, 30.323283],
                        [103.433187, 30.325933],
                        [103.43214, 30.329705],
                        [103.429988, 30.333084],
                        [103.42534, 30.33372],
                        [103.418312, 30.328907],
                        [103.406694, 30.323945],
                        [103.405036, 30.32116],
                        [103.406294, 30.317997],
                        [103.40376, 30.314643],
                        [103.400103, 30.312331],
                        [103.395304, 30.311128],
                        [103.386504, 30.310695],
                        [103.382619, 30.312385],
                        [103.379476, 30.312737],
                        [103.3742, 30.310831],
                        [103.371648, 30.309235],
                        [103.368924, 30.305895],
                        [103.368695, 30.301311],
                        [103.361267, 30.300391],
                        [103.356163, 30.297957],
                        [103.347306, 30.291912],
                        [103.338297, 30.292494],
                        [103.336888, 30.291398],
                        [103.33763, 30.288978],
                        [103.340811, 30.287044],
                        [103.34123, 30.283554],
                        [103.338088, 30.278347],
                        [103.33424, 30.276047],
                        [103.33325, 30.277062],
                        [103.333288, 30.283121],
                        [103.33184, 30.288301],
                        [103.330202, 30.289316],
                        [103.327878, 30.2873],
                        [103.327669, 30.275506],
                        [103.326221, 30.27322],
                        [103.315632, 30.268905],
                        [103.308603, 30.261668],
                        [103.301937, 30.263021],
                        [103.295213, 30.263183],
                        [103.287271, 30.262196],
                        [103.282338, 30.263562],
                        [103.27971, 30.262899],
                        [103.272377, 30.258624],
                        [103.268453, 30.257461],
                        [103.253063, 30.249965],
                        [103.245826, 30.245555],
                        [103.242607, 30.243065],
                        [103.238512, 30.233958],
                        [103.235674, 30.223998],
                        [103.233369, 30.218422],
                        [103.233369, 30.213455],
                        [103.228417, 30.208826],
                        [103.223427, 30.206823],
                        [103.218779, 30.207811],
                        [103.215998, 30.209259],
                        [103.214513, 30.213455],
                        [103.215637, 30.218869],
                        [103.212627, 30.224147],
                        [103.212303, 30.230643],
                        [103.211656, 30.232375],
                        [103.208151, 30.235163],
                        [103.206989, 30.237693],
                        [103.204094, 30.240061],
                        [103.201847, 30.239493],
                        [103.197142, 30.236299],
                        [103.194533, 30.238004],
                        [103.188209, 30.24431],
                        [103.183676, 30.248125],
                        [103.179505, 30.247043],
                        [103.175391, 30.238816],
                        [103.171391, 30.233485],
                        [103.167715, 30.229642],
                        [103.161487, 30.220818],
                        [103.156402, 30.212129],
                        [103.153678, 30.209747],
                        [103.147183, 30.206999],
                        [103.141183, 30.206701],
                        [103.135564, 30.207026],
                        [103.131641, 30.205997],
                        [103.129279, 30.207243],
                        [103.12627, 30.21045],
                        [103.121699, 30.21198],
                        [103.105566, 30.215066],
                        [103.094538, 30.216622],
                        [103.084596, 30.218341],
                        [103.076748, 30.220263],
                        [103.07692, 30.224025],
                        [103.078253, 30.226678],
                        [103.077891, 30.233728],
                        [103.072101, 30.240738],
                        [103.072863, 30.247598],
                        [103.071568, 30.260924],
                        [103.06532, 30.262033],
                        [103.06294, 30.264265],
                        [103.061416, 30.270488],
                        [103.062692, 30.276642],
                        [103.067149, 30.288518],
                        [103.068596, 30.294265],
                        [103.066977, 30.296943],
                        [103.063816, 30.299878],
                        [103.062121, 30.302555],
                        [103.062216, 30.305814],
                        [103.063816, 30.309843],
                        [103.065816, 30.312494],
                        [103.071815, 30.314238],
                        [103.073263, 30.315752],
                        [103.079091, 30.324581],
                        [103.082196, 30.322918],
                        [103.088272, 30.324446],
                        [103.091129, 30.326501],
                        [103.095643, 30.331313],
                        [103.102461, 30.337613],
                        [103.10728, 30.343628],
                        [103.118213, 30.355265],
                        [103.127984, 30.367158],
                        [103.128689, 30.370631],
                        [103.126441, 30.374644],
                        [103.123279, 30.376779],
                        [103.117394, 30.378374],
                        [103.116308, 30.379995],
                        [103.11888, 30.385319],
                        [103.121222, 30.395276],
                        [103.120956, 30.39741],
                        [103.118061, 30.40203],
                        [103.118346, 30.410932],
                        [103.116042, 30.413917],
                        [103.120403, 30.418807],
                        [103.122194, 30.425992],
                        [103.118499, 30.43265],
                        [103.118346, 30.4345],
                        [103.120708, 30.439578],
                        [103.124156, 30.441374],
                        [103.130631, 30.43689],
                        [103.139126, 30.436256],
                        [103.141393, 30.439834],
                        [103.139698, 30.44294],
                        [103.13145, 30.447207],
                        [103.125984, 30.451122],
                        [103.125508, 30.452756],
                        [103.126917, 30.455011],
                        [103.131184, 30.457725],
                        [103.133755, 30.461073],
                        [103.139088, 30.466716],
                        [103.141755, 30.470887],
                        [103.146554, 30.4746],
                        [103.155468, 30.477353],
                        [103.15764, 30.475491],
                        [103.158459, 30.47194],
                        [103.162268, 30.472575],
                        [103.162344, 30.475383],
                        [103.16543, 30.47869],
                        [103.166191, 30.48278],
                        [103.169125, 30.484764],
                        [103.170096, 30.488381],
                        [103.175867, 30.495912],
                        [103.178191, 30.502025],
                        [103.183353, 30.506856],
                        [103.1856, 30.509973],
                        [103.185886, 30.51193],
                        [103.183333, 30.516882],
                        [103.18261, 30.51985],
                        [103.180076, 30.520606],
                        [103.180857, 30.525193],
                        [103.185676, 30.525935],
                        [103.190895, 30.528229],
                        [103.194533, 30.525355],
                        [103.196171, 30.522077],
                        [103.199561, 30.51927],
                        [103.201161, 30.519027],
                        [103.208646, 30.520673],
                        [103.211465, 30.51896],
                        [103.21137, 30.512254],
                        [103.212437, 30.509447],
                        [103.216989, 30.505615],
                        [103.224855, 30.504063],
                        [103.22855, 30.504589],
                        [103.234436, 30.507828],
                        [103.239159, 30.507504],
                        [103.24373, 30.503186],
                        [103.246454, 30.501566],
                        [103.251425, 30.500716],
                        [103.254206, 30.500946],
                        [103.25672, 30.502767],
                        [103.257254, 30.505035],
                        [103.256568, 30.510095],
                        [103.26392, 30.514102],
                        [103.263729, 30.516045],
                        [103.266244, 30.518272],
                        [103.271558, 30.520377],
                        [103.275138, 30.520795],
                        [103.285462, 30.518191],
                        [103.289176, 30.516207],
                        [103.296985, 30.509717],
                        [103.299594, 30.509015],
                        [103.301632, 30.510176],
                        [103.303804, 30.515398],
                        [103.304756, 30.520174],
                        [103.303594, 30.526799],
                        [103.297537, 30.531696],
                        [103.296223, 30.534543],
                        [103.297232, 30.538752],
                        [103.299423, 30.540303],
                        [103.305384, 30.541989],
                        [103.312127, 30.543203],
                        [103.321307, 30.542232],
                        [103.330278, 30.540357],
                        [103.335078, 30.541099],
                        [103.338335, 30.543311],
                        [103.341649, 30.548612],
                        [103.34582, 30.552753],
                        [103.349439, 30.553468],
                        [103.352658, 30.552402],
                        [103.368962, 30.540896],
                        [103.3726, 30.539318],
                        [103.374543, 30.540249],
                        [103.379571, 30.545456],
                        [103.383533, 30.546508],
                        [103.390028, 30.545577],
                        [103.395627, 30.542637],
                        [103.399722, 30.544458],
                        [103.40317, 30.543149],
                        [103.40797, 30.536539],
                        [103.413341, 30.535298],
                        [103.427569, 30.529079],
                        [103.431607, 30.525234],
                        [103.438978, 30.516747],
                        [103.447853, 30.509582],
                        [103.449149, 30.507895],
                        [103.450444, 30.502133],
                        [103.453072, 30.496884],
                        [103.452177, 30.49023],
                        [103.453948, 30.488367],
                        [103.456901, 30.488151],
                        [103.459453, 30.483171],
                        [103.461929, 30.48228],
                        [103.472576, 30.481619],
                        [103.474995, 30.480093],
                        [103.476004, 30.476354],
                        [103.478138, 30.47603],
                        [103.480233, 30.478379],
                        [103.481471, 30.481511],
                        [103.480899, 30.484116],
                        [103.482042, 30.4861],
                        [103.487451, 30.487396],
                        [103.497737, 30.485533],
                        [103.502251, 30.483684],
                        [103.509926, 30.478258],
                        [103.514212, 30.478015],
                        [103.516212, 30.476921],
                        [103.515907, 30.474411],
                        [103.52065, 30.468066],
                        [103.52284, 30.467297],
                        [103.522764, 30.465245],
                        [103.525449, 30.463287],
                        [103.525221, 30.461586],
                        [103.529697, 30.458332],
                        [103.528554, 30.456942],
                        [103.530363, 30.454079],
                        [103.529544, 30.451906],
                        [103.531716, 30.450029],
                        [103.533773, 30.450434],
                        [103.536439, 30.448611],
                        [103.535716, 30.447625],
                        [103.53922, 30.446235],
                        [103.540515, 30.444776],
                        [103.544706, 30.445208],
                        [103.54882, 30.443048],
                        [103.554191, 30.442062],
                        [103.555676, 30.439375],
                        [103.552838, 30.433676],
                        [103.555353, 30.429679],
                        [103.556991, 30.429625],
                        [103.559924, 30.433042],
                        [103.562552, 30.434703],
                        [103.566609, 30.433906],
                        [103.570171, 30.429936],
                        [103.575618, 30.427397],
                        [103.578551, 30.426924],
                        [103.583389, 30.428788],
                        [103.585903, 30.427181],
                        [103.590265, 30.426735],
                        [103.599141, 30.429652],
                        [103.601217, 30.429679],
                        [103.606855, 30.427491],
                        [103.617197, 30.428193],
                        [103.622759, 30.427532],
                        [103.625482, 30.427964],
                        [103.628663, 30.433082],
                        [103.628587, 30.441873],
                        [103.627901, 30.443845],
                        [103.622225, 30.443939],
                        [103.619407, 30.44853],
                        [103.618854, 30.450609],
                        [103.625425, 30.454984],
                        [103.627558, 30.460978],
                        [103.628701, 30.461896],
                        [103.632358, 30.458508],
                        [103.635939, 30.459115],
                        [103.638567, 30.460735],
                        [103.641463, 30.46376],
                        [103.648929, 30.47001],
                        [103.6559, 30.470901],
                        [103.659785, 30.468417],
                        [103.662395, 30.464894],
                        [103.668395, 30.461478],
                        [103.672147, 30.462599],
                        [103.67447, 30.464205],
                        [103.679651, 30.45948],
                        [103.681651, 30.456415],
                        [103.686375, 30.454498],
                        [103.691593, 30.455295],
                        [103.698622, 30.452014],
                        [103.700031, 30.450002],
                        [103.697212, 30.446694],
                        [103.699098, 30.443156],
                        [103.707783, 30.434527],
                        [103.705497, 30.432366],
                        [103.704507, 30.427505],
                        [103.704926, 30.425641],
                        [103.722201, 30.40996],
                        [103.730449, 30.396762],
                        [103.739191, 30.384548],
                        [103.746771, 30.376671],
                        [103.747438, 30.375509],
                        [103.748143, 30.365185],
                        [103.750086, 30.360401],
                        [103.755038, 30.3554],
                        [103.755285, 30.352968],
                        [103.751228, 30.348413],
                        [103.744543, 30.346101],
                        [103.739858, 30.343736],
                        [103.736162, 30.341168],
                        [103.733591, 30.336802],
                        [103.733839, 30.334017],
                        [103.73662, 30.332233],
                        [103.739648, 30.331489],
                        [103.745114, 30.331773],
                        [103.747743, 30.336247],
                        [103.750105, 30.338856],
                        [103.758047, 30.33449],
                        [103.756371, 30.329732],
                        [103.758809, 30.328285],
                        [103.762847, 30.329029],
                        [103.766866, 30.328069],
                        [103.766694, 30.324865],
                        [103.768313, 30.32043],
                        [103.766847, 30.31797],
                        [103.765037, 30.317659],
                        [103.761875, 30.319524],
                        [103.754371, 30.319173],
                        [103.751343, 30.316807],
                        [103.751381, 30.307896],
                        [103.747076, 30.30818],
                        [103.742962, 30.306558],
                        [103.739896, 30.309559],
                        [103.734163, 30.310181],
                        [103.728011, 30.308207],
                        [103.727953, 30.30461],
                        [103.733306, 30.298782],
                        [103.73782, 30.292548],
                        [103.738239, 30.290817],
                        [103.736924, 30.286354],
                        [103.73342, 30.285894],
                        [103.728677, 30.287476],
                        [103.725763, 30.28726],
                        [103.721744, 30.282986],
                        [103.717478, 30.282743],
                        [103.712926, 30.277102],
                        [103.709002, 30.270556],
                        [103.705307, 30.268973],
                        [103.697384, 30.269676],
                        [103.696888, 30.270596],
                        [103.699802, 30.272977],
                        [103.696945, 30.273247],
                        [103.693079, 30.271448],
                        [103.691441, 30.267877],
                        [103.683479, 30.271421]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510184,
            "name": "崇州市",
            "center": [103.671049, 30.631478],
            "centroid": [103.523124, 30.713564],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 18,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [103.43294, 30.878301],
                        [103.431302, 30.874698],
                        [103.43374, 30.873703],
                        [103.436921, 30.87451],
                        [103.441492, 30.874403],
                        [103.455815, 30.869281],
                        [103.4625, 30.867493],
                        [103.467548, 30.868313],
                        [103.470576, 30.867936],
                        [103.475376, 30.862343],
                        [103.477242, 30.857113],
                        [103.478728, 30.855379],
                        [103.481204, 30.855204],
                        [103.487356, 30.856616],
                        [103.493222, 30.8555],
                        [103.497375, 30.856307],
                        [103.499698, 30.854787],
                        [103.50067, 30.85195],
                        [103.500955, 30.847405],
                        [103.50425, 30.843102],
                        [103.50966, 30.841919],
                        [103.513926, 30.84013],
                        [103.517221, 30.841246],
                        [103.524078, 30.836916],
                        [103.532535, 30.837562],
                        [103.541639, 30.836082],
                        [103.543753, 30.833796],
                        [103.544401, 30.830689],
                        [103.543829, 30.826278],
                        [103.544839, 30.823763],
                        [103.549086, 30.819459],
                        [103.552743, 30.819835],
                        [103.557829, 30.823561],
                        [103.56299, 30.823279],
                        [103.571733, 30.819028],
                        [103.576247, 30.818679],
                        [103.578304, 30.816674],
                        [103.579351, 30.812397],
                        [103.582075, 30.810339],
                        [103.585542, 30.809585],
                        [103.591979, 30.810904],
                        [103.595751, 30.808751],
                        [103.599027, 30.799711],
                        [103.599693, 30.795648],
                        [103.601941, 30.79359],
                        [103.609369, 30.790858],
                        [103.610302, 30.789257],
                        [103.610683, 30.78479],
                        [103.609826, 30.782112],
                        [103.607579, 30.780444],
                        [103.605845, 30.775586],
                        [103.603903, 30.772289],
                        [103.606969, 30.769638],
                        [103.608626, 30.766314],
                        [103.610816, 30.764268],
                        [103.611312, 30.761899],
                        [103.655824, 30.770297],
                        [103.664338, 30.773352],
                        [103.675004, 30.774509],
                        [103.681384, 30.774281],
                        [103.699402, 30.769423],
                        [103.70424, 30.766718],
                        [103.709497, 30.761523],
                        [103.712468, 30.756623],
                        [103.715783, 30.749369],
                        [103.716583, 30.748776],
                        [103.730029, 30.749544],
                        [103.731953, 30.745815],
                        [103.731191, 30.742773],
                        [103.732029, 30.740296],
                        [103.734924, 30.737886],
                        [103.73561, 30.731653],
                        [103.738791, 30.730616],
                        [103.744848, 30.726254],
                        [103.744905, 30.723709],
                        [103.746867, 30.722067],
                        [103.750143, 30.721299],
                        [103.751647, 30.717018],
                        [103.753114, 30.716237],
                        [103.752485, 30.714042],
                        [103.75279, 30.702999],
                        [103.75479, 30.693693],
                        [103.759361, 30.685841],
                        [103.762771, 30.679106],
                        [103.764999, 30.676075],
                        [103.765475, 30.672492],
                        [103.76338, 30.670862],
                        [103.761856, 30.667211],
                        [103.764523, 30.666389],
                        [103.763761, 30.661054],
                        [103.768047, 30.65646],
                        [103.768656, 30.65231],
                        [103.771304, 30.650882],
                        [103.770961, 30.64913],
                        [103.77277, 30.645788],
                        [103.777646, 30.643215],
                        [103.777608, 30.641517],
                        [103.780294, 30.639617],
                        [103.784541, 30.632919],
                        [103.786465, 30.632811],
                        [103.787646, 30.631019],
                        [103.788484, 30.626585],
                        [103.787741, 30.625021],
                        [103.792388, 30.621679],
                        [103.797817, 30.614306],
                        [103.798407, 30.610424],
                        [103.798255, 30.605881],
                        [103.801454, 30.602079],
                        [103.804978, 30.593694],
                        [103.811549, 30.586817],
                        [103.816501, 30.579294],
                        [103.820882, 30.573684],
                        [103.820653, 30.571243],
                        [103.821663, 30.56071],
                        [103.820825, 30.555626],
                        [103.81492, 30.543203],
                        [103.814292, 30.536728],
                        [103.815854, 30.531197],
                        [103.82033, 30.526273],
                        [103.818787, 30.526475],
                        [103.815625, 30.522603],
                        [103.813301, 30.521335],
                        [103.806845, 30.520471],
                        [103.798845, 30.521955],
                        [103.794636, 30.519918],
                        [103.79355, 30.517354],
                        [103.788446, 30.512956],
                        [103.78816, 30.509434],
                        [103.791303, 30.506897],
                        [103.792522, 30.503941],
                        [103.797969, 30.501715],
                        [103.796331, 30.49992],
                        [103.78715, 30.499826],
                        [103.777398, 30.50104],
                        [103.764809, 30.501647],
                        [103.761742, 30.510837],
                        [103.758695, 30.518852],
                        [103.753076, 30.528445],
                        [103.749533, 30.536485],
                        [103.747476, 30.538832],
                        [103.741362, 30.542704],
                        [103.727572, 30.55367],
                        [103.723554, 30.55715],
                        [103.71984, 30.561439],
                        [103.716106, 30.561628],
                        [103.710507, 30.556759],
                        [103.708545, 30.556786],
                        [103.703021, 30.559537],
                        [103.698222, 30.557555],
                        [103.697326, 30.551445],
                        [103.690222, 30.550797],
                        [103.687251, 30.549111],
                        [103.686432, 30.546899],
                        [103.684165, 30.54586],
                        [103.682222, 30.548032],
                        [103.678242, 30.548599],
                        [103.67428, 30.546791],
                        [103.669994, 30.541665],
                        [103.665595, 30.538333],
                        [103.658319, 30.536202],
                        [103.652338, 30.5263],
                        [103.647596, 30.520255],
                        [103.640586, 30.513117],
                        [103.632111, 30.509758],
                        [103.628758, 30.510554],
                        [103.630625, 30.516018],
                        [103.629749, 30.521078],
                        [103.632015, 30.523952],
                        [103.63472, 30.525315],
                        [103.633234, 30.526623],
                        [103.628378, 30.527406],
                        [103.626549, 30.532829],
                        [103.629825, 30.538549],
                        [103.629387, 30.540289],
                        [103.62533, 30.54435],
                        [103.623863, 30.54439],
                        [103.614473, 30.542232],
                        [103.602055, 30.531966],
                        [103.596055, 30.53314],
                        [103.584704, 30.533342],
                        [103.577123, 30.535905],
                        [103.574247, 30.535986],
                        [103.567009, 30.533301],
                        [103.563866, 30.53434],
                        [103.559867, 30.539831],
                        [103.55901, 30.544673],
                        [103.565904, 30.552591],
                        [103.565676, 30.554506],
                        [103.561009, 30.562288],
                        [103.558286, 30.569018],
                        [103.557619, 30.573954],
                        [103.558876, 30.579469],
                        [103.561162, 30.586817],
                        [103.563295, 30.589649],
                        [103.567428, 30.591402],
                        [103.569047, 30.593653],
                        [103.569676, 30.596875],
                        [103.568857, 30.598008],
                        [103.565009, 30.598089],
                        [103.563581, 30.600017],
                        [103.565847, 30.60394],
                        [103.564152, 30.60611],
                        [103.564724, 30.613079],
                        [103.564019, 30.618889],
                        [103.565009, 30.624118],
                        [103.560667, 30.631288],
                        [103.557467, 30.635304],
                        [103.557695, 30.640829],
                        [103.553829, 30.646152],
                        [103.553467, 30.648066],
                        [103.553124, 30.664032],
                        [103.55461, 30.672573],
                        [103.550496, 30.677261],
                        [103.546325, 30.681221],
                        [103.543963, 30.685383],
                        [103.536611, 30.689761],
                        [103.530211, 30.694555],
                        [103.521735, 30.702474],
                        [103.516669, 30.701868],
                        [103.512288, 30.699336],
                        [103.508879, 30.699781],
                        [103.506365, 30.70646],
                        [103.504555, 30.709261],
                        [103.49926, 30.712938],
                        [103.496099, 30.713503],
                        [103.489699, 30.713086],
                        [103.484823, 30.717354],
                        [103.474576, 30.72037],
                        [103.470595, 30.723548],
                        [103.467148, 30.721178],
                        [103.464843, 30.718539],
                        [103.462272, 30.717246],
                        [103.455548, 30.717179],
                        [103.452615, 30.717933],
                        [103.448044, 30.722942],
                        [103.442444, 30.722107],
                        [103.437778, 30.718849],
                        [103.433378, 30.720693],
                        [103.419379, 30.733013],
                        [103.416064, 30.735046],
                        [103.413569, 30.735571],
                        [103.399989, 30.730212],
                        [103.391647, 30.725621],
                        [103.385247, 30.724813],
                        [103.377571, 30.727358],
                        [103.374181, 30.729337],
                        [103.36921, 30.735072],
                        [103.366143, 30.736823],
                        [103.36102, 30.736769],
                        [103.359058, 30.735557],
                        [103.349382, 30.726752],
                        [103.341687, 30.721434],
                        [103.340887, 30.719791],
                        [103.34104, 30.712399],
                        [103.337992, 30.70914],
                        [103.334735, 30.709167],
                        [103.331269, 30.710635],
                        [103.324298, 30.717799],
                        [103.320641, 30.720707],
                        [103.319746, 30.72235],
                        [103.318869, 30.729499],
                        [103.317403, 30.73137],
                        [103.313384, 30.730589],
                        [103.308546, 30.726429],
                        [103.30268, 30.723534],
                        [103.295537, 30.714998],
                        [103.292795, 30.714553],
                        [103.291385, 30.715779],
                        [103.283747, 30.717866],
                        [103.2763, 30.716048],
                        [103.273462, 30.716115],
                        [103.271234, 30.717314],
                        [103.26851, 30.726847],
                        [103.265139, 30.732945],
                        [103.263253, 30.733915],
                        [103.259158, 30.740605],
                        [103.257653, 30.741561],
                        [103.252911, 30.7407],
                        [103.249654, 30.742046],
                        [103.248244, 30.743971],
                        [103.247045, 30.74957],
                        [103.242721, 30.755008],
                        [103.240054, 30.756449],
                        [103.233845, 30.757135],
                        [103.229883, 30.755695],
                        [103.222703, 30.751293],
                        [103.208951, 30.737913],
                        [103.204399, 30.734992],
                        [103.200514, 30.733497],
                        [103.197885, 30.733686],
                        [103.193638, 30.73763],
                        [103.187352, 30.739528],
                        [103.174229, 30.741534],
                        [103.17122, 30.742369],
                        [103.168953, 30.744375],
                        [103.165125, 30.750499],
                        [103.158897, 30.75416],
                        [103.150745, 30.762344],
                        [103.148211, 30.763784],
                        [103.141164, 30.763111],
                        [103.138079, 30.763824],
                        [103.135812, 30.765426],
                        [103.130365, 30.773473],
                        [103.128251, 30.775142],
                        [103.124441, 30.776555],
                        [103.122346, 30.779354],
                        [103.121318, 30.782758],
                        [103.121203, 30.790132],
                        [103.12027, 30.79402],
                        [103.123908, 30.792782],
                        [103.128746, 30.794948],
                        [103.133965, 30.802213],
                        [103.138536, 30.814294],
                        [103.140326, 30.816419],
                        [103.145335, 30.818006],
                        [103.149564, 30.821678],
                        [103.156954, 30.826359],
                        [103.159049, 30.829681],
                        [103.163887, 30.839579],
                        [103.165696, 30.842161],
                        [103.170896, 30.845348],
                        [103.175581, 30.846935],
                        [103.179296, 30.847015],
                        [103.184019, 30.845227],
                        [103.193676, 30.846679],
                        [103.199142, 30.845738],
                        [103.208285, 30.839525],
                        [103.214608, 30.837642],
                        [103.222341, 30.838355],
                        [103.228684, 30.836553],
                        [103.232626, 30.83658],
                        [103.242797, 30.839054],
                        [103.248054, 30.838248],
                        [103.252892, 30.839902],
                        [103.255768, 30.842699],
                        [103.258282, 30.842403],
                        [103.263691, 30.833473],
                        [103.269177, 30.830259],
                        [103.275138, 30.828685],
                        [103.281119, 30.82999],
                        [103.284643, 30.82956],
                        [103.289195, 30.824785],
                        [103.292795, 30.819365],
                        [103.29449, 30.812679],
                        [103.296128, 30.811657],
                        [103.30207, 30.810191],
                        [103.305194, 30.810527],
                        [103.32045, 30.818571],
                        [103.329536, 30.825404],
                        [103.334754, 30.824476],
                        [103.33763, 30.824691],
                        [103.341249, 30.832976],
                        [103.344982, 30.839296],
                        [103.352106, 30.848467],
                        [103.354506, 30.850874],
                        [103.362943, 30.851869],
                        [103.368372, 30.855217],
                        [103.378581, 30.859614],
                        [103.383038, 30.862868],
                        [103.398561, 30.86315],
                        [103.409436, 30.864952],
                        [103.425721, 30.879161],
                        [103.427854, 30.879538],
                        [103.43294, 30.878301]
                    ]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "adcode": 510185,
            "name": "简阳市",
            "center": [104.550339, 30.390666],
            "centroid": [104.529918, 30.387272],
            "childrenNum": 0,
            "level": "district",
            "parent": {
                "adcode": 510100
            },
            "subFeatureIndex": 19,
            "acroutes": [100000, 510000, 510100]
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                [
                    [
                        [104.231471, 30.282174],
                        [104.234918, 30.285948],
                        [104.230137, 30.290411],
                        [104.232004, 30.292656],
                        [104.232347, 30.298174],
                        [104.231261, 30.304178],
                        [104.234709, 30.309411],
                        [104.23229, 30.313765],
                        [104.223909, 30.316847],
                        [104.2197, 30.317767],
                        [104.213072, 30.320484],
                        [104.210424, 30.320309],
                        [104.205434, 30.316618],
                        [104.201586, 30.31655],
                        [104.199168, 30.322377],
                        [104.195015, 30.325541],
                        [104.193473, 30.32938],
                        [104.191682, 30.329988],
                        [104.196044, 30.337086],
                        [104.198349, 30.339749],
                        [104.198291, 30.342857],
                        [104.196311, 30.348872],
                        [104.197777, 30.353508],
                        [104.207053, 30.362415],
                        [104.210424, 30.367631],
                        [104.218195, 30.375306],
                        [104.219262, 30.383792],
                        [104.218976, 30.388372],
                        [104.218005, 30.390588],
                        [104.219528, 30.393817],
                        [104.227109, 30.396167],
                        [104.22829, 30.398545],
                        [104.228747, 30.402773],
                        [104.228328, 30.410041],
                        [104.229147, 30.412634],
                        [104.233509, 30.418023],
                        [104.236785, 30.419469],
                        [104.24547, 30.419617],
                        [104.249794, 30.420833],
                        [104.247946, 30.426006],
                        [104.248841, 30.428585],
                        [104.258079, 30.437782],
                        [104.26046, 30.442724],
                        [104.263602, 30.446356],
                        [104.26844, 30.45416],
                        [104.269107, 30.457441],
                        [104.260364, 30.459007],
                        [104.253755, 30.45709],
                        [104.250365, 30.456969],
                        [104.247394, 30.457981],
                        [104.245813, 30.460344],
                        [104.247851, 30.463976],
                        [104.249851, 30.46569],
                        [104.254612, 30.467283],
                        [104.259412, 30.468134],
                        [104.260155, 30.47082],
                        [104.254898, 30.474816],
                        [104.254212, 30.476773],
                        [104.25526, 30.4795],
                        [104.258536, 30.483252],
                        [104.26465, 30.485992],
                        [104.273659, 30.487085],
                        [104.282916, 30.492929],
                        [104.289392, 30.496425],
                        [104.292401, 30.499272],
                        [104.293582, 30.503928],
                        [104.294877, 30.504927],
                        [104.299391, 30.504063],
                        [104.301239, 30.500622],
                        [104.304991, 30.499056],
                        [104.312743, 30.49297],
                        [104.314705, 30.492079],
                        [104.320609, 30.492902],
                        [104.327504, 30.492997],
                        [104.329904, 30.492011],
                        [104.333313, 30.495682],
                        [104.329561, 30.501296],
                        [104.33257, 30.506195],
                        [104.331827, 30.508516],
                        [104.329713, 30.50915],
                        [104.32518, 30.508853],
                        [104.323371, 30.510095],
                        [104.324494, 30.515209],
                        [104.327237, 30.516639],
                        [104.331504, 30.514912],
                        [104.336818, 30.510365],
                        [104.342722, 30.498921],
                        [104.345103, 30.491485],
                        [104.34436, 30.488097],
                        [104.340284, 30.484615],
                        [104.340037, 30.481781],
                        [104.342303, 30.480863],
                        [104.348798, 30.482159],
                        [104.350969, 30.481281],
                        [104.352912, 30.483805],
                        [104.361083, 30.482766],
                        [104.363083, 30.484102],
                        [104.366645, 30.48969],
                        [104.373349, 30.489798],
                        [104.383463, 30.487693],
                        [104.385044, 30.48807],
                        [104.390091, 30.486302],
                        [104.39251, 30.486815],
                        [104.396872, 30.490648],
                        [104.397348, 30.496681],
                        [104.395558, 30.500703],
                        [104.395767, 30.504306],
                        [104.398319, 30.506033],
                        [104.404205, 30.508287],
                        [104.411271, 30.511863],
                        [104.414776, 30.515533],
                        [104.415766, 30.519081],
                        [104.414642, 30.522333],
                        [104.412014, 30.523669],
                        [104.407614, 30.523345],
                        [104.404186, 30.524748],
                        [104.400967, 30.527635],
                        [104.398967, 30.530468],
                        [104.398567, 30.532735],
                        [104.40211, 30.537254],
                        [104.401862, 30.54292],
                        [104.402605, 30.554641],
                        [104.40331, 30.556583],
                        [104.407519, 30.562369],
                        [104.407366, 30.564015],
                        [104.403043, 30.571081],
                        [104.402148, 30.578174],
                        [104.40251, 30.58284],
                        [104.4051, 30.587451],
                        [104.405443, 30.591429],
                        [104.410357, 30.596215],
                        [104.415861, 30.598291],
                        [104.421137, 30.598493],
                        [104.424013, 30.596794],
                        [104.428889, 30.596606],
                        [104.431365, 30.595648],
                        [104.43487, 30.592386],
                        [104.439517, 30.591523],
                        [104.444603, 30.593734],
                        [104.448374, 30.593815],
                        [104.450507, 30.591078],
                        [104.452926, 30.590175],
                        [104.461688, 30.590215],
                        [104.467859, 30.592184],
                        [104.474849, 30.595527],
                        [104.478125, 30.596107],
                        [104.48481, 30.593033],
                        [104.490543, 30.595311],
                        [104.492676, 30.594112],
                        [104.494581, 30.595325],
                        [104.494619, 30.600219],
                        [104.495362, 30.600623],
                        [104.501171, 30.598008],
                        [104.503533, 30.597981],
                        [104.505266, 30.599342],
                        [104.505361, 30.60243],
                        [104.513094, 30.607539],
                        [104.516104, 30.612526],
                        [104.518713, 30.614063],
                        [104.522732, 30.613793],
                        [104.526484, 30.614818],
                        [104.527322, 30.616139],
                        [104.525703, 30.618673],
                        [104.528122, 30.620358],
                        [104.525151, 30.623458],
                        [104.526922, 30.622865],
                        [104.528484, 30.624307],
                        [104.532789, 30.623808],
                        [104.529646, 30.627231],
                        [104.529608, 30.630143],
                        [104.534312, 30.62866],
                        [104.535398, 30.626531],
                        [104.539093, 30.625156],
                        [104.538731, 30.626948],
                        [104.541131, 30.628121],
                        [104.542064, 30.626652],
                        [104.545245, 30.627245],
                        [104.546807, 30.629994],
                        [104.54435, 30.631571],
                        [104.544769, 30.633148],
                        [104.54795, 30.634833],
                        [104.548255, 30.632932],
                        [104.550026, 30.633471],
                        [104.563111, 30.628202],
                        [104.567015, 30.628741],
                        [104.568292, 30.631571],
                        [104.56873, 30.638552],
                        [104.570425, 30.640344],
                        [104.576577, 30.643578],
                        [104.579034, 30.642608],
                        [104.579167, 30.639374],
                        [104.585091, 30.630722],
                        [104.587643, 30.629954],
                        [104.594976, 30.633593],
                        [104.597452, 30.633579],
                        [104.601147, 30.63021],
                        [104.607509, 30.622164],
                        [104.611547, 30.620587],
                        [104.611699, 30.618161],
                        [104.61328, 30.61994],
                        [104.613566, 30.618012],
                        [104.617546, 30.617055],
                        [104.618899, 30.620304],
                        [104.623832, 30.619926],
                        [104.624346, 30.618632],
                        [104.627622, 30.617635],
                        [104.626232, 30.615492],
                        [104.627946, 30.61351],
                        [104.630403, 30.614413],
                        [104.629984, 30.616489],
                        [104.634079, 30.618161],
                        [104.634898, 30.616557],
                        [104.637393, 30.618322],
                        [104.641659, 30.615613],
                        [104.64244, 30.613901],
                        [104.645278, 30.61467],
                        [104.646059, 30.612836],
                        [104.651278, 30.610936],
                        [104.654782, 30.610491],
                        [104.653716, 30.607997],
                        [104.656001, 30.605679],
                        [104.659049, 30.608631],
                        [104.661887, 30.607701],
                        [104.662077, 30.610397],
                        [104.664325, 30.610841],
                        [104.667391, 30.609992],
                        [104.667087, 30.608078],
                        [104.669144, 30.606204],
                        [104.671905, 30.609237],
                        [104.675124, 30.608523],
                        [104.674229, 30.607175],
                        [104.675772, 30.605207],
                        [104.67701, 30.607094],
                        [104.679143, 30.606878],
                        [104.681333, 30.604951],
                        [104.683314, 30.601594],
                        [104.686133, 30.600718],
                        [104.692285, 30.600043],
                        [104.697714, 30.59697],
                        [104.700456, 30.597037],
                        [104.70158, 30.595851],
                        [104.700799, 30.591887],
                        [104.697447, 30.58768],
                        [104.693847, 30.582166],
                        [104.687143, 30.578808],
                        [104.686495, 30.573387],
                        [104.684533, 30.564824],
                        [104.684381, 30.560387],
                        [104.687638, 30.554628],
                        [104.690666, 30.552497],
                        [104.702513, 30.547803],
                        [104.70577, 30.547182],
                        [104.709884, 30.544957],
                        [104.720132, 30.542056],
                        [104.726074, 30.539966],
                        [104.728722, 30.537133],
                        [104.730226, 30.533517],
                        [104.73114, 30.528107],
                        [104.732607, 30.525625],
                        [104.731998, 30.521901],
                        [104.732036, 30.514413],
                        [104.735407, 30.512915],
                        [104.750549, 30.50915],
                        [104.759425, 30.505143],
                        [104.758491, 30.502295],
                        [104.760682, 30.500662],
                        [104.761234, 30.496884],
                        [104.765539, 30.498085],
                        [104.765748, 30.496371],
                        [104.763406, 30.493591],
                        [104.767634, 30.492578],
                        [104.769729, 30.491202],
                        [104.763748, 30.487288],
                        [104.763253, 30.485857],
                        [104.766586, 30.483967],
                        [104.777195, 30.484413],
                        [104.778376, 30.486545],
                        [104.779957, 30.486464],
                        [104.782909, 30.489272],
                        [104.785442, 30.49023],
                        [104.785804, 30.488826],
                        [104.792985, 30.489839],
                        [104.794775, 30.488624],
                        [104.80068, 30.491107],
                        [104.802604, 30.49023],
                        [104.803956, 30.491647],
                        [104.807137, 30.491296],
                        [104.808565, 30.493725],
                        [104.806718, 30.498908],
                        [104.806584, 30.505008],
                        [104.811727, 30.50884],
                        [104.817136, 30.509528],
                        [104.819669, 30.508705],
                        [104.826755, 30.510297],
                        [104.836049, 30.510972],
                        [104.839859, 30.510378],
                        [104.845306, 30.508584],
                        [104.851325, 30.504778],
                        [104.861439, 30.509123],
                        [104.868581, 30.510014],
                        [104.872752, 30.508853],
                        [104.875686, 30.509015],
                        [104.876771, 30.505318],
                        [104.876257, 30.501216],
                        [104.872695, 30.495655],
                        [104.872181, 30.490648],
                        [104.875324, 30.484696],
                        [104.873743, 30.479675],
                        [104.87359, 30.472116],
                        [104.875647, 30.463368],
                        [104.8754, 30.458562],
                        [104.8742, 30.450677],
                        [104.875057, 30.437093],
                        [104.8738, 30.433447],
                        [104.870943, 30.429355],
                        [104.870143, 30.425762],
                        [104.8726, 30.420684],
                        [104.874847, 30.418753],
                        [104.879247, 30.418321],
                        [104.879857, 30.408393],
                        [104.878942, 30.401206],
                        [104.87599, 30.39764],
                        [104.874124, 30.393898],
                        [104.874638, 30.387561],
                        [104.876581, 30.386008],
                        [104.879571, 30.386589],
                        [104.879304, 30.389223],
                        [104.881685, 30.393574],
                        [104.889323, 30.388196],
                        [104.895894, 30.382319],
                        [104.89738, 30.377103],
                        [104.89557, 30.376347],
                        [104.89237, 30.378211],
                        [104.890523, 30.377225],
                        [104.889551, 30.373888],
                        [104.884523, 30.371955],
                        [104.882847, 30.368063],
                        [104.882771, 30.363644],
                        [104.88098, 30.36086],
                        [104.879571, 30.36082],
                        [104.876162, 30.363469],
                        [104.867191, 30.365698],
                        [104.862943, 30.36555],
                        [104.860048, 30.362874],
                        [104.85841, 30.358076],
                        [104.855629, 30.352981],
                        [104.855439, 30.347183],
                        [104.854106, 30.345331],
                        [104.84963, 30.345277],
                        [104.848468, 30.351048],
                        [104.846735, 30.354265],
                        [104.841859, 30.359171],
                        [104.837059, 30.362023],
                        [104.834145, 30.361577],
                        [104.83325, 30.36005],
                        [104.83504, 30.3554],
                        [104.839287, 30.351481],
                        [104.842582, 30.345007],
                        [104.847382, 30.343114],
                        [104.85043, 30.33891],
                        [104.849915, 30.325514],
                        [104.851534, 30.318443],
                        [104.850639, 30.31175],
                        [104.848754, 30.306828],
                        [104.846106, 30.305584],
                        [104.839383, 30.305097],
                        [104.832316, 30.301433],
                        [104.829116, 30.30338],
                        [104.826221, 30.303623],
                        [104.82226, 30.300351],
                        [104.821822, 30.298836],
                        [104.823612, 30.29551],
                        [104.822831, 30.293535],
                        [104.819669, 30.294468],
                        [104.814165, 30.293954],
                        [104.81327, 30.292386],
                        [104.809765, 30.292724],
                        [104.809213, 30.29578],
                        [104.807251, 30.296862],
                        [104.803156, 30.293305],
                        [104.80327, 30.289005],
                        [104.80087, 30.285502],
                        [104.798394, 30.279916],
                        [104.795175, 30.279442],
                        [104.79268, 30.281606],
                        [104.791023, 30.285109],
                        [104.789233, 30.292156],
                        [104.786204, 30.296037],
                        [104.779519, 30.297065],
                        [104.774872, 30.301554],
                        [104.772186, 30.302082],
                        [104.766396, 30.300648],
                        [104.759063, 30.30219],
                        [104.753901, 30.301581],
                        [104.750968, 30.29889],
                        [104.749273, 30.293062],
                        [104.745559, 30.290952],
                        [104.73855, 30.290289],
                        [104.731998, 30.293075],
                        [104.727788, 30.294306],
                        [104.726988, 30.297362],
                        [104.727198, 30.30388],
                        [104.72535, 30.307328],
                        [104.722322, 30.308275],
                        [104.719541, 30.305571],
                        [104.717179, 30.304854],
                        [104.714418, 30.306274],
                        [104.711465, 30.306084],
                        [104.703961, 30.301649],
                        [104.700209, 30.293657],
                        [104.697904, 30.287219],
                        [104.692019, 30.275385],
                        [104.688743, 30.274654],
                        [104.685238, 30.276277],
                        [104.682133, 30.279199],
                        [104.680248, 30.279442],
                        [104.677162, 30.277197],
                        [104.67181, 30.275966],
                        [104.668229, 30.275926],
                        [104.660344, 30.277576],
                        [104.657639, 30.279199],
                        [104.652211, 30.28538],
                        [104.64804, 30.286029],
                        [104.643602, 30.283],
                        [104.641259, 30.279578],
                        [104.637583, 30.271827],
                        [104.638193, 30.268175],
                        [104.643259, 30.26298],
                        [104.650745, 30.25466],
                        [104.652783, 30.251278],
                        [104.653963, 30.243227],
                        [104.653125, 30.240223],
                        [104.645012, 30.238965],
                        [104.635926, 30.23906],
                        [104.628936, 30.23956],
                        [104.619527, 30.23933],
                        [104.616403, 30.240183],
                        [104.609223, 30.245162],
                        [104.606404, 30.24573],
                        [104.599623, 30.244459],
                        [104.596652, 30.24251],
                        [104.595585, 30.239371],
                        [104.597052, 30.237247],
                        [104.601871, 30.235582],
                        [104.602195, 30.234513],
                        [104.601014, 30.228329],
                        [104.601052, 30.224418],
                        [104.600119, 30.220425],
                        [104.596728, 30.217529],
                        [104.59229, 30.215946],
                        [104.584748, 30.210857],
                        [104.579243, 30.208204],
                        [104.57311, 30.20616],
                        [104.572234, 30.205158],
                        [104.569301, 30.197009],
                        [104.563606, 30.193395],
                        [104.553264, 30.189875],
                        [104.547055, 30.187438],
                        [104.54155, 30.184229],
                        [104.537703, 30.186138],
                        [104.535474, 30.192257],
                        [104.531627, 30.194505],
                        [104.528713, 30.193774],
                        [104.523989, 30.185867],
                        [104.520846, 30.184486],
                        [104.514885, 30.182997],
                        [104.508428, 30.182185],
                        [104.505876, 30.183119],
                        [104.501438, 30.19131],
                        [104.488962, 30.186057],
                        [104.485648, 30.183742],
                        [104.484353, 30.181508],
                        [104.485915, 30.177257],
                        [104.486029, 30.174616],
                        [104.483744, 30.170703],
                        [104.484791, 30.16595],
                        [104.488943, 30.162538],
                        [104.488467, 30.159247],
                        [104.485229, 30.15601],
                        [104.482696, 30.155509],
                        [104.480029, 30.156552],
                        [104.477858, 30.159558],
                        [104.475592, 30.161007],
                        [104.47243, 30.159965],
                        [104.467287, 30.155983],
                        [104.465059, 30.152787],
                        [104.466163, 30.148751],
                        [104.465611, 30.14653],
                        [104.457612, 30.147018],
                        [104.455516, 30.14397],
                        [104.456088, 30.139365],
                        [104.455078, 30.1382],
                        [104.449612, 30.137211],
                        [104.449402, 30.132904],
                        [104.454355, 30.126469],
                        [104.457745, 30.12063],
                        [104.453117, 30.117162],
                        [104.448507, 30.116078],
                        [104.44346, 30.113762],
                        [104.441708, 30.110781],
                        [104.436165, 30.110212],
                        [104.437098, 30.107529],
                        [104.447288, 30.10589],
                        [104.45064, 30.10425],
                        [104.450183, 30.10112],
                        [104.444355, 30.099602],
                        [104.438184, 30.101567],
                        [104.436755, 30.099467],
                        [104.43687, 30.097285],
                        [104.434851, 30.094575],
                        [104.43586, 30.091255],
                        [104.432299, 30.089615],
                        [104.428432, 30.089764],
                        [104.422756, 30.093044],
                        [104.415576, 30.099873],
                        [104.415328, 30.101323],
                        [104.420299, 30.104453],
                        [104.417766, 30.108816],
                        [104.417614, 30.112298],
                        [104.416014, 30.115767],
                        [104.411538, 30.120143],
                        [104.410623, 30.124898],
                        [104.409709, 30.125616],
                        [104.398795, 30.124749],
                        [104.394377, 30.126442],
                        [104.388015, 30.133337],
                        [104.391139, 30.138417],
                        [104.388091, 30.156647],
                        [104.386358, 30.16182],
                        [104.382034, 30.165544],
                        [104.370702, 30.167507],
                        [104.366264, 30.170825],
                        [104.362016, 30.171881],
                        [104.358188, 30.173668],
                        [104.353693, 30.179233],
                        [104.354188, 30.182131],
                        [104.362397, 30.180804],
                        [104.365121, 30.181169],
                        [104.366302, 30.183742],
                        [104.364531, 30.186003],
                        [104.358245, 30.18978],
                        [104.352493, 30.193923],
                        [104.336342, 30.197144],
                        [104.333694, 30.200041],
                        [104.331275, 30.200691],
                        [104.32998, 30.203358],
                        [104.32718, 30.204265],
                        [104.322114, 30.203101],
                        [104.315409, 30.200759],
                        [104.31019, 30.201205],
                        [104.306991, 30.206349],
                        [104.305353, 30.207405],
                        [104.302077, 30.207134],
                        [104.297086, 30.208434],
                        [104.292344, 30.21106],
                        [104.284858, 30.217989],
                        [104.282992, 30.22048],
                        [104.280249, 30.220683],
                        [104.273983, 30.217719],
                        [104.272554, 30.21784],
                        [104.269812, 30.221562],
                        [104.271031, 30.226502],
                        [104.271107, 30.230589],
                        [104.267488, 30.237192],
                        [104.264536, 30.24159],
                        [104.262879, 30.242307],
                        [104.258441, 30.241265],
                        [104.255831, 30.241563],
                        [104.249489, 30.244648],
                        [104.243965, 30.243971],
                        [104.238766, 30.24937],
                        [104.233071, 30.251332],
                        [104.231052, 30.254227],
                        [104.230975, 30.256148],
                        [104.237013, 30.262669],
                        [104.240213, 30.263278],
                        [104.243375, 30.267431],
                        [104.243032, 30.268878],
                        [104.238766, 30.273301],
                        [104.237927, 30.276088],
                        [104.234766, 30.274411],
                        [104.233071, 30.279835],
                        [104.231871, 30.280457],
                        [104.233204, 30.281065],
                        [104.232728, 30.281863],
                        [104.231471, 30.282174]
                    ]
                ],
                [
                    [
                        [104.231471, 30.282174],
                        [104.232728, 30.281863],
                        [104.233204, 30.281065],
                        [104.231871, 30.280457],
                        [104.231471, 30.282174]
                    ]
                ]
            ]
        }
    }]
}

export const geoCoordMap_beijing = getGeoCoordMap(map_bejing);

export const geoCoordMap_chengdu = getGeoCoordMap(map_chengdu);

export function getGeoCoordMap(map) {
    let obj: { [key: string]: any[] } = {};
    for (const iterator of map.features) {
        obj[iterator.properties.name] = iterator.properties.centroid
    }
    return obj;
}